import Vue from "vue";
import { MLInstaller, MLCreate, MLanguage } from "vue-multilanguage";
Vue.use(MLInstaller);
const ml = new MLCreate({
	initial: "spanish",
	save: true, //process.env.NODE_ENV === 'production',
	languages: [
		new MLanguage("english").create({
			select_profile: "Select Profile",
			sub_stream: "SUB STREAM",
			has_ptz: "PTZ",
			error_get_stream_uri: "Error getting stream URI",
			connection_error: "Connection Error",
			camera_error: "Camera Error",
			select_file: "Select file",
			description_type_field_parking: "Type of the list",
			description_list_name_field: "List Name field",
			description_motive_field: "Motive field",
			description_list_id_field: "List ID",
			description_plate_field: "Plate characters field",
			description_id_field: "Internal id of  the  plate chars",
			excel_format_error: "Excel format error",
			excel_columns_required: "The Excel file must have exactly 2 columns",
			excel_columns_found: "Found {0} columns, but 2 are required",
			excel_validation_failed: "Excel file validation failed",
			validating_file: "Validating file...",
			file_format_valid: "File format is valid",
			title: "Hello {0}!",
			msg: "This is user", //'You have {f} friends and {l} likes'
			profile: "Profile",
			username: "Username",
			first_names: "First Names",
			last_names: "Last Names",
			email: "E-mail",
			password: "Password",
			token: "Token",
			api_key: "API Key",
			client_id: "Client ID",
			api_key_permissions_placeholder: "e.g. events:read,media:photos:read",
			alice_api_key_legend_title: "What is this integration for?",
			alice_api_key_legend_desc:
				"Use this integration to register external clients that connect to Alice Guardian via API Key. Each client has its own key, ID and specific permissions.",
			alice_api_key_legend_fields: "Fields:",
			alice_api_key_legend_client_id:
				"Unique identifier for the client or service (e.g. ag-metrics, my-app).",
			alice_api_key_legend_api_key:
				"Secure key generated for the client. Keep it secret.",
			alice_api_key_legend_permissions:
				"Comma-separated list of allowed actions (e.g. events:read,media:photos:read).",
			alice_api_key_legend_examples_title: "Environment variable examples:",
			details: "Details",
			alice_api_docs_title: "API Usage Documentation",
			alice_api_docs_auth: "Required headers:",
			alice_api_docs_endpoints: "Available endpoints:",
			alice_api_docs_based_on_perms: "(based on selected permissions)",
			alice_api_docs_all: "(select permissions to filter)",
			alice_api_docs_example: "Example curl request:",
			alice_api_docs_jwt_note:
				"Routes marked JWT require session authentication and are not accessible with API Key yet.",
			alice_api_docs_option_a: "Option A — Snapshot by device ID + timestamp",
			alice_api_docs_option_b: "Option B — Evidence by event UUID + timestamp",
			alice_api_docs_step1: "Step 1 — Request evidence (photo/video URLs)",
			alice_api_docs_step1_note:
				"Returns temporary URLs with token for each media file",
			alice_api_docs_step1_response: "Response:",
			alice_api_docs_step2: "Step 2 — Download media using the token",
			alice_api_docs_step2_note:
				"No Authorization header needed — token is self-contained",
			alice_api_key_validation_title: "Please fix the following before saving:",
			val_name_required: "Name is required.",
			val_client_id_required: "Client ID is required.",
			val_client_id_invalid:
				"Client ID can only contain letters, numbers, hyphens and underscores (no spaces).",
			val_api_key_required: "API Key is required.",
			val_api_key_too_short: "API Key must be at least 8 characters.",
			val_permissions_required: "Select at least one permission.",
			val_guardian_cloud_url_required: "Cloud URL is required.",
			val_guardian_cloud_url_invalid:
				"Cloud URL must include the protocol (e.g. http://69.197.150.32:9090).",
			val_guardian_cloud_name_required: "Integration name is required.",
			guardian_cloud_info_title: "Guardian Cloud setup",
			guardian_cloud_info_url_label: "Cloud URL format:",
			guardian_cloud_info_url_example: "http://IP_OR_DOMAIN:PORT",
			guardian_cloud_info_url_note:
				"Must include protocol (http:// or https://) and port.",
			guardian_cloud_test_btn: "Test connection",
			guardian_cloud_test_testing: "Testing…",
			guardian_cloud_test_ok: "Server responding",
			guardian_cloud_test_fail: "No response",
			guardian_cloud_test_not_tested: "Test the connection before saving.",
			guardian_cloud_test_changed: "URL changed — re-test the connection.",
			confirm_psw: "Confirm Password",
			save: "Save",
			create_new: "Create New",
			duplicate: "Duplicate",
			copy: "Copy",
			edit: "Edit",
			close: "Close",
			soon: "Soon",
			dashboard: "Dashboard",
			settings: "Settings",
			history: "History",
			reports: "Reports",
			register_user: "Register User",
			category: "Category",
			new: "New",
			users: "Users",
			id: "ID",
			name: "Name",
			user: "User",
			type_user: "Type of user",
			type_users: "Type users",
			actions: "Actions",
			search: "Search",
			groups: "Groups",
			select_groups: "Select Groups",
			login: "Login",
			psw_req: "Password is required!",
			login_error: "Login Error",
			log_out: "LogOut",
			direction: "Direction",
			host_api: "Host Api Url",
			host_client: "Host Client Url",
			description: "Description",
			register: "Register",
			reset: "Reset",
			delete: "Delete",
			new_device: "New Device",
			cam_options: "Camera Options",
			host: "Host",
			type_cam: "Type of Cameras",
			host_options: "Host Options ",
			options: "Options",
			camera: "Camera",
			cameras: "Cameras",
			cloud: "Cloud",
			cloud_sent: "Sent to cloud",
			cloud_pending: "Pending delivery to cloud",
			date: "Date",
			date_e: "Final Date",
			date_in: "Date and time In",
			date_out: "Date and time Out",
			plates: "Plates",
			user_options: "User Options",
			dc: "Dc",
			excel: "Export to Excel",
			report_config: "Report Settings",
			device_id: "Device ID",
			notification_config: "Notification Settings",
			create_alert: "Create alert",
			success: "Success",
			error: "Error",
			warning: "Warning",
			alert_type: "Alert type",
			alert_mode: "Alert mode",
			manual: "Manual",
			automatic: "Automatic",
			confirm: "Confirm",
			graffics: "Graffics",
			notice: "Notice",
			alice_face: "Alice Face",
			faces: "Faces",
			recognized: "Recognized",
			odt_face: "ODT - Face",
			unknown: "Unknown",
			select: "Select",
			relay: "Relay",
			searching_relays: "Searching Relays",
			searching: "Searching",
			no_relays_found: "No relays found",
			retry_search: "Retry Search",
			help_name_peripheral:
				"Enter a unique name to identify this peripheral device. Minimum 4 characters required.",
			help_type_peripheral:
				"Select the type of peripheral: Siren (alarm), Electronic Lock (door lock), Arduino (microcontroller), IoT Relay (smart relay), or Odroid (single board computer).",
			help_medium:
				"Select the connection medium: USB (direct USB connection), TCP (network connection), GPIO (General Purpose Input/Output pins), or HTTP (web-based connection).",
			help_ip:
				"Enter the IP address of the device. Required for TCP connections. Format: XXX.XXX.XXX.XXX",
			help_serial:
				"Enter the serial number or identifier of the device. This is usually found on the device label or can be obtained from the device scan.",
			help_arduino:
				'Select an Arduino device from the list of detected devices. Click "Get Arduinos" to scan for connected devices.',
			help_relay:
				"Select an IoT Relay device from the list of available relays. The system will search for active relays automatically.",
			help_username:
				"Enter the username for authentication. Required for electronic lock devices.",
			help_password:
				"Enter the password for authentication. Required for electronic lock devices.",
			help_token:
				"Enter the authentication token or API key. Required for some electronic lock devices.",
			help_host:
				"Enter the host address or server URL. Required for electronic lock devices. Format: hostname or IP address.",
			to_train: "To train",
			video_feed: "Video feed",
			detected_faces: "Detected faces",
			host_list: "Host list",
			type: "Type",
			country: "Country",
			licence: "Licence",
			host_configuration: "Host configuration",
			update: "Update",
			alarm_button_save: "Save",
			alarm_button_update: "Update",
			control: "Control",
			device: "Device",
			mixta_feed_title: "Unified access feed",
			mixta_feed_subtitle: "Real time",
			"Real time": "Real time",
			mixta_live: "• LIVE",
			mixta_filter_all: "All",
			mixta_filter_lpr: "LPR",
			mixta_filter_avc: "AVC",
			mixta_filter_smart: "Smart events",
			mixta_filter_alarms: "Alarms",
			mixta_buffer_label: "Max rows (WS)",
			mixta_col_identity: "Identity",
			mixta_col_detail: "Detail",
			mixta_col_source: "Source",
			mixta_col_action: "Action",
			mixta_col_time: "Time",
			mixta_source_lpr: "LPR",
			mixta_source_avc: "AVC",
			mixta_source_smart: "SMART EVENTS",
			mixta_source_alarms: "ALARMS",
			mixta_action_lpr: "Detected",
			mixta_action_avc: "Passed",
			mixta_no_executed_actions: "No executed actions recorded",
			mixta_filter_placeholder: "Filter events…",
			mixta_rows_count: "rows (filtered)",
			unified_access_feed: "Unified access feed",
			multi_face_roster: "People on terminals",
			multi_face_roster_subtitle: "Unified faces by terminal",
			multi_face_roster_refresh: "Refresh terminal people",
			multi_face_roster_group_label: "Group",
			multi_face_roster_search_label: "Search by name or FPID",
			multi_face_roster_loading_people: "Loading terminal people...",
			multi_face_roster_empty_title: "No people to show",
			multi_face_roster_empty_filter:
				"No faces were found with the current filter.",
			multi_face_roster_unnamed_person: "Unnamed person",
			multi_face_roster_system: "System",
			multi_face_roster_terminal: "Terminal",
			multi_face_roster_yes: "Yes",
			multi_face_roster_no: "No",
			multi_face_roster_registered: "Registered",
			multi_face_roster_registered_single: "Registered",
			multi_face_roster_missing_import: "Import pending",
			multi_face_roster_backend_only: "Only in system",
			multi_face_roster_group_person: "By person",
			multi_face_roster_group_terminal: "By terminal",
			multi_face_roster_import_to_list: "Import to list",
			multi_face_roster_clear_selection: "Clear selection",
			multi_face_roster_import_people_title: "Import people",
			multi_face_roster_import_people_subtitle:
				"Select the list and source terminal when needed.",
			multi_face_roster_close_import: "Close import",
			multi_face_roster_face_list_label: "Face list",
			multi_face_roster_no_face_lists: "No face lists available",
			multi_face_roster_source_required:
				"Select the source terminal for people present on more than one terminal.",
			multi_face_roster_source_terminal_label: "Source terminal",
			multi_face_roster_cancel: "Cancel",
			multi_face_roster_import: "Import",
			multi_face_roster_terminal_count: "{0} terminal(s)",
			multi_face_roster_summary_counts: "{0} registered · {1} import pending",
			multi_face_roster_failed_terminals:
				"{0} terminal(s) did not respond. Available data is shown.",
			multi_face_roster_partial_terminals:
				"Warning: the roster may be incomplete on {0}. The terminal reported partial or truncated data; verify before assuming all people are present.",
			multi_face_roster_selected_count: "{0} person(s) selected for import",
			multi_face_roster_ready_count: "{0} person(s) ready to import.",
			multi_face_roster_list_fallback: "List {0}",
			multi_face_roster_registered_subtitle:
				"People present on terminal and system",
			multi_face_roster_missing_import_subtitle:
				"People present on terminal but not in the system",
			multi_face_roster_person_view_subtitle: "Unified view of all terminals",
			multi_face_roster_people_count: "{0} person(s)",
			multi_face_roster_no_terminals: "No facial access terminals were found.",
			multi_face_roster_load_error: "Could not load the unified people roster.",
			multi_face_roster_state_loaded: "Loaded",
			multi_face_roster_state_connected: "Connected",
			multi_face_roster_state_disconnected: "Disconnected",
			multi_face_roster_state_partial: "Incomplete",
			multi_face_roster_state_error: "Error",
			multi_face_roster_state_loading: "Loading",
			multi_face_roster_state_diagnostic: "Diagnostic",
			multi_face_roster_photo_alt: "Face photo for {0}",
			multi_face_roster_select_person: "Select {0} for import",
			multi_face_roster_unselect_person: "Remove {0} from import",
			multi_face_roster_lists_error: "Could not load face lists.",
			multi_face_roster_import_success:
				"{0} person(s) imported and added to the list.",
			multi_face_roster_import_partial_success:
				"{0} person(s) imported. {1} could not be imported because they are already registered or no longer present on the source terminal.",
			multi_face_roster_import_failed_count:
				"{0} person(s) could not be imported because they are already registered or no longer present on the source terminal.",
			multi_face_roster_import_error: "Could not import the selection.",
			multi_face_roster_add_person: "Add person",
			multi_face_roster_add_success:
				"Person added. Terminal synchronization will process the mirror-list membership.",
			multi_face_roster_remove_from_terminal: "Remove from terminal",
			multi_face_roster_move_target_label: "Move to terminals",
			multi_face_roster_copy_or_move_target_label: "Copy or move to terminals",
			multi_face_roster_move_no_destinations:
				"No other terminal destinations are available for this person.",
			multi_face_roster_move_person: "Move",
			multi_face_roster_copy_to_terminal: "Copy to terminals",
			multi_face_roster_add_to_terminal_target_label: "Add to terminals",
			multi_face_roster_add_to_terminal_no_destinations:
				"No terminal destinations are available for this person.",
			multi_face_roster_add_to_terminal: "Add to terminal",
			multi_face_roster_delete_completely: "Delete completely",
			multi_face_roster_confirm: "Yes, delete",
			multi_face_roster_move_confirm: "Yes, move",
			multi_face_roster_copy_confirm: "Yes, copy",
			multi_face_roster_add_to_terminal_confirm: "Yes, add",
			multi_face_roster_remove_confirm_title: "Remove person from terminal?",
			multi_face_roster_remove_confirm_message:
				"Are you sure you want to delete {0} from terminal {1}? This removes the mirror-list membership and queues terminal deletion.",
			multi_face_roster_move_confirm_title:
				"Move person to selected terminals?",
			multi_face_roster_move_confirm_message:
				"Are you sure you want to move {0} to {1}? All current terminal mirror-list memberships will be removed first, then the selected destination memberships will be added.",
			multi_face_roster_copy_confirm_title:
				"Copy person to selected terminals?",
			multi_face_roster_copy_confirm_message:
				"Are you sure you want to copy {0} to {1}? Current terminal memberships will stay unchanged and only the selected destination memberships will be added.",
			multi_face_roster_add_to_terminal_confirm_title:
				"Add person to selected terminals?",
			multi_face_roster_add_to_terminal_confirm_message:
				"Are you sure you want to add {0} to {1}? Terminal synchronization will create the selected mirror-list memberships.",
			multi_face_roster_delete_confirm_title: "Delete person completely?",
			multi_face_roster_delete_confirm_message:
				"Are you sure you want to delete {0}? This first removes all terminal mirror-list memberships, then deletes the backend trained person when available.",
			multi_face_roster_remove_success: "Person removed from {0}.",
			multi_face_roster_move_success:
				"Person moved. Terminal synchronization will delete from current origins and create on destinations.",
			multi_face_roster_copy_success:
				"Person copied to selected terminal mirror lists. Existing terminal memberships were kept.",
			multi_face_roster_add_to_terminal_success:
				"Person added to selected terminal mirror lists. Terminal synchronization will create the terminal user.",
			multi_face_roster_delete_success:
				"Person deleted from terminal mirror lists and backend when available.",
			multi_face_roster_action_error: "Could not complete the person action.",
			multi_face_roster_terminal_list_missing:
				"The terminal mirror list could not be resolved.",
			multi_face_roster_person_id_missing:
				"The person backend id could not be resolved.",
			multi_face_roster_membership_missing:
				"The terminal mirror-list membership was not found.",
			access_control_face_roster_sync_terminal_users: "Sync terminal users",
			access_control_face_roster_sync_success: "Terminal users synchronized.",
			access_control_face_roster_sync_error:
				"Could not synchronize terminal users.",
			multi_face_roster_detail_title: "Person details",
			multi_face_roster_close_detail: "Close details",
			multi_face_roster_user_info: "User information",
			multi_face_roster_name: "Name",
			multi_face_roster_status_summary: "Status summary",
			multi_face_roster_present_terminals: "Terminals where present",
			multi_face_roster_events_chart_title: "Access terminal events",
			multi_face_roster_events_chart_subtitle:
				"Daily events over the last 30 days",
			multi_face_roster_events_chart_label: "Events",
			multi_face_roster_events_total: "{0} event(s)",
			multi_face_roster_events_loading: "Loading events...",
			multi_face_roster_events_empty:
				"No access terminal events were found in the last 30 days.",
			multi_face_roster_events_error: "Could not load this person’s events.",
			terminal_face_rule_registered_faces_note:
				"This rule uses the faces registered in the selected access terminal(s).",
			terminal_face_rule_registered_faces_list: "Terminal registered faces",
			terminal_face_rule_list_required:
				"The selected face terminal does not have a resolvable registered-faces list.",
			require_face_list_or_entity: "FACE rules require a list or entity",
			access_terminal_events: "Access Terminal Events",
			device_id: "Device Id",
			rtsp_address: "RTSP Address",
			data: "Data",
			ms_s: "Select photos that will not train",
			ms_c: "Are you sure of the selected ones?",
			ms_c1: "Are you sure of the new password?",
			trained_thumbnail: "Trained thumbnail",
			confidence: "Confidence",
			number_detecteds: "Number detecteds",
			device_options: "Device Options",
			type_devices: "Type of devices",
			detection: "Detection",
			evidence: "Evidence",
			config_device: "Configure device",
			rtsp_address: "RTSP address",
			udp_address: "UDP address",
			x: "Position X",
			y: "Position Y",
			w: "Width",
			h: "Height",
			stats: "Stats",
			connections: "Connections",
			country_config: "Country Configuration",
			hosts: "Hosts",
			ms_np: "There is no saved profile",
			user_list: "User List",
			registered_user: "Registered user",
			super_user: "Super user",
			admin: "Administrator",
			operator: "Operator",
			user_role: "User role",
			user_data: "User data",
			login_data: "Login data",
			forgot_psw: "Forgot my password",
			recover_psw: "Recover password",
			search_name: "Search by name",
			search_date: "Search by date",
			search_date_range: "Search by date range",
			resizable: "Resizable",
			draggable: "Draggable",
			responsive: "Responsive",
			prevent_collision: "Prevent Collision",
			static: "Static",
			vertical_compact: "Vertical compact",
			detections: "Detections",
			welcome: "Welcome",
			ms_sd: "Select dashboard",
			lpr: "LPR",
			face: "FACE",
			"Face-Access-Terminal": "Face Access Terminal",
			traffic: "TRAFFIC",
			object: "OBJECT",
			user_tracking: "User tracking",
			daily: "Daily",
			weekly: "Weekly",
			ms_sp: "Please check your email, a security code has been sent.",
			security_code: "Enter security code",
			no_match: "Do not match",
			match: "Match",
			recovery_process: "Password recovery process",
			roi: "Area of interest",
			Roi: "Roi",
			top: "Top",
			left: "Left",
			motion_flag: "Motion flag",
			draw_routes: "Draw routes",
			duration: "Duration",
			fps_top: "FPS top",
			use_overview: "Use overview",
			port: "Port",
			ms_del: "Are you sure to delete it?",
			basic_info: "Basic information",
			ip_rest: "IP REST",
			entry_type: "Entry type",
			debug: "Debug",
			speed_sensor: "Speed sensor",
			speed_limit: "Speed limit",
			fps: "FPS",
			plates_proc: "Plates proc",
			use_subdet_only: "Use subdet only",
			recog_all: "Recog all",
			use_cascade: "Use cascade",
			step_udp_stream: "Step UDP stream",
			events: "Events",
			created_at: "Created at",
			monthly_events: "Monthly events",
			daily_events: "Daily events",
			status_queue: "Status queue",
			total_income: "Total income",
			news: "News",
			total_onqueue: "Total On Queue",
			offline: "Offline",
			online: "OnLine",
			checking: "Checking...",
			inputs: "Inputs",
			input: "Input",
			relays: "Relays",
			relay_status: "Relay Status",
			waiting_relay_data: "Waiting for relay data...",
			error_loading_relays: "Error loading relays",
			more_details: "More details",
			details: "Details",
			// Compat: algunas vistas usan la clave literal en español
			Detalles: "Details",
			// Counter modal
			counter_details: "Counter details",
			rfid: "RFID",
			photo_segment: "Photo segment",
			plate: "Plate",
			list_id: "List ID",
			list_name: "List Name",
			motive: "Motive",
			creation_date: "Creation Date",
			update_date: "Update Date",
			type: "Type",
			description: "Description",
			online_events: "Online events",
			offline_events: "Offline events",
			ms_adh: "Select and add a new host to start and view the platform",
			photo: "Photo",
			segment: "Segment",
			dvr: "DVR",
			// Status/detail keys
			ok: "OK",
			auth_invalid: "Invalid credentials",
			device_offline: "Device is offline or not accessible",
			manager_id: "Manager ID",
			add_components: "Add components",
			lpr_events: " LPR Events",
			events_rfid: "Events RFID",
			device_list: "Device list",
			drawable_options: "Drawable options",
			grid_options: "Grid options",
			video_stream: "Video stream",
			installation_process: "Installation process",
			match_rules: "Match rules",
			new_match_rule: "New match rule",
			select_host_lpr: "Select host LPR",
			select_host_rfid: "Select host RFID",
			select_rfid_ant: "Select RFID ANT",
			match_history: "History matches",
			ant: "Ant",
			epc: "Epc",
			memory_data: "Memory data",
			rssi: "rssi",
			date_lpr: "Date LPR",
			date_rfid: "Date RFID",
			host_config_logs: "Host configuration logs",
			integration: "Integration",
			manager: "Manager",
			ip_address: "IP Address",
			integration_config: "Integration configuration",
			cloud_config: "CLOUD configuration",
			list: "List",
			cloud: "CLOUD",
			config_file: "Configuration path",
			ms_del: "Are you sure to delete?",
			deleted: "Deleted",
			updated: "Updated",
			saved: "Saved",
			registered: "Registered",
			edited: "Edited",
			video_streams: "Video streams",
			hostname: "Hostname",
			ip: "IP",
			status: "Status",
			total: "Total",
			onqueue: "Onqueue",
			axle: "Axle",
			weight: "Weight",
			number_passenger: "Number passenger",
			payment: "Payment",
			type_encode_media: "Type encode media",
			type_integrate: "Type integrate",
			cancel: "Cancel",
			select_lane: "Select lane",
			lane: "Lane",
			add_tariff: "Add tariff",
			tariffs: "Tariffs",
			type_vehicle: "Type vehicle",
			direction: "Direction",
			type_transport: "Type of transport",
			np_start: "Number passengers start",
			np_end: "Number passengers end",
			weight_init: "Initial weight",
			weight_end: "Weight end",
			person: "Person",
			n_a: "N/A",
			access_control_events: "Access control events",
			access_control_admin: "Access control administration",
			event_code: "Event code",
			user_id: "User ID",
			user_name: "User name",
			access_method: "Method",
			access_method_face_fp_card_pw: "Face, fingerprint, card or password",
			access_status: "Access status",
			reader_id: "Reader ID",
			door_status: "Door status",
			device_sn: "Device serial",
			snap_path: "Snapshot path",
			successful_access: "Successful access",
			access_denied: "Access denied",
			unknown_access: "Unknown access event",
			evidence_available: "Available",
			no_evidence: "No evidence",
			door_open: "Door open",
			door_closed: "Door closed",
			open_door: "Open door",
			relay_control: "Relay control",
			card_number: "Card number",
			face_image: "Face image",
			backend_action: "Actions are sent only to controlled backend endpoints.",
			create_user: "Create user",
			update_user: "Update user",
			create_card: "Create card",
			update_card: "Update card",
			remove_card: "Remove card",
			upload_face: "Upload face",
			update_face: "Update face",
			remove_face: "Remove face",
			access_control_unsupported_actions:
				"User create/update is not exposed because it is not supported by the validated backend contract.",
			door_relay_not_validated:
				"Door and relay actions are not validated for this backend contract and are not available here.",
			relay_id: "Relay ID",
			action_sent: "Action sent",
			payments: "Payments",
			ms_sel: "Select photos to train",
			folder_name: "Folder name",
			minimum_selected: "Minimum selected",
			missing_data: "Missing data",
			traffic_lights: "Traffic lights",
			port_server_modbus: "Port server ",
			uselanes: "Use lanes",
			use_ocr: "Use lanes",
			laneconfig: "Lane config",
			wb_violation: "Whitebox  violations",
			wb_vio_time: "Whitebox time",
			quadrants: "Quadrants",
			gpu: "GPU",
			uuid: "UUID",
			ms_reset:
				"The current data will be lost. Except basic information. Are you sure to reset the data to default values?",
			lanes_id: "Lanes id",
			lanes: "Lanes",
			type_lane: "Type lane",
			turns: "Turns",
			turn: "Turn",
			street_cam: "Street cam",
			top_view_cam: "Top view cam",
			mapview: "Mapview",
			ms_complet: "Please complete all fields",
			alerts: "Alerts",
			ocr_found: "OCR found",
			coord: "Coordinates",
			speed: "Speed",
			speed_limit: "Speed limit",
			size: "Size",
			plate_search: "Plate search",
			host_id: "Host ID",
			no_valid: "Not valid",
			invalid_ip: "Invalid IP",
			ms_dwh:
				"Please draw again or extend the Roi, the dimensions of the Roi must exceed more than 0.50 in width and 0.10 for height",
			latitude: "Latitude",
			longitude: "Longitude",
			state: "State",
			rtsp_path: "RTSP Path",
			lat: "Lat",
			long: "Long",
			no_data: "No data available",
			create_dashboard: "Create dashboard",
			create_dashboard_profile: "Create dashboard profile",
			ms_new_dashboard: "Please write a name to the new dashboard",
			saved_profile: "Saved profile",
			updated_profile: "Updated profile",
			connection_type: "Connection type",
			ms_sel_type: "Please select a type",
			ms_name_exist: "This name already exists, Please type another name",
			ms_rename_dashboard:
				"Enter a new name if you want to rename the profile.",
			update_profile: "Update profile",
			update_dashboard_profile: "Update dashboard profile",
			blacklist: "Blacklist",
			active: "Active",
			inactive: "Inactive",
			motive: "Motive",
			refresh: "Refresh",
			matches_found: "Matches found",
			matches_no_found: "Matches not found",
			light: "Light",
			night: "Night",
			language: "Language",
			language_english: "English",
			language_spanish: "Spanish",
			language_mongolian: "Mongolian",
			gpu_device: "GPU device",
			ocr_port: "OCR port",
			decoding_type: "Decoding type",
			added: "Added",
			notifications: "Notifications",
			virtual_keyboard: "Virtual keyboard",
			records: "Records",
			limit: "Limit",
			mb: "MB",
			delete_profile: "Delete profile",
			lanes_config: "Lanes config",
			location: "Location",
			general_parameters: "General parameters",
			number_items: "Number items",
			no_records_found: "No records found",
			records_found: "Records found",
			plate_chars: "Plate",
			plate_char: "Plate",
			img: "Segment",
			location_host: "Location",
			expire_date_vehicle_inspection: "Expire date vehicle inspection",
			point_a: "Point A",
			point_b: "Point B",
			distance: "Distance",
			km_h: "Km/h",
			video_type: "Video type",
			video_stream_type: "Video Streaming Type",
			stream_flv: "FLV",
			stream_ws: "WS-FLV",
			stream_hls: "HLS",
			stream_udp: "UDP",
			data_no_found: "Information not found",
			data_found: "Information found",
			invalid_empty_records: "Invalid or empty record URL",
			ms_sel_dd: "Select a date and device to list",
			udp_connection: "UDP connection",
			stream_element: "Video stream element",
			stream_data: "Video stream data",
			enter_value: "Enter a value",
			connecting: "Connecting",
			reconnecting: "Reconnecting",
			connected: "Connected",
			disconnected: "Disconnected",
			events_received: "Events received",
			alert_sound: "Alert sound",
			sync_alarm_list: "Synchronizing alarm list",
			loading_hosts_list: "Loading hosts list",
			loaded_hosts_list: "Loaded hosts list",
			loading_devices_list: "Loading devices list",
			loaded_devices_list: "Loaded devices list",
			loading_dashboard_profile: "Loading dashboard profile",
			loaded_dashboard_profile: "Loaded dashboard profile",
			loading_dashboard: "Loading Dashboard",
			please_wait: "Please wait...",
			safe_zone: "Safe Zone",
			contact_list: "Contact list",
			telephone: "Telephone",
			cellphone: "Cellphone",
			alert_sounds_settings: "Alert sounds settings",
			sounds: "Sounds",
			pop_ups: "Pop-ups",
			nvr: "NVR",
			vid_path: "Vid path",
			port_rest: "Port REST",
			type_decoding: "Type decoding",
			motion_threshold: "Motion threshold",
			detection_threshold: "Detection threshold",
			tracker_max_frames: "Tracker max frames",
			obj_to_detect: "Obj to detect",
			detect: "Detect",
			debug: "Debug",
			stream_ip: "Stream IP",
			stream_port: "Stream Port",
			video_source: "Video source",
			reconnecting_ws: "Reconnecting WS in 30 seconds",
			timeout: "Timeout",
			seconds: "Seconds",
			add_device: "Add Device",
			ip_cam: "IP CAM",
			constellation: "Constellation",
			streaming: "Video Streaming",
			config: "Config",
			timeline: "Timeline",
			alarms: "Alarms",
			zones: "Zones",
			areas: "Areas",
			hardware_requirements: "Hardware Requirements",
			demo_version: "Demo version",
			register: "Register",
			zone: "Zone",
			container: "Container",
			path_file: "Path file",
			motion: "Motion",
			anomalies: "Anomalies",
			objects: "Objects",
			human_actions: "Human actions",
			face_recognition: "Face recognition",
			gun: "Gun",
			weapon_detector: "Weapon detector",
			tags: "Tags",
			tag: "Tag",
			categorie: "category",
			sel_new_location: "Select new location",
			my_streaming: "My Streaming",
			stream_ws1: "WS",
			min_alert: "Minimized alert mode",
			map: "Map",
			createdAt: "Created at",
			no_receiving_stream: "Not receiving streaming",
			popup_timeout: "Pop up timeout",
			alert_time: "Alert time",
			sound: "Sound",
			frequency_smart_event: "Frequency Smart Event",
			frequency_smart_event_tooltip:
				"Specifies how often the smart event will be generated (in minutes). 0 means the event will be generated every time the condition is met.",
			smart_event_cooldown_seconds_label: "Cooldown event/alert (seconds)",
			frequency: "Frequency",
			popup: "Pop up",
			access: "Access",
			prediction: "Prediction",
			folder: "Folder path",
			probability: "Probability",
			hands_up: "Hands up",
			record: "Record",
			timezone: "Timezone",
			select_timezone: "Select timezone",
			protocol: "Protocol",
			protocol_socket: "Protocol Socket",
			ip_socket: "IP Socket",
			port_socket: "Port Socket",
			port_face: "Port Face",
			parameters: "Parameters",
			parameter: "Parameter",
			color: "Color",
			line_width: "Line width",
			playback: "Playback",
			alarm: "Alarm",
			monday: "Monday",
			tuesday: "Tuesday",
			wednesday: "Wednesday",
			thursday: "Thursday",
			friday: "Friday",
			saturday: "Saturday",
			sunday: "Sunday",
			interval: "Interval",
			notifiable: "Notifiable",
			send_ws: "Send Telegram",
			send_email: "Send email",
			schedule: "Schedule",
			analytic: "Analytic",
			count_device: "Count device",
			alarm_info: "Alarm info",
			capacity: "Capacity",
			minimum_time: "Minimum time",
			channel: "Channel",
			smart_event: "Smart event",
			channels: "Channels",
			ip_stream: "IP stream",
			port_stream: "Port stream",
			ModBus: "ModBus",
			useLanes: "Use lanes",
			laneConfig: "Lane Config",
			port_overview: "Port overview",
			videoEvidence: "Video Evidence",
			videoDuration: "Video Duration",
			use_OCR: "Use OCR",
			lane: "Lane",
			lane1: "Lane 1",
			lane2: "Lane 2",
			lane3: "Lane 3",
			lane4: "Lane 4",
			lane5: "Lane 5",
			lane6: "Lane 6",
			type: "Type",
			type1: "Type 1",
			type2: "Type 2",
			type3: "Type 3",
			type4: "Type 4",
			type5: "Type 5",
			type6: "Type 6",
			turn: "Turn",
			turn1: "Turn 1",
			turn2: "Turn 2",
			turn3: "Turn 3",
			turn4: "Turn 4",
			turn5: "Turn 5",
			turn6: "Turn 6",
			statistics: "Statistics",
			analytics: "Analytics",
			analytics_logs: "Analytics logs",
			recording: "Recording",
			on: "ON",
			off: "OFF",
			table_no_exist: "This table not exist",
			table_no_enable: "This table not enabled",
			clear_console: "Clear console",
			novideo_source: "Video source",
			app_full_frame: "App full frame",
			frame_resize_width: "Frame resize width",
			frame_resize_height: "Frame resize height",
			max_object_size: "Max object size",
			redis_port: "Redis port",
			motion_method: "Motion method",
			jump_n_frames_for_proccess: "Jump n frames for procces",
			draw: "Draw",
			DO_MOTION: "Do Motion",
			display_by_analytics: "Display by analytics",
			rest_ip: "Rest IP",
			rest_port: "Rest port",
			roi1: "ROI1",
			roi2: "ROI2",
			rtsp: "RTSP",
			rtsp2: "RTSP2",
			deviceId: "Device ID",
			redis_ip: "Redis IP",
			settings_smart_event: "Settings smart event",
			entry_type: "Entry type",
			white_box_limits: "White box limits",
			gpu_device: "GPU device",
			lists: "Lists",
			new_list: "New list",
			listing_setting: "Listing configuration",
			listing_details: "Listing details",
			registered_list_details: "Registered listing details",
			require_sel_list: "Required select a list",
			registered_integrations: "Registered integrations",
			video_segments: "Video segments",
			mode: "Mode",
			manage: "Manage",
			AG_REDIS_111:
				"A problem was found with the start of a service, please contact support",
			technical_records: "Technical records ",
			AG_BK_RECORD_001: "Camera recording started",
			AG_BK_RECORD_002: "In this moment the cam is not recording",
			AG_BK_RECORD_003: "Camera is not recording, trying to restart it ", //'The cam try restart record ',
			AG_BK_RECORD_000: "The cam is recording",
			section: "Section",
			alert: "Alert",
			AG_BK_DISK_001: "Disk not found, start with a disk default",
			AG_BK_DISK_007: "Disk  created a default",
			AG_BK_DISK_011: "Disk error in create by default",
			AG_DEV_002: "Error with device",
			AG_DEV_005: "Please check the device",
			not_permissions: "You do not have permissions",
			activate: "Activate",
			confirm_upgrade: "Confirm upgrade",
			AG_BK_GPS_017: "Not receiving coordinates, out of coverage",
			req_sel_device: "Required : Select device ",
			scale: "Plate",
			Scale: "Scale",
			smart_reports: "Smart Event Report",
			no_info_page: "No information found on this page",
			no_found_page: "Page not found",
			registered_smart_event: "Registered Smart Events",
			registered_devices: "Registered devices",
			support: "Support",
			notifications_technical: "Notifications technical",
			profiles_default: "Default profiles",
			dashboards: "Dashboards",
			components: "Components",
			select_dates: "Select dates",
			req_sel_analitic: "Required select a analytic",
			no_res_server: "No response from the server",
			req_sel_analytic_tag: "Required select a analytic and tag",
			bike: "Bike",
			bus: "Bus",
			truck: "Truck",
			car: "Car",
			laptop: "Laptop",
			motorcycle: "Motorcycle",
			area_interest: "Area of interest",
			motorbike: "Motorbike",
			suggested_timezone: "Suggested time zone",
			registered_zones: "Registered zones",
			select_zone: "Select zone",
			type_zone: "Type zone",
			background_image: "Background image",
			sync_blacklist: "Sync blacklist",
			sync_cloud: "Sync with Cloud",
			upload_imagen: "Upload imagen",
			req_name_file_upload: "Required zone name or File for upload",
			uploaded_image: "Uploaded image",
			bbox: "",
			bbox_: "Bounding box",
			tag_count: "Tag count",
			list_id: "List Id",
			entity: "Entity",
			click_test_video: "Click to test video",
			select_record_rtsp: "Select to record this RTSP",
			disk: "Disk",
			disks: "Disks",
			registered_disks: "Registered disks",
			required_range_24h: "Required range 24 hours",
			no_found_id_del: "Not found ID of item to delete",
			not_found: "Not found",
			not_found_propierties: "Not found properties",
			delete_shape: "Delete shape",
			new_shape: "New shape",
			registered_lists: "Registered lists",
			not_found_device: "Not found device",
			not_found_tag: "Not found tag",
			owner: "Owner",
			visitor: "Visitor",
			current_photo: "Current photo",
			trained_photo: "Trained photo",
			registering_user: "Registering user",
			role_not_valid: "Role selected not valid",
			role: "Role",
			invalid_password: "Invalid password",
			required: "Required",
			whatsapp: "Whatsapp",
			enable: "Enable",
			url: "URL",
			import: "Import",
			export: "Exportar",
			registered_schedules: "Registered Schedules",
			confirm_reset: "Confirm reset",
			fail_down_video: "Failed to download video",
			video_down_not_found: "Video to download not found",
			download: "Download",
			current_page: "Current page",
			current_videos: "Current videos",
			all: "All",
			select_videos: "Select videos",
			select_items: "Select items",
			media_path: "Media path",
			server_ip: "Server IP",
			server_port: "Server Port",
			poligons: "Polygons",
			code: "Code",
			module: "Module",
			detail: "Detail",
			req_id_del: "Requires ID to remove",
			req_created_devices: "Requires created devices",
			timelapse: "Time lapse",
			min_6_characters: "Min 6 characters",
			valid: "Valid",
			confirmed: "Confirmed",
			and_reseted: "And reestablished",
			reseted: "Reseted",
			change_password: "Change Password",
			new_zone: "New zone",
			zone_settings: "Zone settings",
			discovered_devices: "Discovered devices",
			clear_logs: "Clear logs",
			restart: "Restart",
			restarted: "Restarted",
			start: "Start",
			started: "Started",
			stop: "Stop",
			stopped: "Stopped",
			store_chunks: "Store chunks",
			video_size_factor: "Video size factor",
			is_record: "Is Record",
			channel_record: "Channel record",
			registered_colors_bbox: "Registered colors Bbox",
			registered_sounds: "Registered sounds",
			logo: "Logo",
			logos: "Logos",
			registered_faces: "Registered FACEs",
			view_grid: "View grid",
			view_list: "View list",
			xaddr: "Xaddr",
			updatedAt: "Update at",
			delete_devices: "Delete devices",
			backup: "Backup",
			restore_backup: "Restore from backup",
			ms_dashboard_empty: "Dashboard empty, Please add components",
			used: "Used",
			space: "Space",
			waiting: "Waiting",
			waiting_: "Waiting...",
			AG_BK_RECORD_004: "RTSP NULL, Required set a RTSP",
			max_buffer: "Max buffer",
			amount_to_delete: "Amount to delete",
			limit_erased_recording: "Limit erasure of recording",
			limit_erased_evidences: "Limit erasure of evidences",
			percent_limit_del_evidences: "Disk % to start deleting evidences",
			rtsp_timeout: "RTSP timeout (s)",
			storage: "Storage",
			AG_BK_RETRASMISSION_004: "Closed retrasmission",
			AG_BK_PING_DEVICE_000: "Ping the device in good condition",
			AG_BK_PING_DEVICE_001: "Device ping delaying",
			AG_BK_PING_DEVICE_002: "Ping with device not detected",
			AG_BK_RETRASMISSION_002: "Error with retransmission",
			AG_BK_PING_NETWORK_000: "Ping the Network in good conditions",
			AG_BK_PING_NETWORK_002: "Ping with Network not detected",
			AG_BK_DISK_000: "Disk in good condition.",
			AG_BK_DISK_002: "Disk storage out of limit",
			video_evidence: "Video evidence",
			PDF: "PDF",
			"Video Evidence": "Video Evidence",
			barcode_not_found: "Barcode not found for this event",
			AG_BK_RETRASMISSION_000: "Retransmission in good connection",
			AG_BK_RETRASMISSION_001: "Reconnecting relay",
			computer: "Computer",
			device_ping: "Device ping",
			retransmission: "Retransmission",
			confirm_logout: "Are you sure logout",
			AG_BK_RTSP_000: "Video streaming it's working",
			AG_BK_RTSP_002: "Fail to get video streaming",
			workspace: "Workspace",
			only_fails: "Only fails",
			select_retransmission: "Post Broadcast Video",
			port_socket_msg: "Add if IP address contains port",
			name_cloud_msg: "It is to identify Workspace",
			registered_workspaces: "Registered Workspaces",
			more_options: "More options",
			download_pdf: "Download PDF",
			download_excel: "Download EXCEL",
			hide_filters: "Hide filters",
			show_filters: "Show filters",
			redirect_reports: "Redirect to reports",
			select_tags: "Select tags",
			ignore: "Ignore",
			send: "Send",
			confirm_options: "Confirm options",
			magament_incidents: "Management of incidents",
			type_peripheral: "Type Peripheral",
			new_peripheral: "New Peripherals",
			pin: "Pin",
			type_device: "Type device",
			access_control: "Access Control",
			access_control_vendor: "Brand",
			access_control_integrated_model: "Integrated model",
			access_control_vendor_fallback: "Could not load brands from the server. Using local fallback options.",
			access_control_models_unavailable: "Could not load integrated models. Enter the model manually and continue.",
			access_control_model_manual_hint: "If the model list is unavailable, type the integrated model manually.",
			access_control_vendor_required: "Select the terminal brand before continuing.",
			access_control_model_required: "Select or enter the integrated model before continuing.",
			access_control_terminal_required: "Complete name, IP, user and password before continuing.",
			access_control_probe_terminal: "Detect terminal information",
			access_control_probe_running: "Detecting terminal information...",
			access_control_probe_success: "Terminal information detected.",
			access_control_probe_unavailable: "Could not detect terminal information. You can continue manually.",
			access_control_server_location_loaded: "Server location loaded as default. You can adjust it on the map.",
			access_control_server_location_unavailable: "Could not load the server location. Select the location manually on the map.",
			access_control_rtsp_url: "RTSP stream URL",
			access_control_rtsp_preview: "RTSP preview",
			access_control_rtsp_preview_help: "Use the same RTSP test flow as camera registration. If the browser cannot play it directly, keep the RTSP and continue.",
			access_control_rtsp_required: "RTSP stream URL required",
			access_control_rtsp_invalid: "RTSP URL must start with rtsp://",
			access_control_rtsp_preview_unavailable: "RTSP preview is unavailable through the current media path. You can keep editing the form.",
			access_control_rtsp_backend_dependency: "RTSP persistence requires backend support. Save without RTSP or update the backend dependency.",
			access_control_backend_device_id_contract: "The backend must generate deviceId automatically. Current backend validation is incorrectly requiring it.",
			access_control_step_vendor_title: "Choose the brand",
			access_control_step_vendor_help: "Start by selecting the terminal brand supported by the integration.",
			access_control_step_model_title: "Choose the model",
			access_control_step_model_help: "Select the integrated model available for the selected brand.",
			access_control_step_terminal_title: "Terminal data",
			access_control_step_terminal_help: "Enter name, IP, user, password and serial. The system will try to detect information automatically.",
			access_control_step_video_title: "Video and RTSP",
			access_control_step_video_help: "Add or test the RTSP URL associated with the terminal camera.",
			access_control_step_location_title: "Terminal location",
			access_control_step_location_help: "Confirm the server default location or select another point on the map.",
			drag_drop_audio: "Drag and drop audio",
			invalid_audio_file: "Only audio files are allowed.",

			action_device_empty_actions: "No configured actions to show.",
			action_device_details_toggle: "View full details",
			action_device_default_title: "Configured action",
			action_device_type_unknown: "Undefined type",
			action_device_type_peripheral: "Peripheral",
			action_device_type_access_control: "Access control",
			action_device_type_device: "Camera / device",
			action_device_type_system: "System",
			action_device_condition_success: "when successful",
			action_device_condition_failure: "when it fails",
			action_device_selected_device_fallback: "selected device",
			action_device_sound_fallback: "configured sound",
			action_device_sentence_play_audio: "Play",
			action_device_sentence_on: "on",
			action_device_sentence_snapshot: "Take a photo on",
			action_device_sentence_record: "Record video on",
			action_device_sentence_webhook: "Send an external URL notice",
			action_device_sentence_smart_event: "Change a smart event state",
			action_device_detail_condition: "Condition",
			action_device_detail_sound_value: "Sound / value",
			action_device_description_placeholder: "Welcome sound",
			action_device_action_play_audio: "Play audio",
			action_device_action_send_value: "Send relay state",
			action_device_action_snapshot: "Take photo",
			action_device_action_record: "Record video",
			action_device_action_webhook: "External URL notice",
			action_device_action_blink: "Blink",
			action_device_action_ring: "Ring",
			action_device_action_change_smart_event_status: "Change smart event state",
			action_device_action_connect: "Connect",
			action_device_action_start_counter: "Start counter",
			action_device_action_end_counter: "End counter",
			action_device_assistant_intro:
				"Follow these steps to explain what the action does, where it runs, and when it should run.",
			action_device_step_identify_title: "Identify this action",
			action_device_step_identify_help:
				"Use a short name operators can recognize later, for example: Welcome sound.",
			action_device_step_target_title: "Choose where it will run",
			action_device_step_target_help:
				"Select the equipment type, the device, and the action to perform.",
			action_device_step_config_title: "Configure what it will do",
			action_device_step_config_help:
				"Only the fields needed for the selected action are shown here.",
			action_device_step_timing_title: "Choose when it runs",
			action_device_step_timing_help:
				"Define if this action runs when the alarm succeeds, fails, or changes an event.",
			action_device_label_relay_channel: "Relay channel",
			action_device_label_relay_state: "Relay state",
			action_device_label_start_wait: "Wait before executing",
			action_device_label_active_duration: "Active time",
			action_device_label_when: "When should it run?",
			action_device_help_description:
				"This name is for the operator. It helps identify the action without reading technical values.",
			action_device_help_type:
				"Choose the family of equipment: camera, peripheral, access control, or system.",
			action_device_help_device:
				"Choose the physical device where this action will run.",
			action_device_help_action:
				"Choose what the system should do with the selected device.",
			action_device_help_destiny:
				"Choose who should receive or use this action result.",
			action_device_help_sound:
				"Choose the audio that will be played on the selected terminal.",
			action_device_help_sound_file:
				"Upload a new audio file if it is not already listed.",
			action_device_help_delay:
				"How long the action stays active before returning to its initial state.",
			action_device_help_seconds:
				"Seconds to wait before the action starts executing.",
			action_device_help_relay_channel:
				"Relay channel to control on the peripheral device.",
			action_device_help_relay_state:
				"State to send to the relay channel: ON or OFF, according to the device configuration.",
			action_device_help_frequency:
				"Number of repetitions or execution frequency, when the device supports it.",
			action_device_help_ring_action:
				"Choose whether the sound should start or stop.",
			action_device_help_ring_file:
				"Choose the stored sound file used by the peripheral.",
			action_device_help_ring_mode:
				"Choose how the peripheral should play the sound.",
			action_device_help_count: "Number of times the action should repeat.",
			action_device_help_volume: "Volume level for the sound action.",
			action_device_help_smart_event:
				"Smart event that will be enabled, disabled, or changed by this action.",
			action_device_help_active_on:
				"Choose whether this action runs on a successful or failed alarm result.",
			medium: "Medium",
			test_peripheral: "Test peripheral",
			roles: "Roles",
			registered_roles: "Registered Roles",
			permissions: "Permissions",
			registered_permissions: "Registered permissions",
			add: "Add",
			view: "View",
			can_add: "Can add",
			can_view: "Can View",
			can_edit: "Can edit",
			can_update: "Can update",
			serial: "Serial",
			action: "Action",
			value: "Value",
			delay: "Delay",
			incident: "Incident",
			incidents: "Incidents",
			new_incident: "New incident",
			table: "Table",
			none_selected: "None selected",
			draw_detected_area: "Draw detected area",
			resource: "Resource",
			resources: "Resources",
			registered_resources: "Registered resources",
			managers: "Managers",
			parking: "Parking",
			information: "Information",
			exit: "Exit",
			entry: "Entry",
			invoice: "Invoice",
			barcode: "Barcode",
			loading_states: "Loading states",
			loading: "Loading",
			total_invoice: "Total invoice",
			invoice_counter: "Invoice counter",
			id_invoice: "ID invoice",
			consecutive: "Consecutive",
			void: "Void",
			iva: "Iva",
			subtotal: "Subtotal",
			total_charge: "Total charge",
			workspaces: "Workspaces",
			domain: "Domain",
			counter: "Counter",
			last_update: "Last update",
			not_recording: "Is not recording",
			it_being_recorded: "It's already being recorded",
			your_browser_not_req:
				"Your web browser does not meet the requirements; please upgrade to a decent browser like firefox or google chrome",
			no_devices: "No hay dispositivos",
			start_recording: "Start recording",
			stop_recording: "Stop recording",
			microphone_selection: "Microphone selection",
			device_selection: "Device Selection",
			audio: "Audio",
			valid_name_without_cs: "Valid name without special characters",
			current_password: "Current password",
			define_new_password: "Define new password",
			contacts: "Contacts",
			new_contact: "New contact",
			registered_contacts: "Registered contacts",
			send_telegram: "Send Telegram",
			telegram: "Telegram",
			settings_contact: "Settings contact",
			contact: "Contact",
			your_pws_has_changed: "Your password has been changed successfully",
			manual_confirmation: "Manual confirmation",
			type_of_contact: "Type of contact",
			final_client: "Final client",
			alert_monitor: "Alert monitor",
			require_confirmation: "Require confirmation",
			confirm_alert: "Confirm alert",
			close_descriptions: "Close descriptions",
			create_motion: "Create Motion",
			confirmed_date: "Confirmed date",
			confirmed_alert: "Confirmed alert",
			not_confirmed: "Not confirmed",
			alarm_name: "Alarm name",
			address: "Address",
			date_birth: "Date of Birth",
			profiles: "Profiles",
			new_profile: "New profile",
			registered_profiles: "Registered profiles",
			client: "Client",
			other: "Other",
			external_customer: "External customer",
			get_arduinos: "Get arduinos",
			get_devices: "Get devices",
			arduino: "Arduino",
			page_not_found: "Page not found",
			redirecting_page: "Redirecting page",
			select_dashboard: "Select a Dashboard",
			"": "",
			is_motion: "Is motion",
			video_for_display: "Video for display",
			cropping_faces: "Cropping faces",
			"hand-up": "Hands up",
			detected: "Detected",
			all: "All",
			event: "Event",
			not_tagged: "Not tagged",
			telegramAPI: "Telegram API",
			name_guardian: "Name GUARDIAN",
			uuid_guardian: "UUID Guardian",
			broker_password: "Broker Password",
			broker_username: "Broker Username",
			broker_address: "Broker Address",
			broker_port: "Broker Port",
			route: "Route",
			component: "Component",
			api: "API",
			field_generated_by_system: " Field generated by the system",
			no: "No",
			do_not_fill_this_field:
				"Do not fill this field, it's generated by the system",
			// CitizenFace API translations
			citizen_title: "Citizen",
			citizenface_api_integration: "CitizenFace API Integration",
			req_id_to_update: "Requires ID to update",
			req_id_to_update_list: "Id required to update listing",
			knife: "Knife",
			default: "Default",
			google_analytic_id: "Google analytic ID",
			add_permission: "Add permission",
			can_delete: "Can delete",
			no_have_permission_create: "You do not have permissions to create",
			no_have_permission_edit: "You do not have permissions to edit",
			no_have_permission_view: "You do not have permission to view",
			no_have_permission_delete: "You do not have permissions to delete",
			setting_device: "Device setting ",
			setting_analytic: "Analytic setting",
			not_allowed_on_sight: "Not allowed on sight",
			devices: "Devices",
			server_rtsp: "RTSP server",
			parked: "Parked",
			overpaid_parking: "Overpaid parking",
			processed_entries: "Processed entries",
			paid: "Paid",
			unpaid: "Unpaid",
			paid_by_post: "Paid by post",
			whitelist: "Whitelist",
			others: "Others",
			trained: "Registered People",
			seleccion_files_to_train: "Seleccion files to train",
			number_trained: "Number trained",
			trained_user: "Trained User",
			avc: "AVC",
			vehicle_type: "Vehicle type",
			axle_counter: "Axle counter",
			lifted_axles: "Lifted axles",
			axle_count: "# Axles",
			required_select_analytic: "Required select a analytic",
			date_of_admission: "Date of admission",
			entry_module: "Entry module",
			entry_type: "Entry type",
			departure_date: "Departure date",
			exit_module: "Exit module",
			exit_type: "Exit type",
			rate: "Rate",
			tax: "Tax",
			payment_method: "Payment method",
			bill_number: "Bill number",
			is_created_automatically: "is created automatically",
			similar_face: "Similar face",
			face_detected: "Face detected",
			faceUUID: "faceUUID",
			similarity_information: "Similarity information",
			alert_information: "Alert information",
			face_detected_information: "Face detected information",
			file: "File",
			files: "Files",
			ip_machine: "IP Machine",
			image: "Image",
			workstation: "Workstation",
			workstations: "Workstations",
			filters: "Filters",
			isignored: "Is ignored",
			option: "Option",
			false_positive: "False positive",
			ignore_alert: "Ignore alert",
			edit_map_name: "Edit map name",
			map_name: "Map name",
			zoom: "Zoom",
			zoom_in: "Zoom in",
			zoom_out: "Zoom out",
			zoom_with_alerts: "Zoom with alerts",
			destiny: "Destiny",
			monitor: "Monitor",
			zoom_in_alerted: "Zoom in when alerted",
			zoom_out_after_alerted: "Move away after alert",
			clean_dashboard: "Clean Dashboard",
			is_incident: "Is incident",
			type_incident: "Type incident",
			evnt_type: "Event type",
			time_to_previous_state: "Time to previous state",
			confirmed_alert: "Confirmed alert",
			automatic_activation: "Automatic activation",
			ignored_alert: "Ignored alert",
			unconfirmed_alert: "Unconfirmed alert",
			deleting_dashboard: "Deleting Dashboard",
			site: "Site",
			Sera4: "Sera4",
			alert_display_time: "Alert display time",
			endpoint: "Endpoint",
			working: "Working",
			restarting: "Restarting",
			AG_BK_RTSP_102:
				"No response from rtsp, check connection with video or transmitter", //,"No response from the server",
			AG_BK_RTSP_112: "Server saturated with requests",
			msg_local_rtsp: "Local RTSP is used in record, analytics and broadcast",
			msg_hls: "RTSP for video in HLS format",
			AG_BK_RTSP_122: "The RTSP is invalid, check it",
			AG_BK_RTSP_132: "Stream verification timed out",
			AG_BK_RTSP_133: "Network is unreachable for Video Streaming",
			"AG_BK_RETRASMISSION_00-1": "Starting video streaming",
			"AG_BK_RECORD_00-1": "Starting recording",
			google: "Google",
			//local
			AG_BK_RETRASMISSION_LOCAL_000:
				"Publishing transmission to internal server status : ON",
			AG_BK_RETRASMISSION_LOCAL_001:
				"Publishing transmission to internal server status : Rebooting",
			"AG_BK_RETRASMISSION_LOCAL_00-1":
				"Publishing transmission to internal server status : Loading",
			AG_BK_RETRASMISSION_LOCAL_002:
				"Publishing transmission to internal server status : Error",
			AG_BK_RETRASMISSION_LOCAL_004:
				"Publishing transmission to internal server status : OFF",
			// cloud
			AG_BK_RETRASMISSION_CLOUD_000:
				"Publishing transmission to cloud status : ON",
			AG_BK_RETRASMISSION_CLOUD_001:
				"Publishing stream to cloud status : Rebooting",
			"AG_BK_RETRASMISSION_CLOUD_00-1":
				"Publishing stream to cloud status : Loading",
			AG_BK_RETRASMISSION_CLOUD_002:
				"Publishing stream to cloud status : Error",
			AG_BK_RETRASMISSION_CLOUD_004:
				"Publishing transmission to cloud status : OFF",
			side: "Side",
			way: "Way",
			"AG_BK_RTSP_00-1": "Loading transmission status",
			AG_BK_RETRASMISSION_003: "Video retransmission status: Flashing",
			AG_BK_RETRASMISSION_LOCAL_003:
				"Publishing transmission to internal server status : Flashing",
			AG_BK_RETRASMISSION_CLOUD_003:
				"Publishing transmission to cloud status : Flashing",
			error_get_counter_list: "Error getting list of counters",
			rules: "Rules",
			required_register_one_rule: "Required register one rule",
			rules_registered: "Rules registered",
			devices_registered: "Devices registered",
			rules_required_register: "Rules required register",
			actions_registered: "Actions registered",
			devices_required_register: "devices required register",
			actions_required_register: "Actions required register",
			terms: "Terms",
			comply_with_any_rule: "Comply with any rule",
			follow_all_rules: "Apply all rules",
			description_follow_all_rules:
				"With this option active, all the rules must be met to notify",
			description_comply_any_rules:
				"This active option allows any of the rules to be fulfilled to notify",
			time_automatic_closing: "Time for automatic closing",
			plate_outside_allowed:
				"Plate outside the allowed limit, it is recommended not to exceed 0.20",
			select_all: "Select All",
			trained_faces: "Trained faces",
			hour: "Hour",
			evidence_link: "Evidence link",
			unable_to_send_event_id_not_found:
				"Unable to send report, event ID not found",
			export_all: "Export all",
			consultation_date: "Consultation date",
			date_range: "Date range",
			preparing: "Preparing",
			preparing_to_export: "Preparing to export",
			consulting_information: "Consulting information",
			adding_to_excel: "Adding to excel",
			downloading_report: "Downloading report",
			finalized: "Finalized",
			edit_zone: "Edit zone",
			edited_area: "Edited area",
			auto_zone: "Auto zone",
			method: "Method Request",
			find_location: "Find Location",
			getting_location: "Getting location",
			geolocation_not_supported: "Geolocation not supported by this browser.",
			enable_browser_permissions: "Enable browser permissions",
			closing_session: "Closing session",
			closed_session: "Closed session",
			device_status: "Device status",
			device_disconnected: "Device disconnected",
			technical_status: "Technical status",
			initializing: "Initializing",
			activate_minimize_alert: "Activate to minimize alert",
			disable_maximize_alert: "Disable to Maximize alert",
			minimized: "Minimized",
			maximized: "Maximized",
			option_to_export:
				"This option export to Excel the analytics : lpr, alarms, smart Event, face, objects.",
			warning_more_time: "Warning: it will take more time",
			no_pending_notifications: "There are no pending notifications",
			helmet: "Helmet",
			no_helmet: "No helmet",
			box: "Box",
			icon: "Icon",
			registered_tags: "Registered tags",
			press_enter_add_analytic: "Press enter to add analytics",
			click_here_add_analytics: "Click here to add analytics",
			tag_created: "Tag Created",
			tag_updated: "Tag Updated",
			tag_deleted: "Tag Deleted",
			creating_tag: "Creating Tag",
			updating_tag: "Updating Tag",
			deleting_tag: "Deleting Tag",
			analytics_created: "Analytics Created",
			analytics_updated: "Analytics Updated",
			analytics_deleted: "Analytics Deleted",
			creating_analytics: "Creating Analytics",
			updating_analytics: "Updating Analytics",
			deleting_analytics: "Deleting Analytics",
			load_default_tag_analytics: "Load Default Tags and Analytics",
			actionsRing: "Action Ring",
			count: "Count",
			volumen: "Volumen",
			multiple: "Multiple",
			once: "Once",
			system: "System",
			peripheral: "Peripheral",
			typeAction: "Type action",
			change_smart_event_status: "Change Smart Event status",
			optimize_tracker: "Optimize tracker",
			already_exist_plate:
				"This plate is already registered in the selected list.",
			start_time: "Start Time",
			end_time: "End Time",
			end: "End",
			group: "Group",
			density: "Density",
			peak_time: "Peak Time",
			object_types: "Object Types",
			Iframe: "Iframe",
			register_events: "Register Events",
			technical: "Tecnhical",
			peripherals: "Peripherals",
			audios: "Audios",
			already_exist_component_dashboard:
				"This component already exists in the Dashboard",
			when_no_option_selected_dashboard:
				"When no option is selected, the last panel is loaded by default",
			profile_already_up_to_dashboard:
				"This profile has already been uploaded to Platform",
			powered_by: "Powered By",
			version: "Version",
			rois_number: "Rois number",
			copy_behavior_to: "Copy behavior to",
			see_more: "See more",
			less_details: "Less details",
			historical_asset: "Historical asset",
			error_validating_images: "Error validating images",
			face_photo_valid: "The photo is valid for facial recognition",
			face_photo_invalid: "The photo is not valid for facial recognition",
			face_validation_pending: "Facial-recognition validation is pending",
			face_analytics_inactive: "FACE analytics is not active",
			face_validation_cleanup_pending:
				"The photo is valid; background processing is still pending",
			trained_face_capture_camera: "Camera",
			trained_face_capture_registered: "Registered camera",
			trained_face_capture_facing_user: "Front",
			trained_face_capture_facing_environment: "Back",
			trained_face_capture_start_preview: "Start preview",
			trained_face_capture_action: "Capture",
			trained_face_capture_no_preview:
				"No browser preview is available for this registered camera. Upload remains available as a fallback.",
			trained_face_capture_unsupported:
				"Browser camera access is not supported by this browser",
			trained_face_capture_requires_secure_context:
				"Camera access requires HTTPS or localhost. Open this page over HTTPS, use localhost during development, or upload an image instead.",
			trained_face_capture_not_ready: "Camera preview is not ready",
			trained_face_capture_stop_preview: "Stop preview",
			trained_face_capture_stream_unavailable:
				"Registered camera stream could not start. Upload remains available as a fallback.",
			trained_face_capture_stream_timeout:
				"Registered camera stream timed out. Start preview again or upload an image instead.",
			trained_face_capture_snapshot_failed:
				"Registered camera snapshot failed. Try again or upload an image instead.",
			trained_face_capture_auth_preview_fallback:
				"Authenticated live preview is not available in this browser yet. Capture still uses the secure backend snapshot.",
			trained_face_capture_load_cameras_failed:
				"Could not load registered cameras. Upload remains available as a fallback.",
			trained_face_capture_error_503:
				"Camera stream is not available right now. Verify the camera is online or try another camera.",
			trained_face_capture_error_502:
				"Snapshot or stream could not be captured. Try again or check the camera connection.",
			trained_face_capture_error_403:
				"Your session is not authorized to use this camera. Refresh the page or log in again.",
			trained_face_capture_error_404:
				"Camera stream session was not found. Restart preview and try again.",
			trained_face_capture_error_network:
				"Backend or camera service is not reachable. Check the connection and try again.",
			trained_face_validation_error_503:
				"Face validation service is not available right now. Verify the camera or validation service connection and try again.",
			trained_face_validation_error_502:
				"Face validation service could not process the image. Try again with another photo.",
			trained_face_validation_error_403:
				"Your session expired or is not authorized. Refresh the page or log in again.",
			trained_face_validation_error_network:
				"Backend or validation service is not reachable. Check the connection and try again.",
			trained_face_validation_error_generic:
				"Could not validate the image. Try again with another photo.",
			trained_face_save_error_generic:
				"Could not save the trained face. Try again.",
			trained_face_list_assignment_title: "Assign to face lists",
			trained_face_list_required:
				"Choose at least one face list before saving.",
			trained_face_list_empty:
				"No face lists yet. Create one here to continue.",
			trained_face_list_create_label: "New list name",
			trained_face_list_create_action: "Create list",
			trained_face_list_assignment_pending:
				"Face saved, but list assignment is still pending. Retry list assignment before considering it complete.",
			trained_face_list_assignment_retry: "Retry assignment",
			invalid_images: "Invalid images",
			validated_images: "Validated images",
			"Cant find face in input": "Cant find face in input",
			search_by_video_face: "Search By Video",
			upload_video: "Upload Video",
			upload_images: "Upload Images",
			results: "Results",
			analyze_video: "Analyze Video",
			video_database: "Video Database",
			video: "Video",
			range: "Range",
			captured_image: "Captured image",
			error_reading_video: "Error reading video",
			select: "Select",
			deselect: "Deselect",
			table: "Table",
			grid: "Grid",
			time: "Time",
			similarity: "Similarity",
			see: "See",
			uploading_video: "Uploading video",
			analyzing_video: "Analyzing video",
			analysis_completed: "Analysis completed",
			successfully: "Successfully",
			unsuccessfully: "Unsuccessfully",
			activeOn: "Active on",
			you_are_already_using_profile: "You are already using this profile",
			no_similarity_found: "No similarity found",
			error_uploading_video_face: "Error loading video. Please try again",
			selection_successfully: "Selection made successfully",
			face_needs_selected:
				"You need to select or import a face. Check and then perform the search",
			now_you_can_perform_search: "Now you can perform the search",
			highest_similarity: "Highest similarity",
			have_been_registered: "Have been registered: ",
			have_not_been_registered: "Have not been registered: ",
			face_already_registered_in_list:
				"The face is already registered in the list.",
			face_selection_required: "Face selection required",
			cuts: "Cuts",
			face_selected: "Face selected",
			video_clipping: "Video clipping",
			no_data_found_face_search: "No data found for the face search",
			cropImage: "Crop image",
			enableCropImage: "Enable image cropping",
			disableCropImage: "Disable image cropping",
			play: "Play",
			pause: "Pause",
			draw_box_over_area_captured: "Draw a box over the area to be captured",
			waiting_for_data: "Waiting for data",
			error_loading: "Error loading",
			attributes: "Attributes",
			color: "Color",
			type_vehicle: "Tipo de vehículo",
			speed_limit: "Velocidad máxima",
			car_type: "Tipo de auto",
			brand: "Marca",
			direction: "Dirección",
			speed: "Speed",
			no_dashboard_items: "No dashboard items to display",
			back_to_dashboard: "Back to Dashboard",
			set_default: "Set as default",
			Barcode: "Barcode",
			Device: "Device",
			Inicio: "Start",
			"Foto inicio": "Photo start",
			Fin: "End",
			"Foto fin": "Photo end",
			State: "State",
			in_progress: "In progress",
			finished: "Finished",
			unknown: "Unknown",
			grouped_events: "Eventos Agrupado",
			Duration: "Duración",
			Totalizers: "Totalizadores",

			// Modal de Entidades
			add_entities_to_list: "Add Entities to List",
			select_list: "Select List",
			entities_selected: "entities selected",
			filter_by_name: "Filter by Name",
			filter_by_date: "Filter by Date",
			clear_filters: "Clear Filters",
			add_to_list: "Add to List",
			cancel: "Cancel",
			please_select_list_first: "Please select a list first",
			no_entities_selected: "No entities selected",
			entities_added_to_list: "Entities added to list",
			failed_to_fetch_entities: "Failed to fetch entities",
			failed_to_add_entities: "Failed to add entities to list",

			// Nuevas claves para listing_details.vue
			loading_please_wait: "Loading... Please wait",
			instructions: "Instructions",
			select_list_and_choose_entities:
				"Select a list and then choose the entities you want to add. You can use filters to find specific entities.",
			entities_selected_for_list: "Entities selected to add to the list",
			select_entities_from_table:
				"Select entities from the table to add them to the list",
			search_filters: "Search Filters",
			use_filters_to_find_entities:
				"Use these filters to find specific entities by name or date",
			available_entities: "Available Entities",
			select_entities_to_add_to_list:
				"Select the entities you want to add to the list. Use the top checkbox to select all.",
			deselect_all: "Deselect All",
			select_all: "Select All",
			global_mode_activated: "Global mode activated",
			entities_of: "entities of",
			pages: "pages",
			active_filters: "Active filters",
			no_entities_available: "No entities available",
			no_entities_match_search_criteria:
				"No entities found matching the search criteria",
			photo: "Photo",
			error_get_list: "Error getting list",
			failed_get_lists: "Failed to get lists",
			required_have_list_created: "Required to have list created: go to lists",
			error_get_list_trained: "Error getting trained list",
			error_list_setting: "Error list setting",
			res_logos: "Response logos",
			error_logos: "Error logos",
			error_deleting: "Error deleting",
			deleting_item: "Deleting item",
			item_to_delete_have_id: "Item to delete must have id",
			item_to_delete_null: "Item to delete is null",
			opening_modal: "Opening modal...",
			modal_state: "Modal state:",
			list_changed_to: "List changed to:",
			api_response: "API Response:",
			api_url: "API URL:",
			api_params: "API Params:",
			filtered_entities: "Filtered entities:",
			total: "Total:",
			applying_filters: "Applying filters",
			none: "none",
			total_entities: "Total entities",
			total_pages: "Total pages",
			items_per_page: "Items per page",
			page: "Page",
			entities_loaded: "entities loaded",
			total_so_far: "Total so far",
			all_entities_loaded: "All entities loaded",
			out_of: "out of",
			warning: "Warning",
			expected: "Expected",
			entities_but_got: "entities but got",
			error_fetching_all_entities: "Error fetching all entities",
			error_loading_all_entities: "Error loading all entities",
			with_filters_applied: "with filters applied",
			filters_applied: "Filters applied",
			viewing_details_for_entity: "Viewing details for entity:",
			added_via_modal: "Added via modal",
			filters_changed_global_mode_deactivated:
				"Filters have changed. Global selection mode has been deactivated.",
			date_changed_global_mode_deactivated:
				"Date has changed. Global selection mode has been deactivated.",
			global_selection_mode_deactivated: "Global selection mode deactivated",
			loading_all_entities_from_all_pages:
				"Loading all entities from all pages",
			entities_selected_from_pages:
				"Selected {count} entities from {pages} pages ({perPage} per page)",
			invalid_entities_for_face_list: "Invalid entities for face list",
			unexpected_response: "Unexpected response from API",
			enter_motive: "Enter motive for adding entities",
			failed_to_add_entities_detailed: "Failed to add entities to list",

			// Nuevas claves para el sistema de guía paso a paso
			step_1_select_list_first: "Step 1: Select a list first",
			step_2_enter_motive: "Step 2: Enter motive to continue",
			step_3_select_faces: "Step 3: Select faces to add",
			ready_to_select_entities: "Ready to select entities",
			setup_progress: "Setup Progress",
			select_faces: "Select Faces",
			complete_steps_1_and_2_first: "Complete steps 1 and 2 first",
			table_locked: "Table Locked",
			complete_setup_steps_to_unlock:
				"Complete the setup steps to unlock the table",
			step: "Step",
			not_in_list: "Not in list",

			// VideoSearchByVideo component translations
			browser_not_support_video:
				"Your browser does not support the video element.",
			frame_information: "Frame Information",
			full_frame: "Full Frame",
			cropped_face: "Cropped Face",
			timestamp: "Timestamp",
			bbox: "Bbox",
			frame_index: "Frame Index",
			bbox_probability: "Bbox Probability",
			face_id: "Face ID",
			photo_uuid: "Photo UUID",
			video_info: "Video Info",
			fps: "FPS",
			resolution: "Resolution",
			total_frames: "Total Frames",
			total_faces: "Total Faces",
			face_search_completed_successfully: "Face search completed successfully",
			no_results_above_similarity_threshold:
				"No results found above the established similarity threshold. The highest similarity found was {similarity}%. Do you want to adjust the filter to the highest similarity detected?",
			adjust_filter: "Adjust filter",
			similarity_filter_adjusted: "Similarity filter adjusted to {similarity}%",
			no_faces_found_in_search: "No faces found in the search",

			// LPR Modal translations
			lpr_event_details: "LPR Event Details",
			event_information: "Event Information",
			detail_event_information: "Detail Event Information",
			click_row_to_show_events:
				"Click on a row in Event Information to see the events",
			event_source: "Source",
			event_source_smartevent: "Smart Event",
			event_source_alert: "Alert",
			event_source_lpr: "LPR",
			event_source_avc: "AVC",
			seg: "Seg",
			event_id: "Event ID",
			video_event: "Event Video",
			loading_video: "Loading video...",
			video_load_error: "Could not load video",
			no_video_available: "No video available for this event",
			play_in_main_player: "Play in Main Player",
			loading_image: "Loading image...",
			connection_onvif: "Connection ONVIF",
			connect: "Connect",
			for_stream_2: "for stream 2",
			mb_gb: "MB/GB",
			tooltip_rtsp: "Enter RTSP URL: rtsp://user:pass@ip[:port]/path",
			tooltip_rtsp2: "Optional RTSP URL for substream or Channel 2",
			tooltip_hls: "HLS stream URL if available",
			tooltip_name: "Device name (min 4 characters)",
			tooltip_is_record: "Enable recording for selected channel",
			tooltip_limit: "Recording storage limit. Use MB or GB",
			tooltip_is_motion: "Enable motion detection",
			tooltip_video_streaming: "Enable video for display in dashboards",
			tooltip_ip_machine: "IP of the host where the service runs",
			tooltip_image: "Select Docker image for the motion service",
			tooltip_uuid:
				"Universal unique identifier of the device. This value is automatically generated and cannot be modified.",
			tooltip_record:
				"Enable or disable video recording for the device. When enabled, the system will save recordings according to the configured storage limit.",
			tooltip_streaming:
				"Enable or disable real-time video streaming. When enabled, the device video will be available for real-time viewing in the system.",
			tooltip_optimize_tracker:
				"Enable motion tracker optimization. When enabled, improves motion analysis and event detection performance, optimizing system resource usage.",
			tooltip_type_peripheral:
				"Select the type of peripheral: Siren (alarm), Electronic Lock (door lock), Arduino (microcontroller), IoT Relay (smart relay), or Odroid (single board computer). Each type has specific configurations.",
			tooltip_arduino:
				"Select the Arduino device associated with this peripheral. The Arduino must be previously configured in the system. Select from the list of available Arduinos.",
			tooltip_mode:
				'Select the operation mode of the peripheral: "in" (input) for devices that send signals to the system, or "out" (output) for devices that receive commands from the system.',
			tooltip_medium:
				"Select the communication medium of the peripheral: USB (physical USB connection), TCP (network TCP/IP communication), GPIO (input/output pins), or HTTP (web HTTP communication).",
			tooltip_pin:
				"GPIO pin number used for communication. Enter the physical pin number of the device (e.g., 2, 3, 4, etc.). Only required when the medium is GPIO.",
			tooltip_ip:
				"IP address of the peripheral device. Enter the IP address in IPv4 format (e.g., 192.168.1.100). Only required when the medium is TCP or HTTP.",
			tooltip_type:
				"Device type: IP_CAM (IP camera with video streaming) or PERIPHERAL (peripheral device such as sensors, actuators, etc.). This value cannot be modified after creating the device.",
			tooltip_serial:
				"Serial number of the peripheral device. Enter the unique serial number of the device for identification and tracking.",
			tooltip_onvif_user: "ONVIF device username",
			tooltip_onvif_password: "ONVIF device password",
			image_load_error: "Could not load image",

			// Alert & Smart Event Modal translations
			alert_details: "Alert Details",
			smart_event_details: "Smart Event Details",
			lpr_event_details: "LPR Event Details",
			action_details: "Action Details",
			object_details: "Object Details",
			axle_details: "Axle Details",
			event_type: "Event Type",
			event_details: "Event Details",
			showing_events_range: "Showing {0} - {1} of {2} events",
			page_of: "Page {0} of {1}",
			no_events_in_range: "No events in this range",
			severity: "Severity",
			message: "Message",
			rule_id: "Rule ID",
			tag: "Tag",
			description: "Description",
			additional_information: "Additional Information",
			unix_timestamp: "Unix Timestamp",
			style: "Style",
			subgroup: "Subgroup",
			file: "File",
			duration: "Duration",

			// EventsChart translations
			temporal_distribution_events: "Temporal Distribution of Events",
			period: "Period",
			by_hour: "By Hour",
			by_minute: "By Minute",
			hour: "Hour",
			minute: "Minute",
			time: "Time",
			no_data_events: "No event data to display",
			number_events: "Number of Events",
			events_label: "events",
			object_detected: "Object Detected",
			events_count: "Events Count",
			no_events: "No events to display",
			previous_event: "Previous Event",
			previous: "Previous",
			next_event: "Next Event",
			next: "Next",
			loading_events: "Loading events...",
			io_kind: "I/O type",
			new_state: "New state",
			mqtt_topic: "MQTT topic",

			// Alarm Stats translations
			alarm_stats: "Alarm Stats",
			alarm_stats_total_counted: "Total Counted Today",
			alarm_stats_good_units: "Good Units",
			alarm_stats_defects: "Defects Detected",
			alarm_stats_stoppages: "Stoppages Today",
			alarm_stats_quality_rate: "Quality Rate",
			alarm_stats_defect_rate: "Defect Rate",
			alarm_stats_total_idle: "Total Idle",
			alarm_stats_this_minute: "this minute",
			alarm_stats_units: "units",
			alarm_stats_events: "events",
			alarm_stats_current_rate: "Current Rate",
			alarm_stats_units_min: "u/min",
			alarm_stats_per_hour: "PER HOUR",
			alarm_stats_peak_today: "PEAK TODAY",
			alarm_stats_avg_hour: "AVG/HOUR",
			alarm_stats_projection: "Shift Projection",
			alarm_stats_projected_units: "Projected Units",
			alarm_stats_projection_desc: "At current rate",
			alarm_stats_shift_progress: "Shift Progress",
			alarm_stats_shift_duration: "SHIFT DURATION",
			alarm_stats_time_remaining: "TIME REMAINING",
			alarm_stats_oee: "OEE",
			alarm_stats_availability: "Availability",
			alarm_stats_performance: "Performance",
			alarm_stats_quality: "Quality",
			alarm_stats_oee_target: "OEE Target",
			alarm_stats_below_target: "Below Target",
			alarm_stats_above_target: "Above Target",
			alarm_stats_throughput: "Throughput",
			alarm_stats_rate: "Rate",
			alarm_stats_defects_label: "Defects",
			alarm_stats_stoppages_label: "Stoppages",
			alarm_stats_stoppage_log: "Stoppage Log",
			alarm_stats_time: "Time",
			alarm_stats_start_time: "Start",
			alarm_stats_end_time: "End",
			alarm_stats_duration: "Duration",
			alarm_stats_camera_trigger: "Camera Trigger",
			alarm_stats_rate_before: "Rate Before",
			alarm_stats_rate_after: "Rate After",
			alarm_stats_status: "Status",
			alarm_stats_notes: "Notes",
			alarm_stats_resolved: "Resolved",
			alarm_stats_active: "Active",
			alarm_stats_active_dash: "Active",
			alarm_stats_no_stats: "No statistics",
			alarm_stats_not_found: "Alarm not found",
			alarm_stats_load_error: "Load error",
			alarm_stats_retry: "Retry",
			alarm_stats_shift_config: "Shift Settings",
			alarm_stats_shift_start: "Shift Start",
			alarm_stats_shift_dur_min: "Duration (min)",
			alarm_stats_target_rate: "Target Rate (u/min)",
			alarm_stats_stop_threshold: "Stop Threshold (ms)",
			alarm_stats_cancel: "Cancel",
			alarm_stats_note_placeholder: "Add note...",
			alarm_stats_listing: "List",
			alarm_stats_loading: "Loading statistics…",
			alarm_stats_title_fallback: "Alarm Statistics",
			alarm_stats_realtime_connected: "Real-time: connected",
			alarm_stats_realtime_disconnected: "Real-time: disconnected",
			alarm_stats_shift_button: "Shift",
			alarm_stats_ws_lost: "Real-time connection lost",
			alarm_stats_ws_reconnected: "Reconnected to server",
			alarm_stats_note_save_error: "Could not save note",
			alarm_stats_config_save_error: "Could not save configuration to server",
			alarm_stats_config_saved: "Shift configuration saved",
			alarm_stats_shift_start_hint: "Format HH:MM (24h)",
			alarm_stats_shift_duration_hint: "Duration in minutes (e.g. 480 = 8 h)",
			alarm_stats_target_rate_hint: "Expected units per minute (0 = no target)",
			alarm_stats_stop_threshold_hint:
				"Minimum idle time before registering a stoppage",
			alarm_stats_shift_start_invalid: "Enter a valid time (HH:MM)",
			alarm_stats_shift_duration_invalid:
				"Duration must be greater than 0 minutes",
			alarm_stats_target_rate_invalid: "Target rate must be 0 or greater",
			alarm_stats_threshold_invalid: "Minimum threshold is 1000 ms (1 second)",
			alarm_stats_reset_zoom: "Reset",
			alarm_stats_from: "From",
			alarm_stats_to: "To",
			alarm_stats_apply: "Apply",
			alarm_stats_preset_today: "Today",
			alarm_stats_preset_custom: "Custom",
			alarm_stats_all: "All",
			alarm_stats_chart_units_axis: "Units",
			alarm_stats_upm: "upm",

			// Dashboard Pie Events shell translations
			dashboard_pie_events_total_type_pie: "Dashboard Chart Builder",
			dashboard_pie_events_preset_total_alertas: "Total Alerts",
			dashboard_pie_events_preset_total_alertas_atendidas:
				"Total Attended Alerts",
			dashboard_pie_events_preset_porcentaje_operacion_efectiva:
				"Effective operation percentage",
			dashboard_pie_events_preset_alertas_pendientes_por_atender:
				"Unresolved Alerts",
			dashboard_pie_events_preset_alertas_clasificadas_positivas_falso_positivas:
				"Classified positive/false positive alerts",
			dashboard_pie_events_preset_alertas_por_dispositivo: "Alerts by device",
			dashboard_pie_events_preset_tiempo_accion_operador:
				"Operator action time",
			dashboard_pie_events_preset_interval_title: "Select chart interval",
			dashboard_alerts_by_device_tab_map: "Map",
			dashboard_alerts_by_device_tab_list: "List",
			dashboard_alerts_by_device_ranking: "Points with most alerts",
			dashboard_alerts_by_device_device: "Device",
			dashboard_alerts_by_device_count: "Alerts",
			dashboard_alerts_by_device_loading: "Loading device alerts...",
			dashboard_alerts_by_device_empty: "No device alert data is available.",
			dashboard_alerts_by_device_no_coordinates:
				"No devices with coordinates to plot.",
			dashboard_operator_action_time_subtitle:
				"Time from alarm to operator action",
			dashboard_operator_action_time_average: "Average",
			dashboard_operator_action_time_p95: "P95",
			dashboard_operator_action_time_best: "Best today",
			dashboard_operator_action_time_within_objective: "Within objective",
			dashboard_operator_action_time_objective: "Objective",
			dashboard_operator_action_time_distribution: "Distribution",
			dashboard_operator_action_time_daily_average:
				"Daily average response time",
			dashboard_operator_action_time_daily_empty:
				"No daily response time data is available.",
			dashboard_operator_action_time_total: "Actioned alerts",
			dashboard_operator_action_time_source: "Action source",
			dashboard_operator_action_time_interval: "Interval",
			dashboard_operator_action_time_interval_24h: "24h",
			dashboard_operator_action_time_interval_7d: "7d",
			dashboard_operator_action_time_interval_30d: "30d",
			dashboard_operator_action_time_loading: "Loading operator action time...",
			dashboard_operator_action_time_empty:
				"No operator action time data is available.",
			dashboard_operator_action_time_error:
				"Could not load operator action time. Try again later.",
			dashboard_operator_action_time_skipped_note:
				"Alerts skipped without creation timestamp",
			dashboard_operator_action_time_pending_note:
				"Open alerts measured until query time",
			dashboard_pie_events_title: "Add Dashboard Chart",
			dashboard_pie_events_shell_help:
				"Name the chart, choose the visualization type, preview the result, then add it to the dashboard.",
			dashboard_pie_events_metadata_error:
				"Could not load chart metadata. The configuration flow can continue when the backend is available.",
			dashboard_pie_events_section_datasource: "Data source",
			dashboard_pie_events_section_interval: "Interval",
			dashboard_pie_events_section_devices: "Devices",
			dashboard_pie_events_section_refresh: "Refresh",
			dashboard_pie_events_section_preview: "Preview",
			dashboard_pie_events_placeholder_interval:
				"Preset and custom range selectors will be enabled here.",
			dashboard_pie_events_placeholder_devices:
				"Device selection will be enabled here.",
			dashboard_pie_events_placeholder_preview:
				"Preview rendering will be enabled before adding the widget.",
			dashboard_pie_events_refresh_default: "Default refresh: 60 seconds.",
			dashboard_pie_events_add_disabled: "Add after preview",
			dashboard_pie_events_loading_metadata: "Loading metadata...",
			dashboard_pie_events_metadata_loaded:
				"Metadata loaded. Selectors will use backend constraints in the next slice.",
			dashboard_pie_events_metadata_pending: "Waiting for chart metadata.",
			dashboard_pie_events_section_grouping: "Grouping",
			dashboard_pie_events_section_filters: "Filters",
			dashboard_pie_events_section_chart: "Chart",
			dashboard_pie_events_section_appearance: "Appearance",
			dashboard_pie_events_chart_name: "Name",
			dashboard_pie_events_chart_type: "Chart type",
			dashboard_pie_events_chart_type_pie: "Pie chart",
			dashboard_pie_events_chart_type_doughnut: "Donut chart",
			dashboard_pie_events_chart_type_kpi: "KPI card",
			dashboard_pie_events_chart_type_line: "Line chart",
			dashboard_pie_events_kpi_color: "KPI color",
			dashboard_pie_events_kpi_icon: "KPI icon",
			dashboard_pie_events_datasource: "Data source",
			dashboard_pie_events_table: "Table",
			dashboard_pie_events_interval_preset: "Interval preset",
			dashboard_pie_events_from: "From",
			dashboard_pie_events_to: "To",
			dashboard_pie_events_devices: "Devices",
			dashboard_pie_events_group_by: "Group by",
			dashboard_pie_events_no_grouping:
				"No groupable fields are available for this data source.",
			dashboard_pie_events_add_filter: "Add filter",
			dashboard_pie_events_no_filters:
				"No filterable fields are available for this data source.",
			dashboard_pie_events_filter_field: "Field",
			dashboard_pie_events_filter_operator: "Operator",
			dashboard_pie_events_filter_value: "Value",
			dashboard_pie_events_refresh_seconds: "Refresh seconds",
			dashboard_pie_events_refresh_range: "Allowed refresh range:",
			dashboard_pie_events_preview: "Preview",
			dashboard_pie_events_preview_loading: "Loading preview...",
			dashboard_pie_events_preview_empty:
				"Run preview to validate the configuration before adding.",
			dashboard_pie_events_preview_error:
				"Could not generate preview. Check the configuration or try again later.",
			dashboard_pie_events_total: "Total",
			dashboard_pie_events_requested: "Requested",
			dashboard_pie_events_interval_total: "Events in interval",
			dashboard_pie_events_grouped_total: "Grouped events",
			dashboard_pie_events_slice: "Slice",
			dashboard_pie_events_value: "Value",
			dashboard_pie_events_percent: "Percent",
			dashboard_pie_events_add: "Add chart",
			dashboard_pie_events_preset_today: "Today",
			dashboard_pie_events_preset_yesterday: "Yesterday",
			dashboard_pie_events_preset_week: "Week",
			dashboard_pie_events_preset_15d: "Last 15 days",
			dashboard_pie_events_preset_30d: "Last 30 days",
			dashboard_pie_events_preset_last_24h: "Last 24 hours",
			dashboard_pie_events_preset_last_7d: "Last 7 days",
			dashboard_pie_events_preset_last_30d: "Last 30 days",
			dashboard_pie_events_preset_custom: "Custom",
			"dashboard.pie.events.values.alarms.classification.positive": "Positive",
			"dashboard.pie.events.values.alarms.classification.false_positive":
				"False positive",
			"dashboard.pie.events.values.alarms.classification.unclassified":
				"Pending classification",
			dashboard_pie_events_validation_chart_type: "Select a chart type.",
			dashboard_pie_events_validation_datasource: "Select a data source.",
			dashboard_pie_events_validation_table: "Select a table.",
			dashboard_pie_events_validation_devices: "Select at least one device.",
			dashboard_pie_events_validation_custom_required:
				"Select custom range start and end dates.",
			dashboard_pie_events_validation_custom_order:
				"Custom range start must be before the end date.",
			dashboard_pie_events_validation_custom_limit:
				"Custom range exceeds the allowed window.",
			dashboard_pie_events_validation_refresh:
				"Refresh seconds are outside the allowed range.",
			dashboard_pie_events_validation_grouping:
				"Selected grouping is not allowed by metadata.",
			dashboard_pie_events_validation_filters:
				"Complete filters using allowed fields and operators.",
			dashboard_pie_events_loading_data: "Loading chart data...",
			dashboard_pie_events_empty_data:
				"No event data is available for this configuration.",
			dashboard_pie_events_data_error:
				"Could not load chart data. Try again later.",
			dashboard_pie_events_unsupported_config:
				"This chart configuration is not supported by this version.",
			dashboard_pie_events_retry: "Retry",
			dashboard_pie_events_generated_at: "Generated",
			dashboard_pie_events_sources_alarms: "Alarms",
			dashboard_pie_events_sources_lpr: "License plates (LPR)",
			dashboard_pie_events_sources_actions: "Operator actions",
			dashboard_pie_events_sources_smart_event: "Smart events",
			dashboard_pie_events_sources_reports: "Reports",
			dashboard_pie_events_sources_objects: "Detected objects",
			dashboard_pie_events_sources_technical: "Technical events",
			dashboard_pie_events_sources_peripherals: "Peripheral events",
			dashboard_pie_events_sources_incidents: "Incidents",
			dashboard_pie_events_sources_face: "Faces",
			dashboard_pie_events_sources_parking: "Parking events",
			dashboard_pie_events_sources_avc: "Vehicle counting (AVC)",
			dashboard_pie_events_sources_counter: "Counters",
			dashboard_pie_events_sources_mixta: "Mixed events",
			dashboard_pie_events_fields_event_type: "Event type",
			dashboard_pie_events_fields_name: "Name",
			dashboard_pie_events_fields_device: "Device",
			dashboard_pie_events_fields_deviceId: "Device",
			dashboard_pie_events_fields_timestamp: "Date and time",
			dashboard_pie_events_fields_unix_itme_stamp: "Date and time",
			dashboard_pie_events_fields_createdAt: "Created at",
			dashboard_pie_events_fields_updatedAt: "Updated at",
			dashboard_pie_events_fields_date: "Date",
			dashboard_pie_events_fields_data: "Data",
			dashboard_pie_events_fields_time: "Time",
			dashboard_pie_events_fields_manager: "Manager",
			dashboard_pie_events_fields_color: "Color",
			dashboard_pie_events_fields_attributes: "Attributes",
			dashboard_pie_events_fields_alarmId: "Alarm ID",
			dashboard_pie_events_fields_alertUUID: "Alert UUID",
			dashboard_pie_events_fields_analytic: "Analytic",
			dashboard_pie_events_fields_antenna_num: "Antenna number",
			dashboard_pie_events_fields_axle_count: "Axle count",
			dashboard_pie_events_fields_barcode: "Barcode",
			dashboard_pie_events_fields_bbox: "Bounding box",
			dashboard_pie_events_fields_caseId: "Case ID",
			dashboard_pie_events_fields_contact: "Contact",
			dashboard_pie_events_fields_coord: "Coordinates",
			dashboard_pie_events_fields_description: "Description",
			dashboard_pie_events_fields_detail: "Detail",
			dashboard_pie_events_fields_duration: "Duration",
			dashboard_pie_events_fields_duration_seconds: "Duration seconds",
			dashboard_pie_events_fields_duration_time: "Duration time",
			dashboard_pie_events_fields_end_time: "End time",
			dashboard_pie_events_fields_entry_event: "Entry event",
			dashboard_pie_events_fields_entry_trigger_event: "Entry trigger event",
			dashboard_pie_events_fields_entry_type: "Entry type",
			dashboard_pie_events_fields_epc_num: "EPC number",
			dashboard_pie_events_fields_eventId: "Event ID",
			dashboard_pie_events_fields_eventUUID: "Event UUID",
			dashboard_pie_events_fields_event_to_pay: "Event to pay",
			dashboard_pie_events_fields_exit_event: "Exit event",
			dashboard_pie_events_fields_exit_trigger_event: "Exit trigger event",
			dashboard_pie_events_fields_frame: "Frame",
			dashboard_pie_events_fields_frame_id: "Frame ID",
			dashboard_pie_events_fields_full_photo: "Full photo",
			dashboard_pie_events_fields_gif_evidence: "GIF evidence",
			dashboard_pie_events_fields_gifevidence: "GIF evidence",
			dashboard_pie_events_fields_h: "Height",
			dashboard_pie_events_fields_history: "History",
			dashboard_pie_events_fields_id: "ID",
			dashboard_pie_events_fields_init_time: "Start time",
			dashboard_pie_events_fields_is_confirmed: "Confirmed",
			dashboard_pie_events_fields_is_fp: "False positive",
			dashboard_pie_events_fields_is_ignored: "Ignored",
			dashboard_pie_events_fields_latitude: "Latitude",
			dashboard_pie_events_fields_longitude: "Longitude",
			dashboard_pie_events_fields_name_categorie: "Category name",
			dashboard_pie_events_fields_ocr_found: "OCR found",
			dashboard_pie_events_fields_operator: "Operator",
			dashboard_pie_events_fields_owner: "Owner",
			dashboard_pie_events_fields_path_evidence: "Evidence path",
			dashboard_pie_events_fields_plate_Description: "Plate description",
			dashboard_pie_events_fields_plate_found: "Plate found",
			dashboard_pie_events_fields_prob: "Probability",
			dashboard_pie_events_fields_probability: "Probability",
			dashboard_pie_events_fields_profileId: "Profile ID",
			dashboard_pie_events_fields_rfid_id: "RFID ID",
			dashboard_pie_events_fields_rssi_level: "RSSI level",
			dashboard_pie_events_fields_ruleId: "Rule ID",
			dashboard_pie_events_fields_segment_photo: "Segment photo",
			dashboard_pie_events_fields_side: "Side",
			dashboard_pie_events_fields_size: "Size",
			dashboard_pie_events_fields_speed: "Speed",
			dashboard_pie_events_fields_speed_limit: "Speed limit",
			dashboard_pie_events_fields_tid_num: "TID number",
			dashboard_pie_events_fields_top_image: "Top image",
			dashboard_pie_events_fields_total: "Total",
			dashboard_pie_events_fields_tracker_id: "Tracker ID",
			dashboard_pie_events_fields_url_evidence: "Evidence URL",
			dashboard_pie_events_fields_url_photo_event: "Event photo URL",
			dashboard_pie_events_fields_userId: "User ID",
			dashboard_pie_events_fields_vehicle_image_path: "Vehicle image path",
			dashboard_pie_events_fields_vehicle_image_url: "Vehicle image URL",
			dashboard_pie_events_fields_video: "Video",
			dashboard_pie_events_fields_vinfo: "Video info",
			dashboard_pie_events_fields_void_reason: "Void reason",
			dashboard_pie_events_fields_w: "Width",
			dashboard_pie_events_fields_way: "Way",
			dashboard_pie_events_fields_x: "X",
			dashboard_pie_events_fields_y: "Y",
			dashboard_pie_events_fields_uuid: "UUID",
			dashboard_pie_events_fields_motive_categorie: "Motive category",
			dashboard_pie_events_fields_tag: "Tag",
			dashboard_pie_events_fields_isalert: "Alert",
			dashboard_pie_events_fields_is_alarm: "Alarm",
			dashboard_pie_events_fields_plate_chars: "Plate",
			dashboard_pie_events_fields_type_vehicle: "Vehicle type",
			dashboard_pie_events_fields_vehicle_type: "Vehicle type",
			dashboard_pie_events_fields_direction: "Direction",
			dashboard_pie_events_fields_action: "Action",
			dashboard_pie_events_fields_type: "Type",
			dashboard_pie_events_fields_state: "State",
			dashboard_pie_events_fields_code: "Code",
			dashboard_pie_events_fields_module: "Module",
			dashboard_pie_events_fields_obs: "Observation",
			dashboard_pie_events_fields_void: "Void",
			dashboard_pie_events_fields_lane_no: "Lane",
			dashboard_pie_events_fields_typeCounter: "Counter type",
			dashboard_pie_events_fields_nameField: "Name field",
			dashboard_pie_events_fields_valueField: "Value field",
			dashboard_pie_events_fields_segment_photo_path: "Segment photo path",
			dashboard_pie_events_fields_segment_photo_url: "Segment photo URL",
			dashboard_pie_events_fields_full_photo_path: "Full photo path",
			dashboard_pie_events_fields_full_photo_url: "Full photo URL",
			dashboard_pie_events_fields_face_detected_path: "Detected face path",
			dashboard_pie_events_fields_face_detected_url: "Detected face URL",
		}),
		//engli
		// new MLanguage('portuguese').create({
		//   title: 'Oi {0}!',
		//   msg: 'este é o usuário'//'Você tem {f} amigos e {l} curtidas'
		// }),
		new MLanguage("spanish").create({
			select_file: "Seleccionar archivo",
			select_files_to_upload: "Seleccionar archivos para subir",
			description_list_id_field: "Identificación de la Lista",
			description_plate_field: "Descripción de la Placa vehicular",
			description_id_field: "Identificacion de la  Placa  vehicular",
			excel_format_error: "Error de formato Excel",
			excel_columns_required:
				"El archivo Excel debe tener exactamente 2 columnas",
			excel_columns_found: "Se encontraron {0} columnas, pero se requieren 2",
			excel_validation_failed: "Falló la validación del archivo Excel",
			validating_file: "Validando archivo...",
			file_format_valid: "Formato de archivo válido",
			title: "hola {0}!",
			msg: "Este es el usuario", //'You have {f} friends and {l} likes'
			profile: "Perfil",
			username: "Nombre de usuario",
			first_names: "Primer Nombre",
			last_names: "Apellidos",
			email: "Correo",
			password: "Contraseña",
			token: "Token",
			api_key: "API Key",
			client_id: "Client ID",
			api_key_permissions_placeholder: "ej. events:read,media:photos:read",
			alice_api_key_legend_title: "¿Para qué sirve esta integración?",
			alice_api_key_legend_desc:
				"Usa esta integración para registrar clientes externos que se conectan a Alice Guardian mediante API Key. Cada cliente tiene su propia clave, ID y permisos específicos.",
			alice_api_key_legend_fields: "Campos:",
			alice_api_key_legend_client_id:
				"Identificador único del cliente o servicio (ej. ag-metrics, mi-app).",
			alice_api_key_legend_api_key:
				"Clave segura generada para el cliente. Mantenla en secreto.",
			alice_api_key_legend_permissions:
				"Lista de acciones permitidas separadas por coma (ej. events:read,media:photos:read).",
			alice_api_key_legend_examples_title:
				"Ejemplos como variables de entorno:",
			details: "Detalles",
			alice_api_docs_title: "Documentación de uso de la API",
			alice_api_docs_auth: "Headers requeridos:",
			alice_api_docs_endpoints: "Endpoints disponibles:",
			alice_api_docs_based_on_perms: "(según permisos seleccionados)",
			alice_api_docs_all: "(selecciona permisos para filtrar)",
			alice_api_docs_example: "Ejemplo con curl:",
			alice_api_docs_jwt_note:
				"Las rutas marcadas como JWT requieren autenticación de sesión y aún no son accesibles con API Key.",
			alice_api_docs_option_a: "Opción A — Snapshot por device ID + timestamp",
			alice_api_docs_option_b:
				"Opción B — Evidencia por event UUID + timestamp",
			alice_api_docs_step1: "Paso 1 — Solicitar evidencia (URLs de foto/video)",
			alice_api_docs_step1_note:
				"Devuelve URLs temporales con token para cada archivo multimedia",
			alice_api_docs_step1_response: "Respuesta:",
			alice_api_docs_step2: "Paso 2 — Descargar el archivo usando el token",
			alice_api_docs_step2_note:
				"No requiere Authorization — el token es autosuficiente",
			alice_api_key_validation_title: "Corrige lo siguiente antes de guardar:",
			val_name_required: "El nombre es obligatorio.",
			val_client_id_required: "El Client ID es obligatorio.",
			val_client_id_invalid:
				"El Client ID solo puede tener letras, números, guiones y guiones bajos (sin espacios).",
			val_api_key_required: "El API Key es obligatorio.",
			val_api_key_too_short: "El API Key debe tener al menos 8 caracteres.",
			val_permissions_required: "Selecciona al menos un permiso.",
			val_guardian_cloud_url_required: "La URL del cloud es obligatoria.",
			val_guardian_cloud_url_invalid:
				"La URL debe incluir el protocolo (ej: http://69.197.150.32:9090).",
			val_guardian_cloud_name_required:
				"El nombre de la integración es obligatorio.",
			guardian_cloud_info_title: "Configuración Guardian Cloud",
			guardian_cloud_info_url_label: "Formato de URL:",
			guardian_cloud_info_url_example: "http://IP_O_DOMINIO:PUERTO",
			guardian_cloud_info_url_note:
				"Debe incluir protocolo (http:// o https://) y puerto.",
			guardian_cloud_test_btn: "Probar conexión",
			guardian_cloud_test_testing: "Probando…",
			guardian_cloud_test_ok: "Servidor responde",
			guardian_cloud_test_fail: "Sin respuesta",
			guardian_cloud_test_not_tested: "Prueba la conexión antes de guardar.",
			guardian_cloud_test_changed:
				"URL modificada — vuelve a probar la conexión.",
			confirm_psw: "Confirmar contraseña",
			save: "Guardar",
			create_new: "Crear Nuevo",
			duplicate: "Duplicar",
			copy: "Copiar",
			edit: "Editar",
			close: "Cerrar",
			soon: "Pronto",
			dashboard: "Plataforma",
			settings: "Configuraciones",
			history: "Historias",
			reports: "Reportes",
			register_user: "Registrar Usuario",
			category: "Categoria",
			save: "Guardar",
			create_new: "Crear Nuevo",
			duplicate: "Duplicar",
			copy: "Copiar",
			edit: "Editar",
			close: "Cerrar",
			soon: "Pronto",
			dashboard: "Plataforma",
			settings: "Configuraciones",
			history: "Historias",
			reports: "Reportes",
			register_user: "Registrar Usuario",
			category: "Categoria",
			new: "Nuevo",
			users: "Usuarios",
			id: "ID",
			name: "Nombre",
			user: "Usuario",
			type_user: "Tipo de usuario",
			type_users: "Tipo de usuarios",
			actions: "Acciones",
			search: "Buscar",
			groups: "Grupos",
			select_groups: "Seleccionar Grupos",
			login: "Loguearse",
			psw_req: "Contraseña es requerida!",
			login_error: "Error en loguarse",
			log_out: "Cerrar sesión",
			direction: "Direccion",
			host_api: "Servidor Api Url",
			host_client: "Servidor Cliente Url",
			description: "Descripcion",
			register: "Registrar",
			reset: "Resetear",
			delete: "Borrar",
			new_device: "Nuevo Dispositivo",
			cam_options: "Opciones de Camara",
			host: "Servidor",
			relay: "Relay",
			searching_relays: "Buscando Relays",
			searching: "Buscando",
			no_relays_found: "No se encontraron relays disponibles",
			retry_search: "Buscar de nuevo",
			help_name_peripheral:
				"Ingrese un nombre único para identificar este dispositivo periférico. Se requieren mínimo 4 caracteres.",
			help_type_peripheral:
				"Seleccione el tipo de periférico: Sirena (alarma), Cerradura Electrónica (cerradura de puerta), Arduino (microcontrolador), Relay IoT (relé inteligente) u Odroid (computadora de placa única).",
			help_medium:
				"Seleccione el medio de conexión: USB (conexión USB directa), TCP (conexión de red), GPIO (pines de entrada/salida de propósito general) o HTTP (conexión basada en web).",
			help_ip:
				"Ingrese la dirección IP del dispositivo. Requerido para conexiones TCP. Formato: XXX.XXX.XXX.XXX",
			help_serial:
				"Ingrese el número de serie o identificador del dispositivo. Generalmente se encuentra en la etiqueta del dispositivo o se puede obtener del escaneo del dispositivo.",
			help_arduino:
				'Seleccione un dispositivo Arduino de la lista de dispositivos detectados. Haga clic en "Obtener Arduinos" para escanear dispositivos conectados.',
			help_relay:
				"Seleccione un dispositivo Relay IoT de la lista de relays disponibles. El sistema buscará relays activos automáticamente.",
			help_username:
				"Ingrese el nombre de usuario para autenticación. Requerido para dispositivos de cerradura electrónica.",
			help_password:
				"Ingrese la contraseña para autenticación. Requerido para dispositivos de cerradura electrónica.",
			help_token:
				"Ingrese el token de autenticación o clave API. Requerido para algunos dispositivos de cerradura electrónica.",
			help_host:
				"Ingrese la dirección del host o URL del servidor. Requerido para dispositivos de cerradura electrónica. Formato: nombre de host o dirección IP.",
			type_cam: "Tipo de Camara",
			host_options: "Opciones de Servidor",
			options: "Opciones",
			camera: "Camara",
			cameras: "Cámaras",
			cloud: "Nube",
			cloud_sent: "Enviado a la nube",
			cloud_pending: "Pendiente de envío a la nube",
			date: "Fecha",
			date_e: "Fecha Final",
			date_in: "Fecha y Hora de Entrada",
			date_out: "Fecha y Hora de Salida",
			plates: "Placas",
			user_options: "Opciones de Usuario",
			dc: "Docs",
			excel: "Exportar a Excel",
			report_config: "Configuracion de Reporte",
			device_id: "Identificación del dispositivo",
			notification_config: "Configuracion de Notificaciones",
			create_alert: "Crear Alerta",
			success: "Acierto",
			error: "Error",
			warning: "Advertencia",
			alert_type: "Tipo de Alerta",
			alert_mode: "Modo de alerta",
			manual: "Manual",
			automatic: "Automatico",
			confirm: "Confirmar",
			graffics: "Graficos",
			notice: "Aviso",
			alice_face: "Alice Face",
			faces: "Caras",
			recognized: "Reconocidos",
			odt_face: "ODT - Face",
			unknown: "Desconocidos",
			select: "Seleccione",
			to_train: "Entrenar",
			video_feed: "Video feed",
			detected_faces: "Caras detectadas",
			host_list: "Lista de host",
			type: "Tipo",
			country: "País",
			licence: "Licencia",
			host_configuration: "Configuración del host",
			update: "Actualizar",
			alarm_button_save: "Guardar",
			alarm_button_update: "Actualizar",
			control: "Control",
			device: "Dispositivo",
			mixta_feed_title: "Feed unificado de accesos",
			mixta_feed_subtitle: "Tiempo real",
			"Real time": "Tiempo real",
			"Tiempo real": "Tiempo real",
			mixta_live: "• EN VIVO",
			mixta_filter_all: "Todo",
			mixta_filter_lpr: "LPR",
			mixta_filter_avc: "AVC",
			mixta_filter_smart: "Smart Events",
			mixta_filter_alarms: "Alarmas",
			mixta_buffer_label: "Máx. filas (WS)",
			mixta_col_identity: "Identidad",
			mixta_col_detail: "Detalle",
			mixta_col_source: "Origen",
			mixta_col_action: "Acción",
			mixta_col_time: "Hora",
			mixta_source_lpr: "LPR",
			mixta_source_avc: "AVC",
			mixta_source_smart: "SMART EVENTS",
			mixta_source_alarms: "ALARMS",
			mixta_action_lpr: "Detectado",
			mixta_action_avc: "Pasó",
			mixta_no_executed_actions: "Sin acciones ejecutadas registradas",
			mixta_filter_placeholder: "Filtrar eventos…",
			mixta_rows_count: "filas (filtrado)",
			unified_access_feed: "Feed unificado de accesos",
			multi_face_roster: "Personas en terminales",
			multi_face_roster_subtitle: "Rostros unificados por terminal",
			multi_face_roster_refresh: "Actualizar personas del terminal",
			multi_face_roster_group_label: "Agrupar",
			multi_face_roster_search_label: "Buscar por nombre o FPID",
			multi_face_roster_loading_people: "Cargando personas del terminal...",
			multi_face_roster_empty_title: "No hay personas para mostrar",
			multi_face_roster_empty_filter:
				"No se encontraron rostros con el filtro actual.",
			multi_face_roster_unnamed_person: "Persona sin nombre",
			multi_face_roster_system: "Sistema",
			multi_face_roster_terminal: "Terminal",
			multi_face_roster_yes: "Sí",
			multi_face_roster_no: "No",
			multi_face_roster_registered: "Registrados",
			multi_face_roster_registered_single: "Registrado",
			multi_face_roster_missing_import: "Falta importar",
			multi_face_roster_backend_only: "Solo en el sistema",
			multi_face_roster_group_person: "Por persona",
			multi_face_roster_group_terminal: "Por terminal",
			multi_face_roster_import_to_list: "Importar a lista",
			multi_face_roster_clear_selection: "Limpiar selección",
			multi_face_roster_import_people_title: "Importar personas",
			multi_face_roster_import_people_subtitle:
				"Seleccione la lista y el terminal de origen cuando corresponda.",
			multi_face_roster_close_import: "Cerrar importación",
			multi_face_roster_face_list_label: "Lista de rostros",
			multi_face_roster_no_face_lists: "No hay listas de rostros disponibles",
			multi_face_roster_source_required:
				"Seleccione el terminal de origen para personas presentes en más de un terminal.",
			multi_face_roster_source_terminal_label: "Terminal de origen",
			multi_face_roster_cancel: "Cancelar",
			multi_face_roster_import: "Importar",
			multi_face_roster_terminal_count: "{0} terminal(es)",
			multi_face_roster_summary_counts: "{0} registrados · {1} falta importar",
			multi_face_roster_failed_terminals:
				"{0} terminal(es) no respondieron. Se muestran los datos disponibles.",
			multi_face_roster_partial_terminals:
				"Atención: el listado puede estar incompleto en {0}. El terminal informó datos parciales o truncados; verifique antes de asumir que están todas las personas.",
			multi_face_roster_selected_count:
				"{0} persona(s) seleccionada(s) para importar",
			multi_face_roster_ready_count: "{0} persona(s) lista(s) para importar.",
			multi_face_roster_list_fallback: "Lista {0}",
			multi_face_roster_registered_subtitle:
				"Personas presentes en terminal y sistema",
			multi_face_roster_missing_import_subtitle:
				"Personas presentes en terminal pero no en el sistema",
			multi_face_roster_person_view_subtitle:
				"Vista unificada de todos los terminales",
			multi_face_roster_people_count: "{0} persona(s)",
			multi_face_roster_no_terminals:
				"No se encontraron terminales de acceso facial.",
			multi_face_roster_load_error:
				"No se pudo cargar el listado unificado de personas.",
			multi_face_roster_state_loaded: "Cargado",
			multi_face_roster_state_connected: "Conectado",
			multi_face_roster_state_disconnected: "Desconectado",
			multi_face_roster_state_partial: "Incompleto",
			multi_face_roster_state_error: "Error",
			multi_face_roster_state_loading: "Cargando",
			multi_face_roster_state_diagnostic: "Diagnóstico",
			multi_face_roster_photo_alt: "Foto del rostro de {0}",
			multi_face_roster_select_person: "Seleccionar {0} para importar",
			multi_face_roster_unselect_person: "Quitar {0} de la importación",
			multi_face_roster_lists_error:
				"No se pudieron cargar las listas de rostros.",
			multi_face_roster_import_success:
				"{0} persona(s) importada(s) y agregada(s) a la lista.",
			multi_face_roster_import_partial_success:
				"{0} persona(s) importada(s). {1} no se pudieron importar porque ya están registradas o ya no están presentes en el terminal de origen.",
			multi_face_roster_import_failed_count:
				"{0} persona(s) no se pudieron importar porque ya están registradas o ya no están presentes en el terminal de origen.",
			multi_face_roster_import_error: "No se pudo importar la selección.",
			multi_face_roster_add_person: "Agregar persona",
			multi_face_roster_add_success:
				"Persona agregada. La sincronización procesará la membresía de la lista espejo.",
			multi_face_roster_remove_from_terminal: "Quitar de terminal",
			multi_face_roster_move_target_label: "Mover a terminales",
			multi_face_roster_copy_or_move_target_label:
				"Copiar o mover a terminales",
			multi_face_roster_move_no_destinations:
				"No hay otros terminales de destino disponibles para esta persona.",
			multi_face_roster_move_person: "Mover",
			multi_face_roster_copy_to_terminal: "Copiar a terminales",
			multi_face_roster_add_to_terminal_target_label: "Agregar a terminales",
			multi_face_roster_add_to_terminal_no_destinations:
				"No hay terminales de destino disponibles para esta persona.",
			multi_face_roster_add_to_terminal: "Agregar a terminal",
			multi_face_roster_delete_completely: "Eliminar completamente",
			multi_face_roster_confirm: "Sí, eliminar",
			multi_face_roster_move_confirm: "Sí, mover",
			multi_face_roster_copy_confirm: "Sí, copiar",
			multi_face_roster_add_to_terminal_confirm: "Sí, agregar",
			multi_face_roster_remove_confirm_title: "¿Quitar persona del terminal?",
			multi_face_roster_remove_confirm_message:
				"¿Estás seguro de eliminar a {0} del terminal {1}? Esto quita la membresía de la lista espejo y encola la eliminación en el terminal.",
			multi_face_roster_move_confirm_title:
				"¿Mover persona a los terminales seleccionados?",
			multi_face_roster_move_confirm_message:
				"¿Estás seguro de mover a {0} a {1}? Primero se quitarán todas las membresías actuales de listas espejo de terminales y luego se agregarán las membresías de destino seleccionadas.",
			multi_face_roster_copy_confirm_title:
				"¿Copiar persona a los terminales seleccionados?",
			multi_face_roster_copy_confirm_message:
				"¿Estás seguro de copiar a {0} a {1}? Las membresías actuales de terminales se mantendrán y solo se agregarán las membresías de destino seleccionadas.",
			multi_face_roster_add_to_terminal_confirm_title:
				"¿Agregar persona a los terminales seleccionados?",
			multi_face_roster_add_to_terminal_confirm_message:
				"¿Estás seguro de agregar a {0} a {1}? La sincronización creará las membresías seleccionadas en las listas espejo.",
			multi_face_roster_delete_confirm_title:
				"¿Eliminar persona completamente?",
			multi_face_roster_delete_confirm_message:
				"¿Estás seguro de eliminar a {0}? Primero se quitan todas las membresías de listas espejo y luego se elimina la persona entrenada del backend si existe.",
			multi_face_roster_remove_success: "Persona quitada de {0}.",
			multi_face_roster_move_success:
				"Persona movida. La sincronización eliminará de los orígenes actuales y creará en los destinos.",
			multi_face_roster_copy_success:
				"Persona copiada a las listas espejo seleccionadas. Se mantuvieron las membresías actuales de terminales.",
			multi_face_roster_add_to_terminal_success:
				"Persona agregada a las listas espejo seleccionadas. La sincronización creará el usuario en el terminal.",
			multi_face_roster_delete_success:
				"Persona eliminada de listas espejo y del backend cuando correspondía.",
			multi_face_roster_action_error:
				"No se pudo completar la acción sobre la persona.",
			multi_face_roster_terminal_list_missing:
				"No se pudo resolver la lista espejo del terminal.",
			multi_face_roster_person_id_missing:
				"No se pudo resolver el id backend de la persona.",
			multi_face_roster_membership_missing:
				"No se encontró la membresía de lista espejo del terminal.",
			access_control_face_roster_sync_terminal_users:
				"Sincronizar usuarios de la terminal",
			access_control_face_roster_sync_success:
				"Usuarios de la terminal sincronizados.",
			access_control_face_roster_sync_error:
				"No se pudieron sincronizar los usuarios de la terminal.",
			multi_face_roster_detail_title: "Detalle de la persona",
			multi_face_roster_close_detail: "Cerrar detalle",
			multi_face_roster_user_info: "Información del usuario",
			multi_face_roster_name: "Nombre",
			multi_face_roster_status_summary: "Resumen de estado",
			multi_face_roster_present_terminals: "Terminales donde está presente",
			multi_face_roster_events_chart_title: "Eventos de terminal de acceso",
			multi_face_roster_events_chart_subtitle:
				"Eventos diarios de los últimos 30 días",
			multi_face_roster_events_chart_label: "Eventos",
			multi_face_roster_events_total: "{0} evento(s)",
			multi_face_roster_events_loading: "Cargando eventos...",
			multi_face_roster_events_empty:
				"No se encontraron eventos de terminal de acceso en los últimos 30 días.",
			multi_face_roster_events_error:
				"No se pudieron cargar los eventos de esta persona.",
			terminal_face_rule_registered_faces_note:
				"Esta regla usará los rostros registrados en la(s) terminal(es) de acceso seleccionada(s).",
			terminal_face_rule_registered_faces_list:
				"Rostros registrados en la terminal",
			terminal_face_rule_list_required:
				"La terminal facial seleccionada no tiene una lista de rostros registrada que se pueda resolver.",
			require_face_list_or_entity:
				"Las reglas FACE requieren una lista o entidad",
			access_terminal_events: "Eventos de terminal de acceso",
			attributes: "Atributos",
			device_id: "Id. Dispositivo",
			rtsp_address: "Dirección RTSP",
			data: "Datos",
			select_profile: "Seleccionar Perfil",
			sub_stream: "SUB STREAM",
			has_ptz: "PTZ",
			error_get_stream_uri: "Error al obtener URI del stream",
			connection_error: "Error de Conexión",
			camera_error: "Error de Cámara",
			ms_s: "Seleccionar fotos que no entrenarán",
			ms_c: "Esta seguro de los seleccionados?",
			ms_c1: "¿Estás seguro de la nueva contraseña?",
			trained_thumbnail: "Miniatura entrenada",
			confidence: "Confianza",
			number_detecteds: "Número detectado",
			device_options: "Opciones del dispositivo",
			type_devices: "Tipo de dispositivos",
			detection: "Detección",
			evidence: "Evidencia",
			config_device: "Configurar dispositivo",
			rtsp_address: "Dirección RTSP",
			udp_address: "Dirección UDP",
			x: "Posición X",
			y: "Posición Y",
			w: "Ancho",
			h: "Altura",
			stats: "Estadísticas",
			connections: "Conecciones",
			country_config: "Configuracion de país",
			hosts: "Servidores",
			ms_np: "No existe perfil guardado",
			user_list: "Lista de usuarios",
			registered_user: "Usuario registrado",
			super_user: "Super usuario",
			admin: "Administrador",
			operator: "Operador",
			user_role: "Rol del usuario",
			user_data: "Datos del usuario",
			login_data: "Datos de inicio de sesión",
			forgot_psw: "Olvidé mi contraseña",
			recover_psw: "Recuperar contraseña",
			search_name: "Buscar por nombre",
			search_date: "Buscar por fecha",
			search_date_range: "Buscar por rango de fecha",
			resizable: "Redimensionable",
			draggable: "Arrastrable",
			responsive: "Responsivo",
			prevent_collision: "Prevenir colisión",
			static: "Estático",
			vertical_compact: "Compacto vertical",
			detections: "Detecciones",
			welcome: "Bienvenido",
			ms_sd: "Seleccionar plataforma",
			lpr: "LPR",
			face: "Rostro",
			"Face-Access-Terminal": "Face Access Terminal",
			traffic: "TRAFFIC",
			object: "OBJECT",
			user_tracking: "Seguimiento de usuarios",
			daily: "Diario",
			weekly: "Semanal",
			ms_sp:
				"Por favor revisar su correo, se ha enviado un codigo de seguridad.",
			security_code: "Digite codigo de seguridad",
			no_match: "No coinciden",
			match: "Coinciden",
			recovery_process: "Proceso de recuperacion de la contraseña",
			roi: "Area de interes",
			Roi: "Roi",
			top: "Parte superior",
			left: "Izquierda",
			motion_flag: "Bandera de movimiento",
			draw_routes: "Dibujar rutas",
			duration: "Duración",
			fps_top: "Top FPS",
			use_overview: "Usar visión general",
			port: "Puerto",
			ms_del: "¿Estás seguro de eliminarlo?",
			basic_info: "Información básica",
			ip_rest: "IP REST",
			entry_type: "Oroltын төрөл",
			debug: "Depurar",
			speed_sensor: "Sensor de velocidad",
			speed_limit: "Límite de velocidad",
			fps: "FPS",
			plates_proc: "Placas de proceso",
			use_subdet_only: "Use solo subdet",
			recog_all: "Reconocer todo",
			use_cascade: "Usar cascada",
			step_udp_stream: "Paso UDP stream",
			events: "Eventos",
			created_at: "Creado en",
			monthly_events: "Eventos mensuales",
			daily_events: "Eventos diarios",
			status_queue: "Cola de estado",
			total_income: "Ingresos totales",
			news: "Noticias",
			total_onqueue: "Total en cola",
			offline: "Desconectado",
			online: "En línea",
			checking: "Verificando...",
			inputs: "Entradas",
			input: "Entrada",
			relays: "Relés",
			relay_status: "Estado del Relay",
			waiting_relay_data: "Esperando datos del relay...",
			error_loading_relays: "Error al cargar los relays",
			more_details: "En línea",
			details: "Detalles",
			// Compat: algunas vistas usan la clave literal en español
			Detalles: "Detalles",
			// Counter modal
			counter_details: "Detalles del Counter",
			rfid: "RFID",
			photo_segment: "Segmento de foto",
			plate: "Placa",
			list_id: "ID de lista",
			list_name: "Nombre de lista",
			motive: "Motivo",
			creation_date: "Fecha de creación",
			update_date: "Fecha de actualización",
			type: "Tipo",
			description: "Descripción",
			online_events: "Eventos en linea",
			offline_events: "Eventos fuera de linea",
			ms_adh:
				"Seleccione y agregue un nuevo host para iniciar y ver la plataforma", //Para iniciar y visualizar plataformas, seleccionar y agregar nuevo host
			photo: "Foto",
			segment: "Segmento",
			dvr: "DVR",
			// Claves de estado/detalle
			ok: "OK",
			auth_invalid: "Credenciales inválidas",
			device_offline: "La cámara no está encendida o no es accesible",
			manager_id: "ID del gerente",
			add_components: "Agregar componentes",
			lpr_events: "Eventos LPR",
			events_rfid: "Eventos RFID",
			device_list: "Lista de dispositivos",
			drawable_options: "Opciones dibujables",
			grid_options: "Opciones de cuadrícula",
			video_stream: "Video en directo",
			installation_process: "Proceso de instalación",
			match_rules: "Reglas de coincidencia",
			new_match_rule: "Nueva regla de coincidencia",
			select_host_lpr: "Seleccionar host LPR",
			select_host_rfid: "Seleccionar host RFID",
			select_rfid_ant: "Seleccione ANT RFID",
			match_history: "Histórico de coincidencias",
			ant: "Ant",
			epc: "Epc",
			memory_data: "Datos de la memoria",
			rssi: "rssi",
			date_lpr: "Fecha LPR",
			date_rfid: "Fecha RFID",
			host_config_logs: "Registros de configuración del host",
			integration: "Integración",
			manager: "Gerente",
			ip_address: "Dirección IP",
			integration_config: "Configuración de integración",
			cloud_config: "Configuración de CLOUD",
			list: "Listado",
			cloud: "CLOUD",
			config_file: "Ruta de configuración",
			ms_del: "¿Estás seguro de eliminar?",
			deleted: "Eliminado",
			updated: "Actualizado",
			saved: "Guardado", // Salvado
			registered: "Registrado",
			edited: "Editado",
			video_streams: "Transmisiones de video",
			hostname: "Nombre del anfitrión",
			ip: "IP",
			status: "Estado",
			total: "Total",
			onqueue: "En Cola",
			axle: "Eje",
			weight: "Peso",
			number_passenger: "Número de pasajeros",
			payment: "Pago",
			type_encode_media: "Tipo codificar medios",
			type_integrate: "Tipo integracion",
			cancel: "Cancelar",
			select_lane: "Seleccionar carril",
			lane: "Carril",
			add_tariff: "Agregar tarifa",
			tariffs: "Tarifas",
			type_vehicle: "Tipo de vehículo",
			direction: "Dirección",
			type_transport: "Tipo de transporte",
			np_start: "Número de pasajeros comienzan",
			np_end: "Numero de pasajeros final",
			weight_init: "Peso inicial",
			weight_end: "Peso final",
			person: "Persona",
			n_a: "N/A",
			access_control_events: "Eventos de control de acceso",
			access_control_admin: "Administración de control de acceso",
			event_code: "Código de evento",
			user_id: "ID de usuario",
			user_name: "Nombre de usuario",
			access_method: "Método",
			access_method_face_fp_card_pw: "Rostro, huella, tarjeta o contraseña",
			access_status: "Estado de acceso",
			reader_id: "ID de lector",
			door_status: "Estado de puerta",
			device_sn: "Serial del dispositivo",
			snap_path: "Ruta de captura",
			successful_access: "Acceso exitoso",
			access_denied: "Acceso denegado",
			unknown_access: "Evento de acceso desconocido",
			evidence_available: "Disponible",
			no_evidence: "Sin evidencia",
			door_open: "Puerta abierta",
			door_closed: "Puerta cerrada",
			open_door: "Abrir puerta",
			relay_control: "Control de relay",
			card_number: "Número de tarjeta",
			face_image: "Imagen de rostro",
			backend_action:
				"Las acciones se envían solo a endpoints controlados del backend.",
			create_user: "Crear usuario",
			update_user: "Actualizar usuario",
			create_card: "Crear tarjeta",
			update_card: "Actualizar tarjeta",
			remove_card: "Quitar tarjeta",
			upload_face: "Subir rostro",
			update_face: "Actualizar rostro",
			remove_face: "Quitar rostro",
			access_control_unsupported_actions:
				"Crear/actualizar usuarios no se expone porque no está soportado por el contrato backend validado.",
			door_relay_not_validated:
				"Las acciones de puerta y relay no están validadas para este contrato backend y no están disponibles aquí.",
			relay_id: "ID de relay",
			action_sent: "Acción enviada",
			payments: "Pagos",
			ms_sel: "Seleccionar fotos para entrenar",
			folder_name: "Nombre de la carpeta",
			minimum_selected: "Mínimo seleccionado",
			missing_data: "Faltan datos",
			traffic_lights: "Semáforos",
			port_server_modbus: "Servidor de puerto",
			uselanes: "Use carriles",
			use_ocr: "Use OCR",
			laneconfig: "Configuración de carril",
			wb_violation: "Violaciones de Whitebox",
			wb_vio_time: "Tiempo Whitebox",
			quadrants: "Cuadrantes",
			gpu: "GPU",
			uuid: "UUID",
			ms_reset:
				"Los datos actuales se perderán. Excepto información básica. ¿Está seguro de restablecer los datos a los valores predeterminados?",
			lanes_id: "ID de carriles",
			lanes: "Carriles",
			type_lane: "Tipo de carril",
			turns: "Vueltas",
			turn: "Giro",
			street_cam: "Cámara de la calle",
			top_view_cam: "Cámara de la vista superior",
			mapview: "Vista del mapa",
			ms_complet: "Porfavor complete todos los campos",
			alerts: "Alertas",
			ocr_found: "OCR encontrado",
			coord: "Coordenadas",
			speed: "Velocidad",
			speed_limit: "Límite de velocidad",
			size: "Tamaño",
			plate_search: "búsqueda de placas",
			host_id: "ID de Host",
			no_valid: "No es válido",
			invalid_ip: "IP inválida",
			ms_dwh:
				"Dibuje nuevamente o extienda el Roi, las dimensiones del Roi deben exceder más de 0.50 de ancho y 0.10 de altura",
			latitude: "Latitud",
			longitude: "Longitud",
			state: "Estado",
			rtsp_path: "RTSP зам",
			lat: "Lat",
			long: "Long",
			no_data: "Informacion no disponible",
			create_dashboard: "Crear tablero",
			create_dashboard_profile: "Crear perfil de tablero",
			ms_new_dashboard: "Por favor escriba un nombre para el nuevo tablero",
			saved_profile: "Saved profile",
			updated_profile: "Updated profile",
			connection_type: "Connection type",
			ms_sel_type: "Por favor seleccione un tipo",
			ms_name_exist: "Este nombre ya existe, Por favor escriba otro nombre.",
			ms_rename_dashboard:
				"Ingrese un nuevo nombre si desea cambiar el nombre del perfil.",
			update_profile: "Update profile",
			update_dashboard_profile: "Update dashboard profile",
			blacklist: "Lista negra",
			active: "Activo",
			inactive: "Inactivo",
			motive: "Motivo",
			refresh: "Actualizar",
			matches_found: "Resultados encontrados",
			matches_no_found: "Coincidencias no encontrados",
			light: "Claro",
			night: "Noche",
			language: "Idioma",
			language_english: "Inglés",
			language_spanish: "Español",
			language_mongolian: "Mongol",
			gpu_device: "GPU device",
			ocr_port: "OCR port",
			decoding_type: "Decoding type",
			added: "Agregado",
			notifications: "Notificaciones",
			virtual_keyboard: "Teclado virtual",
			records: "Registros",
			limit: "Límite",
			mb: "MB",
			delete_profile: "Borrar perfil",
			lanes_config: "Configuración de carriles",
			location: "Ubicación",
			general_parameters: "Parametros generales",
			number_items: "Numero de articulos",
			no_records_found: "No se encontraron registros",
			records_found: "Registros encontrados",
			plate_chars: "Placa",
			plate_char: "Placa",
			img: "Segmento",
			location_host: "Location",
			expire_date_vehicle_inspection:
				"Inspección del vehículo con fecha de vencimiento",
			point_a: "Point A",
			point_b: "Point B",
			distance: "Distance",
			km_h: "Km / h",
			video_type: "Video type",
			video_stream_type: "Video Streaming Type",
			stream_flv: "FLV",
			stream_ws: "WS-FLV",
			stream_hls: "HLS",
			stream_udp: "UDP",
			data_no_found: "Information not found",
			data_found: "Information found",
			invalid_empty_records: "Invalid or empty record URL",
			ms_sel_dd: "Select a date and device to list",
			udp_connection: "UDP connection",
			stream_element: "Video stream element",
			stream_data: "Video stream data",
			enter_value: "Enter a value",
			connecting: "Connecting",
			reconnecting: "Reconnecting",
			connected: "Connected",
			disconnected: "Disconnected",
			events_received: "Events received",
			alert_sound: "Alert sound",
			sync_alarm_list: "Synchronizing alarm list",
			loading_hosts_list: "Loading hosts list",
			loaded_hosts_list: "Loaded hosts list",
			loading_devices_list: "Loading devices list",
			loaded_devices_list: "Loaded devices list",
			loading_dashboard_profile: "Loading dashboard profile",
			loaded_dashboard_profile: "Loaded dashboard profile",
			loading_dashboard: "Loading Dashboard",
			please_wait: "Please wait...",
			safe_zone: "Safe Zone",
			contact_list: "Contact list",
			telephone: "Teléfono",
			cellphone: "Teléfono móvil",
			alert_sounds_settings: "Alert sounds settings",
			sounds: "Sounds",
			pop_ups: "Pop-ups",
			nvr: "NVR",
			vid_path: "Vid path",
			port_rest: "Port REST",
			type_decoding: "Type decoding",
			motion_threshold: "Motion threshold",
			detection_threshold: "Detection threshold",
			tracker_max_frames: "Tracker max frames",
			obj_to_detect: "Obj to detect",
			detect: "Detect",
			debug: "Debug",
			stream_ip: "Stream IP",
			stream_port: "Stream Port",
			video_source: "Video source",
			reconnecting_ws: "Reconnecting WS in 30 seconds",
			timeout: "Timeout",
			seconds: "Seconds",
			add_device: "Agregar dispositivo",
			ip_cam: "IP CAM",
			constellation: "Constellation",
			streaming: "Video Streaming",
			config: "Config",
			timeline: "Timeline",
			alarms: "Alarms",
			zones: "Zonas",
			areas: "Areas",
			hardware_requirements: "Hardware Requirements",
			demo_version: "Demo version",
			register: "Register",
			zone: "Zone",
			container: "Container",
			path_file: "Path file",
			motion: "Motion",
			anomalies: "Anomalies",
			objects: "Objects",
			human_actions: "Human actions",
			face_recognition: "Face recognition",
			gun: "Gun",
			weapon_detector: "Weapon detector",
			tags: "Tags",
			tag: "Tag",
			categorie: "category",
			sel_new_location: "Select new location",
			my_streaming: "My Streaming",
			stream_ws1: "WS",
			min_alert: "Modo de alerta minimizado",
			map: "Map",
			createdAt: "Created at",
			no_receiving_stream: "No recibo transmisión",
			popup_timeout: "Tiempo vizualizacion de alert",
			alert_time: "Tiempo de alerta",
			sound: "Sonido",
			frequency_smart_event: "Frecuencia Evento Inteligente",
			frequency_smart_event_tooltip:
				"Especifica cada cuánto tiempo se generará el evento inteligente (en minutos). 0 significa que el evento se generará cada vez que se cumpla la condición.",
			smart_event_cooldown_seconds_label: "Tiempo de espera evento/alerta (segundos)",
			frequency: "Frecuencia",
			popup: "Ventana emergente",
			access: "Access",
			prediction: "Prediction",
			folder: "Folder path",
			probability: "Probability",
			hands_up: "Hands up",
			record: "Record",
			timezone: "Timezone",
			select_timezone: "Select timezone",
			protocol: "Protocol",
			protocol_socket: "Protocol Socket",
			ip_socket: "IP Socket",
			port_socket: "Port Socket",
			port_face: "Port Face",
			parameters: "Parameters",
			parameter: "Parameter",
			color: "Color",
			line_width: "Line width",
			playback: "Reproducción",
			alarm: "Alarm",
			monday: "Monday",
			tuesday: "Tuesday",
			wednesday: "Wednesday",
			thursday: "Thursday",
			friday: "Friday",
			saturday: "Saturday",
			sunday: "Sunday",
			interval: "Interval",
			notifiable: "Notifiable",
			send_ws: "Enviar Telegram",
			send_email: "Enviar Email",
			schedule: "Schedule",
			analytic: "Analytic",
			count_device: "Count device",
			alarm_info: "Alarm info",
			capacity: "Capacity",
			minimum_time: "Minimum time",
			channel: "Channel",
			smart_event: "Evento inteligente",
			channels: "Channels",
			ip_stream: "IP stream",
			port_stream: "Port stream",
			ModBus: "ModBus",
			useLanes: "Use lanes",
			laneConfig: "Lane Config",
			port_overview: "Port overview",
			videoEvidence: "Video Evidence",
			videoDuration: "Video Duration",
			use_OCR: "Use OCR",
			lane: "Lane",
			lane1: "Lane 1",
			lane2: "Lane 2",
			lane3: "Lane 3",
			lane4: "Lane 4",
			lane5: "Lane 5",
			lane6: "Lane 6",
			type: "Type",
			type1: "Type 1",
			type2: "Type 2",
			type3: "Type 3",
			type4: "Type 4",
			type5: "Type 5",
			type6: "Type 6",
			turn: "Turn",
			turn1: "Turn 1",
			turn2: "Turn 2",
			turn3: "Turn 3",
			turn4: "Turn 4",
			turn5: "Turn 5",
			turn6: "Turn 6",
			statistics: "Statistics",
			analytics: "Analytics",
			analytics_logs: "Analytics logs",
			recording: "Recording",
			on: "ON",
			off: "OFF",
			table_no_exist: "This table not exist",
			table_no_enable: "This table not enabled",
			clear_console: "Clear console",
			novideo_source: "Video source",
			app_full_frame: "App full frame",
			frame_resize_width: "Frame resize width",
			frame_resize_height: "Frame resize height",
			max_object_size: "Max object size",
			redis_port: "Redis port",
			motion_method: "Motion method",
			jump_n_frames_for_proccess: "Jump n frames for procces",
			draw: "Draw",
			DO_MOTION: "Hacer movimiento",
			display_by_analytics: "Display by analytics",
			rest_ip: "Rest IP",
			rest_port: "Rest port",
			roi1: "ROI1",
			roi2: "ROI2",
			rtsp: "RTSP",
			rtsp2: "RTSP2",
			deviceId: "Device ID",
			redis_ip: "Redis IP",
			settings_smart_event: "Configurar evento inteligente",
			entry_type: "Entry type",
			white_box_limits: "White box limits",
			gpu_device: "GPU device",
			lists: "Listas",
			new_list: "New list",
			listing_setting: "Listing configuration",
			listing_details: "Listing details",
			registered_list_details: "Registered listing details",
			require_sel_list: "Required select a list",
			registered_integrations: "Registered integrations",
			video_segments: "Video segments",
			mode: "Mode",
			manage: "Administrar",
			AG_REDIS_111:
				"Se encontró un problema con el inicio de un servicio, comuníquese con el soporte",
			technical_records: "Technical records ",
			AG_BK_RECORD_001: "La cámara comenzó a grabar",
			AG_BK_RECORD_002: "En este momento la cámara no está grabando",
			AG_BK_RECORD_003: "La cámara no está grabando, tratando de reiniciarla ", //'La cámara intenta reiniciar la grabación',
			AG_BK_RECORD_000: "La cámara esta grabando",
			section: "Sección",
			alert: "Alerta",
			AG_BK_DISK_001:
				"Disco no encontrado, comience con un disco predeterminado",
			AG_BK_DISK_007: "Disco creado por defecto",
			AG_BK_DISK_011: "Disk error in create by default",
			AG_DEV_002: "Error with device",
			AG_DEV_005: "Please check the device",
			not_permissions: "You do not have permissions",
			activate: "Activate",
			confirm_upgrade: "Confirm upgrade",
			AG_BK_GPS_017: "Not receiving coordinates, out of coverage",
			req_sel_device: "Required : Select device ",
			scale: "Plate",
			Scale: "Scale",
			smart_reports: "Smart Event Report",
			no_info_page: "No information found on this page",
			no_found_page: "Page not found",
			registered_smart_event: "Eventos inteligentes registrados",
			registered_devices: "Dispositivos registrados",
			support: "Support",
			notifications_technical: "Notifications technical",
			profiles_default: "Default profiles",
			dashboards: "Dashboards",
			components: "Components",
			select_dates: "Select dates",
			req_sel_analitic: "Required select a analytic",
			no_res_server: "No response from the server",
			req_sel_analytic_tag: "Required select a analytic and tag",
			bike: "Bike",
			bus: "Bus",
			truck: "Truck",
			car: "Car",
			laptop: "Laptop",
			motorcycle: "Motorcycle",
			area_interest: "Area of interest",
			motorbike: "Motorbike",
			suggested_timezone: "Suggested time zone",
			registered_zones: "Registered zones",
			select_zone: "Select zone",
			type_zone: "Type zone",
			background_image: "Background image",
			sync_blacklist: "Sync blacklist",
			sync_cloud: "Sync with Cloud",
			upload_imagen: "Upload imagen",
			req_name_file_upload: "Required zone name or File for upload",
			uploaded_image: "Uploaded image",
			bbox: "",
			bbox_: "Bounding box",
			tag_count: "Tag count",
			list_id: "List Id",
			entity: "Entity",
			click_test_video: "Click to test video",
			select_record_rtsp: "Select to record this RTSP",
			disk: "Disk",
			disks: "Disks",
			registered_disks: "Registered disks",
			required_range_24h: "Required range 24 hours",
			no_found_id_del: "Not found ID of item to delete",
			not_found: "Not found",
			not_found_propierties: "Not found properties",
			delete_shape: "Delete shape",
			new_shape: "New shape",
			registered_lists: "Registered lists",
			not_found_device: "Not found device",
			not_found_tag: "Not found tag",
			owner: "Owner",
			visitor: "Visitor",
			current_photo: "Current photo",
			trained_photo: "Trained photo",
			registering_user: "Registering user",
			role_not_valid: "Role selected not valid",
			role: "Role",
			invalid_password: "Invalid password",
			required: "Required",
			whatsapp: "Whatsapp",
			enable: "Enable",
			url: "URL",
			import: "Import",
			export: "Exportar",
			registered_schedules: "Registered Schedules",
			confirm_reset: "Confirm reset",
			fail_down_video: "Failed to download video",
			video_down_not_found: "Video to download not found",
			download: "Download",
			current_page: "Current page",
			current_videos: "Current videos",
			all: "All",
			select_videos: "Select videos",
			select_items: "Select items",
			media_path: "Media path",
			server_ip: "Server IP",
			server_port: "Server Port",
			poligons: "Polygons",
			code: "Code",
			module: "Module",
			detail: "Detail",
			req_id_del: "Requires ID to remove",
			req_created_devices: "Requires created devices",
			timelapse: "Time lapse",
			min_6_characters: "Min 6 characters",
			valid: "Valid",
			confirmed: "Confirmed",
			and_reseted: "And reestablished",
			reseted: "Reseted",
			change_password: "Change Password",
			new_zone: "New zone",
			zone_settings: "Zone settings",
			discovered_devices: "Discovered devices",
			clear_logs: "Clear logs",
			restart: "Restart",
			restarted: "Restarted",
			start: "Start",
			started: "Started",
			stop: "Stop",
			stopped: "Stopped",
			store_chunks: "Store chunks",
			video_size_factor: "Video size factor",
			is_record: "Is Record",
			channel_record: "Channel record",
			registered_colors_bbox: "Registered colors Bbox",
			registered_sounds: "Registered sounds",
			logo: "Logo",
			logos: "Logos",
			registered_faces: "Registered FACEs",
			view_grid: "View grid",
			view_list: "View list",
			xaddr: "Xaddr",
			updatedAt: "Update at",
			delete_devices: "Delete devices",
			backup: "Backup",
			restore_backup: "Restore from backup",
			ms_dashboard_empty: "Dashboard empty, Please add components",
			used: "Used",
			space: "Space",
			waiting: "Waiting",
			waiting_: "Waiting...",
			AG_BK_RECORD_004: "RTSP NULL, Required set a RTSP",
			max_buffer: "Max buffer",
			amount_to_delete: "Amount to delete",
			limit_erased_recording: "Limit erasure of recording",
			limit_erased_evidences: "Limit erasure of evidences",
			percent_limit_del_evidences: "Disk % to start deleting evidences",
			rtsp_timeout: "RTSP timeout (s)",
			storage: "Storage",
			AG_BK_RETRASMISSION_004: "Closed retrasmission",
			AG_BK_PING_DEVICE_000: "Ping the device in good condition",
			AG_BK_PING_DEVICE_001: "Device ping delaying",
			AG_BK_PING_DEVICE_002: "Ping with device not detected",
			AG_BK_RETRASMISSION_002: "Error with retransmission",
			AG_BK_PING_NETWORK_000: "Ping the Network in good conditions",
			AG_BK_PING_NETWORK_002: "Ping with Network not detected",
			AG_BK_DISK_000: "Disk in good condition.",
			AG_BK_DISK_002: "Disk storage out of limit",
			video_evidence: "Video evidence",
			PDF: "PDF",
			"Video Evidence": "Video Evidence",
			barcode_not_found: "Barcode not found for this event",
			AG_BK_RETRASMISSION_000: "Retransmission in good connection",
			AG_BK_RETRASMISSION_001: "Reconnecting relay",
			computer: "Computer",
			device_ping: "Device ping",
			retransmission: "Retransmission",
			confirm_logout: "Are you sure logout",
			AG_BK_RTSP_000: "Video streaming it's working",
			AG_BK_RTSP_002: "Fail to get video streaming",
			workspace: "Workspace",
			only_fails: "Only fails",
			select_retransmission: "Post Broadcast Video",
			port_socket_msg: "Add if IP address contains port",
			name_cloud_msg: "It is to identify Workspace",
			registered_workspaces: "Registered Workspaces",
			more_options: "More options",
			download_pdf: "Download PDF",
			download_excel: "Download EXCEL",
			hide_filters: "Hide filters",
			show_filters: "Show filters",
			redirect_reports: "Redirect to reports",
			select_tags: "Select tags",
			ignore: "Ignore",
			send: "Send",
			confirm_options: "Confirm options",
			magament_incidents: "Management of incidents",
			type_peripheral: "Type Peripheral",
			new_peripheral: "New Peripherals",
			pin: "Pin",
			type_device: "Tipo de dispositivo",
			access_control: "Control de acceso",
			access_control_vendor: "Marca",
			access_control_integrated_model: "Modelo integrado",
			access_control_vendor_fallback: "No se pudieron cargar las marcas desde el servidor. Se usarán opciones locales temporales.",
			access_control_models_unavailable: "No se pudieron cargar los modelos integrados. Podés escribir el modelo manualmente y continuar.",
			access_control_model_manual_hint: "Si la lista no está disponible, escribí el modelo integrado manualmente.",
			access_control_vendor_required: "Seleccioná la marca de la terminal antes de continuar.",
			access_control_model_required: "Seleccioná o escribí el modelo integrado antes de continuar.",
			access_control_terminal_required: "Completá nombre, IP, usuario y clave antes de continuar.",
			access_control_probe_terminal: "Detectar información de la terminal",
			access_control_probe_running: "Detectando información de la terminal...",
			access_control_probe_success: "Información de la terminal detectada.",
			access_control_probe_unavailable: "No se pudo detectar la información de la terminal. Podés continuar manualmente.",
			access_control_server_location_loaded: "Ubicación del servidor cargada por defecto. Podés ajustarla en el mapa.",
			access_control_server_location_unavailable: "No se pudo cargar la ubicación del servidor. Seleccioná la ubicación manualmente en el mapa.",
			access_control_rtsp_url: "URL RTSP del video",
			access_control_rtsp_preview: "Vista previa RTSP",
			access_control_rtsp_preview_help: "Usa el mismo flujo de prueba RTSP del registro de cámaras. Si el navegador no puede reproducirlo directamente, conservá la RTSP y continuá.",
			access_control_rtsp_required: "La URL RTSP es requerida",
			access_control_rtsp_invalid: "La URL RTSP debe iniciar con rtsp://",
			access_control_rtsp_preview_unavailable: "La vista previa RTSP no está disponible con la ruta de video actual. Podés seguir editando el formulario.",
			access_control_rtsp_backend_dependency: "Guardar RTSP requiere soporte del backend. Guardá sin RTSP o actualizá la dependencia del backend.",
			access_control_backend_device_id_contract: "El backend debe generar deviceId automáticamente. La validación actual del backend lo está exigiendo incorrectamente.",
			access_control_step_vendor_title: "Elegí la marca",
			access_control_step_vendor_help: "Empezá seleccionando la marca de la terminal soportada por la integración.",
			access_control_step_model_title: "Elegí el modelo",
			access_control_step_model_help: "Seleccioná el modelo integrado disponible para la marca elegida.",
			access_control_step_terminal_title: "Datos de la terminal",
			access_control_step_terminal_help: "Ingresá nombre, IP, usuario, clave y serial. El sistema intentará detectar información automáticamente.",
			access_control_step_video_title: "Video y RTSP",
			access_control_step_video_help: "Agregá o probá la URL RTSP asociada a la cámara de la terminal.",
			access_control_step_location_title: "Ubicación de la terminal",
			access_control_step_location_help: "Confirmá la ubicación por defecto del servidor o seleccioná otro punto en el mapa.",
			drag_drop_audio: "Arrastrar y soltar audio",
			invalid_audio_file: "Solo se permiten archivos de audio.",

			action_device_empty_actions: "No hay acciones configuradas para mostrar.",
			action_device_details_toggle: "Ver detalles completos",
			action_device_default_title: "Acción configurada",
			action_device_type_unknown: "Tipo no definido",
			action_device_type_peripheral: "Periférico",
			action_device_type_access_control: "Control de acceso",
			action_device_type_device: "Cámara / dispositivo",
			action_device_type_system: "Sistema",
			action_device_condition_success: "cuando sea exitoso",
			action_device_condition_failure: "cuando falle",
			action_device_selected_device_fallback: "dispositivo seleccionado",
			action_device_sound_fallback: "sonido configurado",
			action_device_sentence_play_audio: "Reproducir",
			action_device_sentence_on: "en",
			action_device_sentence_snapshot: "Tomar una foto en",
			action_device_sentence_record: "Grabar video en",
			action_device_sentence_webhook: "Enviar aviso a una URL externa",
			action_device_sentence_smart_event: "Cambiar el estado de un evento inteligente",
			action_device_detail_condition: "Condición",
			action_device_detail_sound_value: "Sonido / valor",
			action_device_description_placeholder: "Sonido de bienvenida",
			action_device_action_play_audio: "Reproducir audio",
			action_device_action_send_value: "Enviar estado al relay",
			action_device_action_snapshot: "Tomar foto",
			action_device_action_record: "Grabar video",
			action_device_action_webhook: "Aviso a URL externa",
			action_device_action_blink: "Parpadear",
			action_device_action_ring: "Sonar",
			action_device_action_change_smart_event_status: "Cambiar estado de evento inteligente",
			action_device_action_connect: "Conectar",
			action_device_action_start_counter: "Iniciar contador",
			action_device_action_end_counter: "Finalizar contador",
			action_device_assistant_intro:
				"Seguí estos pasos para indicar qué hace la acción, dónde se ejecuta y cuándo debe activarse.",
			action_device_step_identify_title: "Identificá esta acción",
			action_device_step_identify_help:
				"Usá un nombre corto que el operador pueda reconocer después. Ejemplo: Sonido de bienvenida.",
			action_device_step_target_title: "Elegí dónde se ejecuta",
			action_device_step_target_help:
				"Seleccioná el tipo de equipo, el dispositivo y la acción que se realizará.",
			action_device_step_config_title: "Configurá lo que hará",
			action_device_step_config_help:
				"Acá solo aparecen los campos necesarios para la acción seleccionada.",
			action_device_step_timing_title: "Elegí cuándo se ejecuta",
			action_device_step_timing_help:
				"Definí si se activa cuando la alarma sea exitosa, falle o cambie un evento.",
			action_device_label_relay_channel: "Canal del relay",
			action_device_label_relay_state: "Estado del relay",
			action_device_label_start_wait: "Espera antes de ejecutar",
			action_device_label_active_duration: "Tiempo activo",
			action_device_label_when: "¿Cuándo debe ejecutarse?",
			action_device_help_description:
				"Este nombre es para el operador. Ayuda a reconocer la acción sin leer valores técnicos.",
			action_device_help_type:
				"Elegí la familia del equipo: cámara, periférico, control de acceso o sistema.",
			action_device_help_device:
				"Elegí el dispositivo físico donde se ejecutará esta acción.",
			action_device_help_action:
				"Elegí qué debe hacer el sistema con el dispositivo seleccionado.",
			action_device_help_destiny:
				"Elegí quién recibe o utiliza el resultado de esta acción.",
			action_device_help_sound:
				"Elegí el audio que se reproducirá en el terminal seleccionado.",
			action_device_help_sound_file:
				"Subí un audio nuevo si todavía no aparece en la lista.",
			action_device_help_delay:
				"Tiempo que se mantendrá activa antes de volver a su estado inicial.",
			action_device_help_seconds:
				"Tiempo que debe esperar el sistema antes de empezar a ejecutar la acción.",
			action_device_help_relay_channel:
				"Canal del relay que se controlará en el periférico.",
			action_device_help_relay_state:
				"Estado que tendrá el canal del relay: ON u OFF, según la configuración del dispositivo.",
			action_device_help_frequency:
				"Cantidad de repeticiones o frecuencia de ejecución, cuando el dispositivo lo soporte.",
			action_device_help_ring_action:
				"Elegí si el sonido debe iniciar o detenerse.",
			action_device_help_ring_file:
				"Elegí el archivo de sonido guardado en el periférico.",
			action_device_help_ring_mode:
				"Elegí cómo debe reproducir el sonido el periférico.",
			action_device_help_count:
				"Cantidad de veces que debe repetirse la acción.",
			action_device_help_volume: "Nivel de volumen para la acción de sonido.",
			action_device_help_smart_event:
				"Evento inteligente que será activado, desactivado o modificado por esta acción.",
			action_device_help_active_on:
				"Elegí si esta acción corre cuando la alarma sea exitosa o cuando falle.",
			medium: "Medium",
			test_peripheral: "Test peripheral",
			roles: "Roles",
			registered_roles: "Registered Roles",
			permissions: "Permissions",
			registered_permissions: "Registered permissions",
			add: "Add",
			view: "View",
			can_add: "Can add",
			can_view: "Can View",
			can_edit: "Can edit",
			can_update: "Can update",
			serial: "Serial",
			action: "Action",
			value: "Value",
			delay: "Delay",
			incident: "Incident",
			incidents: "Incidents",
			new_incident: "New incident",
			table: "Table",
			none_selected: "None selected",
			draw_detected_area: "Draw detected area",
			resource: "Resource",
			resources: "Resources",
			registered_resources: "Registered resources",
			managers: "Managers",
			parking: "Parqueadero",
			information: "Information",
			exit: "Exit",
			entry: "Entry",
			invoice: "Invoice",
			barcode: "Barcode",
			loading_states: "Loading states",
			loading: "Loading",
			total_invoice: "Total invoice",
			invoice_counter: "Invoice counter",
			id_invoice: "ID invoice",
			consecutive: "Consecutive",
			void: "Void",
			iva: "Iva",
			subtotal: "Subtotal",
			total_charge: "Total charge",
			workspaces: "Espacios de trabajo",
			domain: "Domain",
			counter: "Counter",
			last_update: "Last update",
			not_recording: "Is not recording",
			it_being_recorded: "It's already being recorded",
			your_browser_not_req:
				"Your web browser does not meet the requirements; please upgrade to a decent browser like firefox or google chrome",
			no_devices: "No devices",
			start_recording: "Start recording",
			stop_recording: "Stop recording",
			microphone_selection: "Microphone selection",
			device_selection: "Device Selection",
			audio: "Audio",
			valid_name_without_cs: "Valid name without special characters",
			current_password: "Current password",
			define_new_password: "Define new password",
			contacts: "Contactos",
			new_contact: "New contact",
			registered_contacts: "Registered contacts",
			send_telegram: "Send Telegram",
			telegram: "Telegram",
			settings_contact: "Settings contact",
			contact: "Contact",
			your_pws_has_changed: "Your password has been changed successfully",
			manual_confirmation: "Manual confirmation",
			type_of_contact: "Type of contact",
			final_client: "Final client",
			alert_monitor: "Alert monitor",
			require_confirmation: "Require confirmation",
			confirm_alert: "Confirm alert",
			close_descriptions: "Close descriptions",
			create_motion: "Create Motion",
			confirmed_date: "Confirmed date",
			confirmed_alert: "Confirmed alert",
			not_confirmed: "Not confirmed",
			alarm_name: "Alarm name",
			address: "Address",
			date_birth: "Date of Birth",
			profiles: "Perfiles",
			new_profile: "New profile",
			registered_profiles: "Registered profiles",
			client: "Client",
			other: "Other",
			external_customer: "External customer",
			get_arduinos: "Get arduinos",
			get_devices: "Get devices",
			arduino: "Arduino",
			page_not_found: "Page not found",
			redirecting_page: "Redirecting page",
			select_dashboard: "Select a Dashboard",
			"": "",
			is_motion: "Is motion",
			video_for_display: "Video for display",
			cropping_faces: "Cropping faces",
			"hand-up": "Hands up",
			detected: "Detected",
			all: "All",
			event: "Event",
			not_tagged: "Not tagged",
			telegramAPI: "Telegram API",
			name_guardian: "Name GUARDIAN",
			uuid_guardian: "UUID Guardian",
			broker_password: "Broker Password",
			broker_username: "Broker Username",
			broker_address: "Broker Address",
			broker_port: "Broker Port",
			route: "Route",
			component: "Component",
			api: "API",
			// CitizenFace API translations
			citizen_title: "Ciudadano",
			citizenface_api_integration: "Integración CitizenFace API",
			citizen_query_title: "Consulta de Ciudadano - CitizenFace API",
			citizen_id_label: "ID del Ciudadano",
			citizen_id_placeholder: "Ej: CO8709023T63",
			citizen_id_required: "El ID es requerido",
			citizen_id_required_integration:
				"ID del ciudadano es requerido y la integración debe estar configurada",
			consult: "Consultar",
			query_result_title: "Resultado de la Consulta",
			endpoint: "Endpoint",
			not_configured: "No configurado",
			citizen_query_success: "Consulta realizada exitosamente",
			citizen_query_error: "Error al consultar el ciudadano",
			add_unlisted_resources: "Add unlisted resources",
			not_found_items_add: "Not found items to add",
			new_resource: "New resource",
			add_unlisted_permissions: "Add unlisted permissions",
			req_id_to_update: "Requires ID to update",
			req_id_to_update_list: "Id required to update listing",
			knife: "Knife",
			default: "Registrado",
			google_analytic_id: "Google analytic ID",
			add_permission: "Add permission",
			can_delete: "Can delete",
			no_have_permission_create: "You do not have permissions to create",
			no_have_permission_edit: "You do not have permissions to edit",
			no_have_permission_view: "You do not have permission to view",
			no_have_permission_delete: "You do not have permissions to delete",
			setting_device: "Device setting ",
			setting_analytic: "Analytic setting",
			not_allowed_on_sight: "Not allowed on sight",
			devices: "Devices",
			server_rtsp: "RTSP server",
			parked: "Parked",
			overpaid_parking: "Overpaid parking",
			processed_entries: "Processed entries",
			paid: "Paid",
			unpaid: "Unpaid",
			paid_by_post: "Paid by post",
			whitelist: "Whitelist",
			others: "Others",
			trained: "Personas Registradas",
			seleccion_files_to_train: "Selección de archivos para entrenar",
			number_trained: "Número entrenado",
			trained_user: "Trained User",
			avc: "AVC",
			vehicle_type: "Tipo vehículo",
			axle_counter: "Axle counter",
			lifted_axles: "Lifted axles",
			axle_count: "# Ejes",
			required_select_analytic: "Required select a analytic",
			date_of_admission: "Date of admission",
			entry_module: "Entry module",
			entry_type: "Entry type",
			departure_date: "Departure date",
			exit_module: "Exit module",
			exit_type: "Exit type",
			rate: "Rate",
			tax: "Tax",
			payment_method: "Payment method",
			bill_number: "Bill number",
			is_created_automatically: "is created automatically",
			similar_face: "Similar face",
			face_detected: "Face detected",
			faceUUID: "faceUUID",
			similarity_information: "Similarity information",
			alert_information: "Alert information",
			face_detected_information: "Face detected information",
			file: "File",
			files: "Files",
			ip_machine: "IP Machine",
			image: "Image",
			workstation: "Workstation",
			workstations: "Workstations",
			filters: "Filters",
			isignored: "Is ignored",
			option: "Option",
			false_positive: "False positive",
			ignore_alert: "Ignore alert",
			edit_map_name: "Edit map name",
			map_name: "Map name",
			zoom: "Zoom",
			zoom_in: "Zoom in",
			zoom_out: "Zoom out",
			zoom_with_alerts: "Zoom with alerts",
			destiny: "Destiny",
			monitor: "Monitor",
			zoom_in_alerted: "Zoom in when alerted",
			zoom_out_after_alerted: "Move away after alert",
			clean_dashboard: "Clean Dashboard",
			is_incident: "Is incident",
			type_incident: "Type incident",
			evnt_type: "Event type",
			time_to_previous_state: "Time to previous state",
			confirmed_alert: "Confirmed alert",
			automatic_activation: "Automatic activation",
			ignored_alert: "Ignored alert",
			unconfirmed_alert: "Unconfirmed alert",
			deleting_dashboard: "Deleting Dashboard",
			site: "Site",
			Sera4: "Sera4",
			alert_display_time: "Alert display time",
			endpoint: "Endpoint",
			working: "Working",
			restarting: "Restarting",
			AG_BK_RTSP_102:
				"No response from rtsp, check connection with video or transmitter", //,"No response from the server",
			AG_BK_RTSP_112: "Server saturated with requests",
			msg_local_rtsp: "Local RTSP is used in record, analytics and broadcast",
			msg_hls: "RTSP for video in HLS format",
			AG_BK_RTSP_122: "The RTSP is invalid, check it",
			AG_BK_RTSP_132: "Stream verification timed out",
			AG_BK_RTSP_133: "Network is unreachable for Video Streaming",
			"AG_BK_RETRASMISSION_00-1": "Starting video streaming",
			"AG_BK_RECORD_00-1": "Starting recording",
			google: "Google",
			//local
			AG_BK_RETRASMISSION_LOCAL_000:
				"Publishing transmission to internal server status : ON",
			AG_BK_RETRASMISSION_LOCAL_001:
				"Publishing transmission to internal server status : Rebooting",
			"AG_BK_RETRASMISSION_LOCAL_00-1":
				"Publishing transmission to internal server status : Loading",
			AG_BK_RETRASMISSION_LOCAL_002:
				"Publishing transmission to internal server status : Error",
			AG_BK_RETRASMISSION_LOCAL_004:
				"Publishing transmission to internal server status : OFF",
			// cloud
			AG_BK_RETRASMISSION_CLOUD_000:
				"Publishing transmission to cloud status : ON",
			AG_BK_RETRASMISSION_CLOUD_001:
				"Publishing stream to cloud status : Rebooting",
			"AG_BK_RETRASMISSION_CLOUD_00-1":
				"Publishing stream to cloud status : Loading",
			AG_BK_RETRASMISSION_CLOUD_002:
				"Publishing stream to cloud status : Error",
			AG_BK_RETRASMISSION_CLOUD_004:
				"Publishing transmission to cloud status : OFF",
			side: "Side",
			way: "Way",
			"AG_BK_RTSP_00-1": "Loading transmission status",
			AG_BK_RETRASMISSION_003: "Video retransmission status: Flashing",
			AG_BK_RETRASMISSION_LOCAL_003:
				"Publishing transmission to internal server status : Flashing",
			AG_BK_RETRASMISSION_CLOUD_003:
				"Publishing transmission to cloud status : Flashing",
			error_get_counter_list: "Error getting list of counters",
			rules: "Reglas",
			required_register_one_rule: "Debe registrar al menos una regla",
			rules_registered: "Reglas registradas",
			devices_registered: "Dispositivos registrados",
			rules_required_register: "Debe registrar reglas",
			actions_registered: "Acciones registradas",
			devices_required_register: "Debe registrar dispositivos",
			actions_required_register: "Debe registrar acciones",
			terms: "Condiciones",
			comply_with_any_rule: "Cumplir cualquier regla",
			follow_all_rules: "Aplicar todas las reglas",
			description_follow_all_rules:
				"With this option active, all the rules must be met to notify",
			description_comply_any_rules:
				"This active option allows any of the rules to be fulfilled to notify",
			time_automatic_closing: "Time for automatic closing",
			plate_outside_allowed:
				"Plate outside the allowed limit, it is recommended not to exceed 0.20",
			select_all: "Select All",
			trained_faces: "Trained faces",
			hour: "Hour",
			evidence_link: "Evidence link",
			unable_to_send_event_id_not_found:
				"Unable to send report, event ID not found",
			export_all: "Export all",
			consultation_date: "Consultation date",
			date_range: "Date range",
			preparing: "Preparing",
			preparing_to_export: "Preparing to export",
			consulting_information: "Consulting information",
			adding_to_excel: "Adding to excel",
			downloading_report: "Downloading report",
			finalized: "Finalized",
			edit_zone: "Edit zone",
			edited_area: "Edited area",
			auto_zone: "Auto zone",
			method: "Method Request",
			find_location: "Find Location",
			getting_location: "Getting location",
			geolocation_not_supported: "Geolocation not supported by this browser.",
			enable_browser_permissions: "Enable browser permissions",
			closing_session: "Closing session",
			closed_session: "Closed session",
			device_status: "Device status",
			device_disconnected: "Device disconnected",
			technical_status: "Technical status",
			initializing: "Initializing",
			activate_minimize_alert: "Activate to minimize alert",
			disable_maximize_alert: "Disable to Maximize alert",
			minimized: "Minimized",
			maximized: "Maximized",
			option_to_export:
				"This option export to Excel the analytics : lpr, alarms, smart Event, face, objects.",
			warning_more_time: "Warning: it will take more time",
			no_pending_notifications: "There are no pending notifications",
			helmet: "Helmet",
			no_helmet: "No helmet",
			box: "Box",
			icon: "Icon",
			registered_tags: "Registered tags",
			press_enter_add_analytic: "Press enter to add analytics",
			click_here_add_analytics: "Click here to add analytics",
			tag_created: "Tag Created",
			tag_updated: "Tag Updated",
			tag_deleted: "Tag Deleted",
			creating_tag: "Creating Tag",
			updating_tag: "Updating Tag",
			deleting_tag: "Deleting Tag",
			analytics_created: "Analytics Created",
			analytics_updated: "Analytics Updated",
			analytics_deleted: "Analytics Deleted",
			creating_analytics: "Creating Analytics",
			updating_analytics: "Updating Analytics",
			deleting_analytics: "Deleting Analytics",
			load_default_tag_analytics: "Load Default Tags and Analytics",
			actionsRing: "Action Ring",
			count: "Count",
			volumen: "Volumen",
			multiple: "Multiple",
			once: "Once",
			system: "System",
			peripheral: "Peripheral",
			typeAction: "Type action",
			change_smart_event_status: "Change Smart Event status",
			optimize_tracker: "Optimize tracker",
			already_exist_plate:
				"Esta placa ya está registrada en la lista seleccionada.",
			start_time: "Hora de Inicio",
			end_time: "Hora de Fin",
			end: "Fin",
			group: "Grupo",
			density: "Densidad",
			peak_time: "Hora Pico",
			object_types: "Tipos de Objetos",
			Iframe: "Iframe",
			register_events: "Registrar Eventos",
			technical: "Tecnico",
			peripherals: "Periférico",
			audios: "Audios",
			already_exist_component_dashboard:
				"Ya existe este componente en la plataforma",
			when_no_option_selected_dashboard:
				"Cuando no seleccionar ninguna opcion, se carga ultimo panel por default",
			profile_already_up_to_dashboard:
				"Este perfil ya ha sido cargado a la Plataforma",
			powered_by: "Desarrollado por",
			version: "Versión",
			rois_number: "Rois number",
			copy_behavior_to: "Copy behavior to",
			see_more: "See more",
			less_details: "Less details",
			historical_asset: "Historical asset",
			error_validating_images: "Error validating images",
			face_photo_valid: "The photo is valid for facial recognition",
			face_photo_invalid: "The photo is not valid for facial recognition",
			face_validation_pending: "Facial-recognition validation is pending",
			face_analytics_inactive: "FACE analytics is not active",
			face_validation_cleanup_pending:
				"The photo is valid; background processing is still pending",
			trained_face_capture_camera: "Camera",
			trained_face_capture_registered: "Registered camera",
			trained_face_capture_facing_user: "Front",
			trained_face_capture_facing_environment: "Back",
			trained_face_capture_start_preview: "Start preview",
			trained_face_capture_action: "Capture",
			trained_face_capture_no_preview:
				"No browser preview is available for this registered camera. Upload remains available as a fallback.",
			trained_face_capture_unsupported:
				"Browser camera access is not supported by this browser",
			trained_face_capture_requires_secure_context:
				"Camera access requires HTTPS or localhost. Open this page over HTTPS, use localhost during development, or upload an image instead.",
			trained_face_capture_not_ready: "Camera preview is not ready",
			trained_face_capture_stop_preview: "Stop preview",
			trained_face_capture_stream_unavailable:
				"Registered camera stream could not start. Upload remains available as a fallback.",
			trained_face_capture_stream_timeout:
				"Registered camera stream timed out. Start preview again or upload an image instead.",
			trained_face_capture_snapshot_failed:
				"Registered camera snapshot failed. Try again or upload an image instead.",
			trained_face_capture_auth_preview_fallback:
				"Authenticated live preview is not available in this browser yet. Capture still uses the secure backend snapshot.",
			trained_face_capture_load_cameras_failed:
				"Could not load registered cameras. Upload remains available as a fallback.",
			trained_face_capture_error_503:
				"Camera stream is not available right now. Verify the camera is online or try another camera.",
			trained_face_capture_error_502:
				"Snapshot or stream could not be captured. Try again or check the camera connection.",
			trained_face_capture_error_403:
				"Your session is not authorized to use this camera. Refresh the page or log in again.",
			trained_face_capture_error_404:
				"Camera stream session was not found. Restart preview and try again.",
			trained_face_capture_error_network:
				"Backend or camera service is not reachable. Check the connection and try again.",
			trained_face_validation_error_503:
				"Face validation service is not available right now. Verify the camera or validation service connection and try again.",
			trained_face_validation_error_502:
				"Face validation service could not process the image. Try again with another photo.",
			trained_face_validation_error_403:
				"Your session expired or is not authorized. Refresh the page or log in again.",
			trained_face_validation_error_network:
				"Backend or validation service is not reachable. Check the connection and try again.",
			trained_face_validation_error_generic:
				"Could not validate the image. Try again with another photo.",
			trained_face_save_error_generic:
				"Could not save the trained face. Try again.",
			trained_face_list_assignment_title: "Assign to face lists",
			trained_face_list_required:
				"Choose at least one face list before saving.",
			trained_face_list_empty:
				"No face lists yet. Create one here to continue.",
			trained_face_list_create_label: "New list name",
			trained_face_list_create_action: "Create list",
			trained_face_list_assignment_pending:
				"Face saved, but list assignment is still pending. Retry list assignment before considering it complete.",
			trained_face_list_assignment_retry: "Retry assignment",
			invalid_images: "Invalid images",
			validated_images: "Validated images",
			"Cant find face in input": "Cant find face in input",
			search_by_video_face: "Buscar por video",
			upload_video: "Upload Video",
			upload_images: "Upload Images",
			results: "Results",
			analyze_video: "Analyze Video",
			video_database: "Video Database",
			video: "Video",
			range: "Range",
			captured_image: "Captured image",
			error_reading_video: "Error reading video",
			select: "Select",
			deselect: "Deselect",
			table: "Table",
			grid: "Grid",
			time: "Time",
			similarity: "Similarity",
			see: "See",
			uploading_video: "Uploading video",
			analyzing_video: "Analyzing video",
			analysis_completed: "Analysis completed",
			successfully: "Successfully",
			unsuccessfully: "Unsuccessfully",
			activeOn: "Active on",
			you_are_already_using_profile: "You are already using this profile",
			no_similarity_found: "No similarity found",
			error_uploading_video_face: "Error loading video. Please try again",
			selection_successfully: "Selection made successfully",
			face_needs_selected:
				"You need to select or import a face. Check and then perform the search",
			now_you_can_perform_search: "Now you can perform the search",
			highest_similarity: "Highest similarity",
			have_been_registered: "Have been registered: ",
			have_not_been_registered: "Have not been registered: ",
			face_already_registered_in_list:
				"The face is already registered in the list.",
			face_selection_required: "Face selection required",
			cuts: "Cuts",
			face_selected: "Face selected",
			video_clipping: "Video clipping",
			no_data_found_face_search: "No data found for the face search",
			cropImage: "Crop image",
			enableCropImage: "Enable image cropping",
			disableCropImage: "Disable image cropping",
			play: "Play",
			pause: "Pause",
			draw_box_over_area_captured: "Draw a box over the area to be captured",
			waiting_for_data: "Waiting for data",
			error_loading: "Error loading",
			attributes: "Attributes",
			color: "Color",
			type_vehicle: "Tipo de vehículo",
			speed_limit: "Velocidad máxima",
			car_type: "Tipo de auto",
			brand: "Marca",
			direction: "Dirección",
			speed: "Speed",
			no_dashboard_items: "No dashboard items to display",
			back_to_dashboard: "Back to Dashboard",
			set_default: "Set as default",
			Barcode: "Barcode",
			Device: "Device",
			Inicio: "Inicio",
			"Foto inicio": "Foto inicio",
			Fin: "Fin",
			"Foto fin": "Foto fin",
			State: "State",
			in_progress: "In progress",
			finished: "Finished",
			unknown: "Unknown",
			grouped_events: "Eventos Agrupado",
			Duration: "Duración",
			Totalizers: "Totalizadores",

			// Modal de Entidades
			add_entities_to_list: "Agregar Entidades a Lista",
			select_list: "Seleccionar Lista",
			entities_selected: "entidades seleccionadas",
			filter_by_name: "Filtrar por Nombre",
			filter_by_date: "Filtrar por Fecha",
			clear_filters: "Limpiar Filtros",
			add_to_list: "Agregar a Lista",
			cancel: "Cancelar",
			please_select_list_first: "Por favor seleccione una lista primero",
			no_entities_selected: "No hay entidades seleccionadas",
			entities_added_to_list: "Entidades agregadas a la lista",
			failed_to_fetch_entities: "Error al obtener entidades",
			failed_to_add_entities: "Error al agregar entidades a la lista",

			// Nuevas claves para listing_details.vue
			loading_please_wait: "Cargando... Por favor espere",
			instructions: "Instrucciones",
			select_list_and_choose_entities:
				"Selecciona una lista y luego elige las entidades que deseas agregar. Puedes usar los filtros para encontrar entidades específicas.",
			entities_selected_for_list:
				"Entidades seleccionadas para agregar a la lista",
			select_entities_from_table:
				"Selecciona entidades de la tabla para agregarlas a la lista",
			search_filters: "Filtros de Búsqueda",
			use_filters_to_find_entities:
				"Utiliza estos filtros para encontrar entidades específicas por nombre o fecha",
			available_entities: "Entidades Disponibles",
			select_entities_to_add_to_list:
				"Selecciona las entidades que deseas agregar a la lista. Usa el checkbox superior para seleccionar todas.",
			deselect_all: "Deseleccionar Todas",
			select_all: "Seleccionar Todas",
			global_mode_activated: "Modo global activado",
			entities_of: "entidades de",
			pages: "páginas",
			active_filters: "Filtros activos",
			no_entities_available: "No hay entidades disponibles",
			no_entities_match_search_criteria:
				"No se encontraron entidades que coincidan con los criterios de búsqueda",
			photo: "Foto",
			error_get_list: "Error al obtener lista",
			failed_get_lists: "Error al obtener listas",
			required_have_list_created: "Se requiere tener lista creada: ve a listas",
			error_get_list_trained: "Error al obtener lista entrenada",
			error_list_setting: "Error en configuración de lista",
			res_logos: "Respuesta logos",
			error_logos: "Error logos",
			error_deleting: "Error al eliminar",
			deleting_item: "Eliminando elemento",
			item_to_delete_have_id: "El elemento a eliminar debe tener id",
			item_to_delete_null: "El elemento a eliminar es nulo",
			opening_modal: "Abriendo modal...",
			modal_state: "Estado del modal:",
			list_changed_to: "Lista cambiada a:",
			api_response: "Respuesta API:",
			api_url: "URL API:",
			api_params: "Parámetros API:",
			filtered_entities: "Entidades filtradas:",
			total: "Total:",
			applying_filters: "Aplicando filtros",
			none: "ninguno",
			total_entities: "Total de entidades",
			total_pages: "Total de páginas",
			items_per_page: "Elementos por página",
			page: "Página",
			entities_loaded: "entidades cargadas",
			total_so_far: "Total hasta ahora",
			all_entities_loaded: "Todas las entidades cargadas",
			out_of: "de",
			warning: "Advertencia",
			expected: "Esperado",
			entities_but_got: "entidades pero se obtuvo",
			error_fetching_all_entities: "Error al obtener todas las entidades",
			error_loading_all_entities: "Error al cargar todas las entidades",
			with_filters_applied: "con filtros aplicados",
			filters_applied: "Filtros aplicados",
			viewing_details_for_entity: "Viendo detalles de la entidad:",
			added_via_modal: "Agregado vía modal",
			filters_changed_global_mode_deactivated:
				"Los filtros han cambiado. El modo de selección global se ha desactivado.",
			date_changed_global_mode_deactivated:
				"La fecha ha cambiado. El modo de selección global se ha desactivado.",
			global_selection_mode_deactivated: "Modo de selección global desactivado",
			loading_all_entities_from_all_pages:
				"Cargando todas las entidades de todas las páginas",
			entities_selected_from_pages:
				"Seleccionadas {count} entidades de {pages} páginas ({perPage} por página)",
			invalid_entities_for_face_list: "Entidades inválidas para lista de caras",
			unexpected_response: "Respuesta inesperada de la API",
			failed_to_add_entities_detailed: "Error al agregar entidades a la lista",

			// Nuevas claves para el sistema de guía paso a paso
			step_1_select_list_first: "Paso 1: Selecciona una lista primero",
			step_2_enter_motive: "Paso 2: Ingresa el motivo para continuar",
			step_3_select_faces: "Paso 3: Selecciona caras para agregar",
			ready_to_select_entities: "Listo para seleccionar entidades",
			setup_progress: "Progreso de Configuración",
			select_faces: "Seleccionar Caras",
			complete_steps_1_and_2_first: "Completa los pasos 1 y 2 primero",
			table_locked: "Tabla Bloqueada",
			complete_setup_steps_to_unlock:
				"Completa los pasos de configuración para desbloquear la tabla",
			step: "Paso",
			enter_motive: "Ingresa el motivo para agregar entidades",
			not_in_list: "No está en la lista",

			// VideoSearchByVideo component translations
			browser_not_support_video:
				"Tu navegador no soporta el elemento de video.",
			frame_information: "Información del Frame",
			full_frame: "Foto Completa",
			cropped_face: "Rostro Recortado",
			timestamp: "Timestamp",
			bbox: "Bbox",
			frame_index: "Índice del Frame",
			bbox_probability: "Probabilidad del Bbox",
			face_id: "ID de Cara",
			photo_uuid: "UUID de Foto",
			video_info: "Información del Video",
			fps: "FPS",
			resolution: "Resolución",
			total_frames: "Total de Frames",
			total_faces: "Total de Caras",
			face_search_completed_successfully:
				"Búsqueda facial completada exitosamente",
			no_results_above_similarity_threshold:
				"No se encontraron resultados que superen el umbral de similitud establecido. El mayor similarity encontrado fue {similarity}%. ¿Deseas ajustar el filtro al mayor similarity detectado?",
			adjust_filter: "Ajustar filtro",
			similarity_filter_adjusted:
				"Filtro de similitud ajustado a {similarity}%",
			no_faces_found_in_search: "No se encontraron caras en la búsqueda",

			// LPR Modal translations
			lpr_event_details: "Detalles del Evento LPR",
			event_information: "Información del Evento",
			detail_event_information: "Detalle de Información del Evento",
			click_row_to_show_events:
				"Haga clic en una fila de Event Information para ver los eventos",
			event_source: "Origen",
			event_source_smartevent: "Smart Event",
			event_source_alert: "Alerta",
			event_source_lpr: "LPR",
			event_source_avc: "AVC",
			seg: "Seg",
			event_id: "ID del Evento",
			video_event: "Video del Evento",
			loading_video: "Cargando video...",
			video_load_error: "No se pudo cargar el video",
			no_video_available: "No hay video disponible para este evento",
			play_in_main_player: "Reproducir en Reproductor Principal",
			loading_image: "Cargando imagen...",
			connection_onvif: "Conexión ONVIF",
			connect: "Conectar",
			for_stream_2: "para stream 2",
			mb_gb: "MB/GB",
			tooltip_rtsp: "Ingrese URL RTSP: rtsp://usuario:clave@ip[:puerto]/ruta",
			tooltip_rtsp2: "URL RTSP opcional para substream o Canal 2",
			tooltip_hls: "URL de transmisión HLS si está disponible",
			tooltip_name: "Nombre del dispositivo (mínimo 4 caracteres)",
			tooltip_is_record: "Activa la grabación para el canal seleccionado",
			tooltip_limit: "Límite de almacenamiento de grabaciones. Use MB o GB",
			tooltip_is_motion: "Activa la detección de movimiento",
			tooltip_video_streaming: "Activa video para mostrar en paneles",
			tooltip_ip_machine: "IP del host donde corre el servicio",
			tooltip_image: "Seleccione la imagen Docker del servicio de motion",
			tooltip_uuid:
				"Identificador único universal del dispositivo. Este valor es generado automáticamente y no puede ser modificado.",
			tooltip_record:
				"Activa o desactiva la grabación de video del dispositivo. Cuando está activado, el sistema guardará las grabaciones según el límite de almacenamiento configurado.",
			tooltip_streaming:
				"Activa o desactiva la transmisión de video en tiempo real. Cuando está activado, el video del dispositivo estará disponible para visualización en tiempo real en el sistema.",
			tooltip_optimize_tracker:
				"Activa la optimización del rastreador de movimiento. Cuando está activado, mejora el rendimiento del análisis de movimiento y detección de eventos, optimizando el uso de recursos del sistema.",
			tooltip_type_peripheral:
				"Seleccione el tipo de periférico: Sirena (siren), Cerradura electrónica (electronic_lock), Arduino, Relay IoT (iot_relay) u Odroid. Cada tipo tiene configuraciones específicas.",
			tooltip_arduino:
				"Seleccione el dispositivo Arduino asociado a este periférico. El Arduino debe estar previamente configurado en el sistema. Seleccione de la lista de Arduinos disponibles.",
			tooltip_mode:
				'Seleccione el modo de operación del periférico: "in" (entrada) para dispositivos que envían señales al sistema, o "out" (salida) para dispositivos que reciben comandos del sistema.',
			tooltip_medium:
				"Seleccione el medio de comunicación del periférico: USB (conexión física USB), TCP (comunicación por red TCP/IP), GPIO (pines de entrada/salida) o HTTP (comunicación web HTTP).",
			tooltip_pin:
				"Número del pin GPIO utilizado para la comunicación. Ingrese el número del pin físico del dispositivo (ej: 2, 3, 4, etc.). Solo necesario cuando el medio es GPIO.",
			tooltip_ip:
				"Dirección IP del dispositivo periférico. Ingrese la dirección IP en formato IPv4 (ej: 192.168.1.100). Solo necesario cuando el medio es TCP o HTTP.",
			tooltip_type:
				"Tipo de dispositivo: IP_CAM (cámara IP con streaming de video) o PERIPHERAL (dispositivo periférico como sensores, actuadores, etc.). Este valor no puede ser modificado después de crear el dispositivo.",
			tooltip_serial:
				"Número de serie del dispositivo periférico. Ingrese el número de serie único del dispositivo para identificación y seguimiento.",
			tooltip_onvif_user: "Usuario del dispositivo ONVIF",
			tooltip_onvif_password: "Contraseña del dispositivo ONVIF",
			image_load_error: "No se pudo cargar la imagen",

			// Alert & Smart Event Modal translations
			alert_details: "Detalles de la Alerta",
			smart_event_details: "Detalles del Smart Event",
			lpr_event_details: "Detalles del LPR",
			action_details: "Detalles de la Acción",
			object_details: "Detalles del Objeto",
			axle_details: "Detalles del Axle",
			event_type: "Tipo de Evento",
			event_details: "Detalles del Evento",
			showing_events_range: "Mostrando {0} - {1} de {2} eventos",
			page_of: "Página {0} de {1}",
			no_events_in_range: "No hay eventos en este rango",
			severity: "Severidad",
			message: "Mensaje",
			rule_id: "ID de Regla",
			tag: "Etiqueta",
			description: "Descripción",
			additional_information: "Información Adicional",
			unix_timestamp: "Timestamp Unix",
			style: "Estilo",
			subgroup: "Subgrupo",
			file: "Archivo",
			duration: "Duración",
			no_events: "No hay eventos para mostrar",
			previous_event: "Evento Anterior",
			previous: "Anterior",
			next_event: "Siguiente Evento",
			next: "Siguiente",
			loading_events: "Cargando eventos...",
			io_kind: "Tipo I/O",
			new_state: "Estado nuevo",
			mqtt_topic: "Topic MQTT",

			// EventsChart translations
			temporal_distribution_events: "Distribución Temporal de Eventos",
			period: "Período",
			by_hour: "Por Hora",
			by_minute: "Por Minuto",
			hour: "Hora",
			minute: "Minuto",
			time: "Tiempo",
			no_data_events: "No hay datos de eventos para mostrar",
			number_events: "Número de Eventos",
			events_label: "eventos",
			object_detected: "Objeto Detectado",
			events_count: "Cantidad de Eventos",

			// Alarm Stats translations
			alarm_stats: "Estadísticas de Alarma",
			alarm_stats_total_counted: "Total Contado Hoy",
			alarm_stats_good_units: "Unidades Buenas",
			alarm_stats_defects: "Defectos Detectados",
			alarm_stats_stoppages: "Paradas Hoy",
			alarm_stats_quality_rate: "Tasa de Calidad",
			alarm_stats_defect_rate: "Tasa de Defectos",
			alarm_stats_total_idle: "Tiempo Total Parado",
			alarm_stats_this_minute: "este minuto",
			alarm_stats_units: "unidades",
			alarm_stats_events: "eventos",
			alarm_stats_current_rate: "Tasa Actual",
			alarm_stats_units_min: "u/min",
			alarm_stats_per_hour: "POR HORA",
			alarm_stats_peak_today: "PICO HOY",
			alarm_stats_avg_hour: "AVG/HORA",
			alarm_stats_projection: "Proyección de Turno",
			alarm_stats_projected_units: "Unidades Proyectadas",
			alarm_stats_projection_desc: "A la tasa actual",
			alarm_stats_shift_progress: "Progreso de Turno",
			alarm_stats_shift_duration: "DURACIÓN TURNO",
			alarm_stats_time_remaining: "TIEMPO RESTANTE",
			alarm_stats_oee: "OEE",
			alarm_stats_availability: "Disponibilidad",
			alarm_stats_performance: "Rendimiento",
			alarm_stats_quality: "Calidad",
			alarm_stats_oee_target: "Objetivo OEE",
			alarm_stats_below_target: "Por debajo del objetivo",
			alarm_stats_above_target: "Por encima del objetivo",
			alarm_stats_throughput: "Producción",
			alarm_stats_rate: "Tasa",
			alarm_stats_defects_label: "Defectos",
			alarm_stats_stoppages_label: "Paradas",
			alarm_stats_stoppage_log: "Registro de Paradas",
			alarm_stats_time: "Hora",
			alarm_stats_start_time: "Inicio",
			alarm_stats_end_time: "Fin",
			alarm_stats_duration: "Duración",
			alarm_stats_camera_trigger: "Cámara Disparadora",
			alarm_stats_rate_before: "Tasa Antes",
			alarm_stats_rate_after: "Tasa Después",
			alarm_stats_status: "Estado",
			alarm_stats_notes: "Notas",
			alarm_stats_resolved: "Resuelto",
			alarm_stats_active: "Activo",
			alarm_stats_active_dash: "Activo",
			alarm_stats_no_stats: "Sin estadísticas",
			alarm_stats_not_found: "Alarma no encontrada",
			alarm_stats_load_error: "Error al cargar",
			alarm_stats_retry: "Reintentar",
			alarm_stats_shift_config: "Configuración de Turno",
			alarm_stats_shift_start: "Inicio de Turno",
			alarm_stats_shift_dur_min: "Duración (min)",
			alarm_stats_target_rate: "Tasa Objetivo (u/min)",
			alarm_stats_stop_threshold: "Umbral de Parada (ms)",
			alarm_stats_cancel: "Cancelar",
			alarm_stats_note_placeholder: "Agregar nota...",
			alarm_stats_listing: "Lista",
			alarm_stats_loading: "Cargando estadísticas…",
			alarm_stats_title_fallback: "Estadísticas de Alarma",
			alarm_stats_realtime_connected: "Tiempo real: conectado",
			alarm_stats_realtime_disconnected: "Tiempo real: desconectado",
			alarm_stats_shift_button: "Turno",
			alarm_stats_ws_lost: "Conexión en tiempo real perdida",
			alarm_stats_ws_reconnected: "Reconectado al servidor",
			alarm_stats_note_save_error: "No se pudo guardar la nota",
			alarm_stats_config_save_error:
				"No se pudo guardar la configuración en el servidor",
			alarm_stats_config_saved: "Configuración de turno guardada",
			alarm_stats_shift_start_hint: "Formato HH:MM (24h)",
			alarm_stats_shift_duration_hint: "Duración en minutos (ej: 480 = 8 h)",
			alarm_stats_target_rate_hint:
				"Unidades por minuto esperadas (0 = sin objetivo)",
			alarm_stats_stop_threshold_hint:
				"Tiempo mínimo sin actividad para registrar un paro",
			alarm_stats_shift_start_invalid: "Ingrese un horario válido (HH:MM)",
			alarm_stats_shift_duration_invalid:
				"La duración debe ser mayor a 0 minutos",
			alarm_stats_target_rate_invalid: "La tasa objetivo debe ser 0 o mayor",
			alarm_stats_threshold_invalid: "El umbral mínimo es 1000 ms (1 segundo)",
			alarm_stats_reset_zoom: "Reset",
			alarm_stats_from: "Desde",
			alarm_stats_to: "Hasta",
			alarm_stats_apply: "Aplicar",
			alarm_stats_preset_today: "Hoy",
			alarm_stats_preset_custom: "Personalizado",
			alarm_stats_all: "Todo",
			alarm_stats_chart_units_axis: "Unidades",
			alarm_stats_upm: "upm",

			// Dashboard Pie Events shell translations
			dashboard_pie_events_total_type_pie: "Constructor de gráficas dashboard",
			dashboard_pie_events_preset_total_alertas: "Total Alertas",
			dashboard_pie_events_preset_total_alertas_atendidas:
				"Total Alertas atendidas",
			dashboard_pie_events_preset_porcentaje_operacion_efectiva:
				"Porcentaje de operación efectiva",
			dashboard_pie_events_preset_alertas_pendientes_por_atender:
				"Alertas sin resolver",
			dashboard_pie_events_preset_alertas_clasificadas_positivas_falso_positivas:
				"Alertas clasificadas positivas/falso positivas",
			dashboard_pie_events_preset_alertas_por_dispositivo:
				"Alertas por dispositivo",
			dashboard_pie_events_preset_tiempo_accion_operador:
				"Tiempo de acción del operador",
			dashboard_pie_events_preset_interval_title:
				"Seleccione el intervalo de la gráfica",
			dashboard_alerts_by_device_tab_map: "Mapa",
			dashboard_alerts_by_device_tab_list: "Lista",
			dashboard_alerts_by_device_ranking: "Puntos con más alertas",
			dashboard_alerts_by_device_device: "Dispositivo",
			dashboard_alerts_by_device_count: "Alertas",
			dashboard_alerts_by_device_loading: "Cargando alertas por dispositivo...",
			dashboard_alerts_by_device_empty:
				"No hay datos de alertas por dispositivo.",
			dashboard_alerts_by_device_no_coordinates:
				"No hay dispositivos con coordenadas para graficar.",
			dashboard_operator_action_time_subtitle:
				"Tiempo desde alarma hasta acción del operador",
			dashboard_operator_action_time_average: "Promedio",
			dashboard_operator_action_time_p95: "P95",
			dashboard_operator_action_time_best: "Mejor hoy",
			dashboard_operator_action_time_within_objective: "Dentro de objetivo",
			dashboard_operator_action_time_objective: "Objetivo",
			dashboard_operator_action_time_distribution: "Distribución",
			dashboard_operator_action_time_daily_average:
				"Promedio diario de tiempo de respuesta",
			dashboard_operator_action_time_daily_empty:
				"No hay datos diarios de tiempo de respuesta.",
			dashboard_operator_action_time_total: "Alertas accionadas",
			dashboard_operator_action_time_source: "Fuente de acción",
			dashboard_operator_action_time_interval: "Intervalo",
			dashboard_operator_action_time_interval_24h: "24h",
			dashboard_operator_action_time_interval_7d: "7d",
			dashboard_operator_action_time_interval_30d: "30d",
			dashboard_operator_action_time_loading:
				"Cargando tiempo de acción del operador...",
			dashboard_operator_action_time_empty:
				"No hay datos de tiempo de acción del operador.",
			dashboard_operator_action_time_error:
				"No se pudo cargar el tiempo de acción del operador. Intente nuevamente más tarde.",
			dashboard_operator_action_time_skipped_note:
				"Alertas omitidas sin fecha de creación",
			dashboard_operator_action_time_pending_note:
				"Alertas abiertas medidas hasta el momento de consulta",
			dashboard_pie_events_title: "Agregar gráfica al dashboard",
			dashboard_pie_events_shell_help:
				"Asigne un nombre, elija el tipo de gráfica, genere una vista previa y luego agréguela al dashboard.",
			dashboard_pie_events_metadata_error:
				"No se pudo cargar la metadata de la gráfica. El flujo de configuración podrá continuar cuando el backend esté disponible.",
			dashboard_pie_events_section_datasource: "Fuente de datos",
			dashboard_pie_events_section_interval: "Intervalo",
			dashboard_pie_events_section_devices: "Dispositivos",
			dashboard_pie_events_section_refresh: "Refresco",
			dashboard_pie_events_section_preview: "Vista previa",
			dashboard_pie_events_placeholder_interval:
				"Los selectores de preset y rango personalizado se habilitarán aquí.",
			dashboard_pie_events_placeholder_devices:
				"La selección de dispositivos se habilitará aquí.",
			dashboard_pie_events_placeholder_preview:
				"La vista previa se habilitará antes de agregar el widget.",
			dashboard_pie_events_refresh_default:
				"Refresco por defecto: 60 segundos.",
			dashboard_pie_events_add_disabled: "Agregar después de vista previa",
			dashboard_pie_events_loading_metadata: "Cargando metadata...",
			dashboard_pie_events_metadata_loaded:
				"Metadata cargada. Los selectores usarán restricciones del backend en el siguiente corte.",
			dashboard_pie_events_metadata_pending:
				"Esperando metadata de la gráfica.",
			dashboard_pie_events_section_grouping: "Agrupación",
			dashboard_pie_events_section_filters: "Filtros",
			dashboard_pie_events_section_chart: "Gráfica",
			dashboard_pie_events_section_appearance: "Apariencia",
			dashboard_pie_events_chart_name: "Nombre",
			dashboard_pie_events_chart_type: "Tipo de gráfica",
			dashboard_pie_events_chart_type_pie: "Gráfica tipo torta",
			dashboard_pie_events_chart_type_doughnut: "Gráfica tipo dona",
			dashboard_pie_events_chart_type_kpi: "Tarjeta KPI",
			dashboard_pie_events_chart_type_line: "Gráfica de líneas",
			dashboard_pie_events_kpi_color: "Color KPI",
			dashboard_pie_events_kpi_icon: "Ícono KPI",
			dashboard_pie_events_datasource: "Fuente de datos",
			dashboard_pie_events_table: "Tabla",
			dashboard_pie_events_interval_preset: "Preset de intervalo",
			dashboard_pie_events_from: "Desde",
			dashboard_pie_events_to: "Hasta",
			dashboard_pie_events_devices: "Dispositivos",
			dashboard_pie_events_group_by: "Agrupar por",
			dashboard_pie_events_no_grouping:
				"No hay campos agrupables disponibles para esta fuente de datos.",
			dashboard_pie_events_add_filter: "Agregar filtro",
			dashboard_pie_events_no_filters:
				"No hay campos filtrables disponibles para esta fuente de datos.",
			dashboard_pie_events_filter_field: "Campo",
			dashboard_pie_events_filter_operator: "Operador",
			dashboard_pie_events_filter_value: "Valor",
			dashboard_pie_events_refresh_seconds: "Segundos de refresco",
			dashboard_pie_events_refresh_range: "Rango de refresco permitido:",
			dashboard_pie_events_preview: "Vista previa",
			dashboard_pie_events_preview_loading: "Cargando vista previa...",
			dashboard_pie_events_preview_empty:
				"Ejecute la vista previa para validar la configuración antes de agregar.",
			dashboard_pie_events_preview_error:
				"No se pudo generar la vista previa. Revise la configuración o intente nuevamente.",
			dashboard_pie_events_total: "Total",
			dashboard_pie_events_requested: "Pedido",
			dashboard_pie_events_interval_total: "Eventos en el intervalo",
			dashboard_pie_events_grouped_total: "Eventos agrupados",
			dashboard_pie_events_slice: "Segmento",
			dashboard_pie_events_value: "Valor",
			dashboard_pie_events_percent: "Porcentaje",
			dashboard_pie_events_add: "Agregar gráfica",
			dashboard_pie_events_preset_today: "Hoy",
			dashboard_pie_events_preset_yesterday: "Ayer",
			dashboard_pie_events_preset_week: "Semana",
			dashboard_pie_events_preset_15d: "Últimos 15 días",
			dashboard_pie_events_preset_30d: "Últimos 30 días",
			dashboard_pie_events_preset_last_24h: "Últimas 24 horas",
			dashboard_pie_events_preset_last_7d: "Últimos 7 días",
			dashboard_pie_events_preset_last_30d: "Últimos 30 días",
			dashboard_pie_events_preset_custom: "Personalizado",
			"dashboard.pie.events.values.alarms.classification.positive": "Positivas",
			"dashboard.pie.events.values.alarms.classification.false_positive":
				"Falso positivas",
			"dashboard.pie.events.values.alarms.classification.unclassified":
				"Pendientes por clasificar",
			dashboard_pie_events_validation_chart_type:
				"Seleccione un tipo de gráfica.",
			dashboard_pie_events_validation_datasource:
				"Seleccione una fuente de datos.",
			dashboard_pie_events_validation_table: "Seleccione una tabla.",
			dashboard_pie_events_validation_devices:
				"Seleccione al menos un dispositivo.",
			dashboard_pie_events_validation_custom_required:
				"Seleccione fecha inicial y final para el rango personalizado.",
			dashboard_pie_events_validation_custom_order:
				"La fecha inicial del rango debe ser anterior a la fecha final.",
			dashboard_pie_events_validation_custom_limit:
				"El rango personalizado excede la ventana permitida.",
			dashboard_pie_events_validation_refresh:
				"Los segundos de refresco están fuera del rango permitido.",
			dashboard_pie_events_validation_grouping:
				"La agrupación seleccionada no está permitida por la metadata.",
			dashboard_pie_events_validation_filters:
				"Complete los filtros con campos y operadores permitidos.",
			dashboard_pie_events_loading_data: "Cargando datos de la gráfica...",
			dashboard_pie_events_empty_data:
				"No hay datos de eventos disponibles para esta configuración.",
			dashboard_pie_events_data_error:
				"No se pudieron cargar los datos de la gráfica. Intente nuevamente más tarde.",
			dashboard_pie_events_unsupported_config:
				"Esta configuración de gráfica no es compatible con esta versión.",
			dashboard_pie_events_retry: "Reintentar",
			dashboard_pie_events_generated_at: "Generado",
			dashboard_pie_events_sources_alarms: "Alarmas",
			dashboard_pie_events_sources_lpr: "Placas vehiculares (LPR)",
			dashboard_pie_events_sources_actions: "Acciones del operador",
			dashboard_pie_events_sources_smart_event: "Eventos inteligentes",
			dashboard_pie_events_sources_reports: "Reportes",
			dashboard_pie_events_sources_objects: "Objetos detectados",
			dashboard_pie_events_sources_technical: "Eventos técnicos",
			dashboard_pie_events_sources_peripherals: "Eventos de periféricos",
			dashboard_pie_events_sources_incidents: "Incidentes",
			dashboard_pie_events_sources_face: "Rostros",
			dashboard_pie_events_sources_parking: "Eventos de parqueadero",
			dashboard_pie_events_sources_avc: "Conteo vehicular (AVC)",
			dashboard_pie_events_sources_counter: "Contadores",
			dashboard_pie_events_sources_mixta: "Eventos mixtos",
			dashboard_pie_events_fields_event_type: "Tipo de evento",
			dashboard_pie_events_fields_name: "Nombre",
			dashboard_pie_events_fields_device: "Dispositivo",
			dashboard_pie_events_fields_deviceId: "Dispositivo",
			dashboard_pie_events_fields_timestamp: "Fecha y hora",
			dashboard_pie_events_fields_unix_itme_stamp: "Fecha y hora",
			dashboard_pie_events_fields_createdAt: "Fecha de creación",
			dashboard_pie_events_fields_updatedAt: "Fecha de actualización",
			dashboard_pie_events_fields_date: "Fecha",
			dashboard_pie_events_fields_data: "Datos",
			dashboard_pie_events_fields_time: "Hora",
			dashboard_pie_events_fields_manager: "Administrador",
			dashboard_pie_events_fields_color: "Color",
			dashboard_pie_events_fields_attributes: "Atributos",
			dashboard_pie_events_fields_alarmId: "ID alarma",
			dashboard_pie_events_fields_alertUUID: "UUID alerta",
			dashboard_pie_events_fields_analytic: "Analítica",
			dashboard_pie_events_fields_antenna_num: "Número de antena",
			dashboard_pie_events_fields_axle_count: "Conteo de ejes",
			dashboard_pie_events_fields_barcode: "Código de barras",
			dashboard_pie_events_fields_bbox: "Caja delimitadora",
			dashboard_pie_events_fields_caseId: "ID caso",
			dashboard_pie_events_fields_contact: "Contacto",
			dashboard_pie_events_fields_coord: "Coordenadas",
			dashboard_pie_events_fields_description: "Descripción",
			dashboard_pie_events_fields_detail: "Detalle",
			dashboard_pie_events_fields_duration: "Duración",
			dashboard_pie_events_fields_duration_seconds: "Duración en segundos",
			dashboard_pie_events_fields_duration_time: "Tiempo de duración",
			dashboard_pie_events_fields_end_time: "Hora final",
			dashboard_pie_events_fields_entry_event: "Evento de entrada",
			dashboard_pie_events_fields_entry_trigger_event: "Disparador de entrada",
			dashboard_pie_events_fields_entry_type: "Tipo de entrada",
			dashboard_pie_events_fields_epc_num: "Número EPC",
			dashboard_pie_events_fields_eventId: "ID evento",
			dashboard_pie_events_fields_eventUUID: "UUID evento",
			dashboard_pie_events_fields_event_to_pay: "Evento a pagar",
			dashboard_pie_events_fields_exit_event: "Evento de salida",
			dashboard_pie_events_fields_exit_trigger_event: "Disparador de salida",
			dashboard_pie_events_fields_frame: "Frame",
			dashboard_pie_events_fields_frame_id: "ID frame",
			dashboard_pie_events_fields_full_photo: "Foto completa",
			dashboard_pie_events_fields_gif_evidence: "Evidencia GIF",
			dashboard_pie_events_fields_gifevidence: "Evidencia GIF",
			dashboard_pie_events_fields_h: "Alto",
			dashboard_pie_events_fields_history: "Historial",
			dashboard_pie_events_fields_id: "ID",
			dashboard_pie_events_fields_init_time: "Hora inicial",
			dashboard_pie_events_fields_is_confirmed: "Confirmado",
			dashboard_pie_events_fields_is_fp: "Falso positivo",
			dashboard_pie_events_fields_is_ignored: "Ignorado",
			dashboard_pie_events_fields_latitude: "Latitud",
			dashboard_pie_events_fields_longitude: "Longitud",
			dashboard_pie_events_fields_name_categorie: "Nombre de categoría",
			dashboard_pie_events_fields_ocr_found: "OCR encontrado",
			dashboard_pie_events_fields_operator: "Operador",
			dashboard_pie_events_fields_owner: "Propietario",
			dashboard_pie_events_fields_path_evidence: "Ruta evidencia",
			dashboard_pie_events_fields_plate_Description: "Descripción de placa",
			dashboard_pie_events_fields_plate_found: "Placa encontrada",
			dashboard_pie_events_fields_prob: "Probabilidad",
			dashboard_pie_events_fields_probability: "Probabilidad",
			dashboard_pie_events_fields_profileId: "ID perfil",
			dashboard_pie_events_fields_rfid_id: "ID RFID",
			dashboard_pie_events_fields_rssi_level: "Nivel RSSI",
			dashboard_pie_events_fields_ruleId: "ID regla",
			dashboard_pie_events_fields_segment_photo: "Foto segmento",
			dashboard_pie_events_fields_side: "Lado",
			dashboard_pie_events_fields_size: "Tamaño",
			dashboard_pie_events_fields_speed: "Velocidad",
			dashboard_pie_events_fields_speed_limit: "Límite de velocidad",
			dashboard_pie_events_fields_tid_num: "Número TID",
			dashboard_pie_events_fields_top_image: "Imagen superior",
			dashboard_pie_events_fields_total: "Total",
			dashboard_pie_events_fields_tracker_id: "ID tracker",
			dashboard_pie_events_fields_url_evidence: "URL evidencia",
			dashboard_pie_events_fields_url_photo_event: "URL foto evento",
			dashboard_pie_events_fields_userId: "ID usuario",
			dashboard_pie_events_fields_vehicle_image_path: "Ruta imagen vehículo",
			dashboard_pie_events_fields_vehicle_image_url: "URL imagen vehículo",
			dashboard_pie_events_fields_video: "Video",
			dashboard_pie_events_fields_vinfo: "Información de video",
			dashboard_pie_events_fields_void_reason: "Motivo de anulación",
			dashboard_pie_events_fields_w: "Ancho",
			dashboard_pie_events_fields_way: "Vía",
			dashboard_pie_events_fields_x: "X",
			dashboard_pie_events_fields_y: "Y",
			dashboard_pie_events_fields_uuid: "UUID",
			dashboard_pie_events_fields_motive_categorie: "Categoría de motivo",
			dashboard_pie_events_fields_tag: "Etiqueta",
			dashboard_pie_events_fields_isalert: "Alerta",
			dashboard_pie_events_fields_is_alarm: "Alarma",
			dashboard_pie_events_fields_plate_chars: "Placa",
			dashboard_pie_events_fields_type_vehicle: "Tipo de vehículo",
			dashboard_pie_events_fields_vehicle_type: "Tipo de vehículo",
			dashboard_pie_events_fields_direction: "Dirección",
			dashboard_pie_events_fields_action: "Acción",
			dashboard_pie_events_fields_type: "Tipo",
			dashboard_pie_events_fields_state: "Estado",
			dashboard_pie_events_fields_code: "Código",
			dashboard_pie_events_fields_module: "Módulo",
			dashboard_pie_events_fields_obs: "Observación",
			dashboard_pie_events_fields_void: "Anulado",
			dashboard_pie_events_fields_lane_no: "Carril",
			dashboard_pie_events_fields_typeCounter: "Tipo de contador",
			dashboard_pie_events_fields_nameField: "Campo nombre",
			dashboard_pie_events_fields_valueField: "Campo valor",
			dashboard_pie_events_fields_segment_photo_path: "Ruta foto segmento",
			dashboard_pie_events_fields_segment_photo_url: "URL foto segmento",
			dashboard_pie_events_fields_full_photo_path: "Ruta foto completa",
			dashboard_pie_events_fields_full_photo_url: "URL foto completa",
			dashboard_pie_events_fields_face_detected_path: "Ruta rostro detectado",
			dashboard_pie_events_fields_face_detected_url: "URL rostro detectado",
		}),
		//esp
		new MLanguage("mongolian").create({
			select_file: "Файл сонгох",
			select_files: "Файлуудыг сонгоно уу",
			description_list_id_field: "Жагсаалтын дугаарын тайлбар",
			description_plate_field: "Талбарын дугаарын тайлбар",
			description_id_field: "ID Талбарын тайлбар",
			profile: "Профайл",
			username: "Хэрэглэгчийн нэр",
			first_names: "Өөрийн нэр",
			last_names: "Овог нэр",
			email: "И-мэйл",
			password: "Нууц үг", //
			token: "Токен",
			confirm_psw: "Нууц үгээ баталгаажуулна уу",
			save: "Хадгалах",
			create_new: "Шинэ үүсгэх",
			duplicate: "Хуулбарлах",
			copy: "Хуулах",
			edit: "Засварлах",
			close: "Хаах",
			soon: "Удалгүй",
			dashboard: "Хяналтын самбар",
			settings: "Тохиргоо",
			history: "Түүх",
			reports: "Тайлан", //
			register_user: "Хэрэглэгчийг бүртгүүлэх",
			category: "Ангилал",
			new: "Шинэ",
			users: "Хэрэглэгчид",
			id: "Үнэмлэх",
			name: "Нэр",
			user: "Хэрэглэгч",
			type_user: "Хэрэглэгчийн төрөл",
			type_users: "Хэрэглэгчдийг оруулна уу",
			actions: "Үйлдэл",
			search: "Хайлт хийх",
			login: "Нэвтрэх",
			psw_req: "Нууц үг шаардлагатай!", //
			login_error: "Нэвтрэх алдаа",
			log_out: "Гарах",
			direction: "Чиглэл",
			host_api: "Хөтлөгч Api Url",
			host_client: "Хост Үйлчлүүлэгч Url",
			description: "Тайлбар",
			register: "Бүртгүүлэх",
			reset: "Дахин тохируулах",
			delete: "Устгах",
			new_device: "Шинэ төхөөрөмж",
			cam_options: "Камерын сонголтууд",
			host: "Хост байна",
			relay: "Релей",
			searching_relays: "Релей хайж байна",
			searching: "Хайж байна",
			no_relays_found: "Релей олдсонгүй",
			type_cam: "Камерын төрөл",
			host_options: "Хост сонголтууд",
			options: "Сонголтууд",
			camera: "Камер",
			cameras: "Камерууд",
			cloud: "Үүл",
			cloud_sent: "Үүлэнд илгээгдсэн",
			cloud_pending: "Үүлэнд илгээх хүлээлттэй",
			date: "Огноо",
			date_e: "Эцсийн огноо",
			date_in: "Огноо, цаг In",
			date_out: "Огноо ба цаг хугацаа",
			plates: "Улсын дугаар",
			user_options: "Хэрэглэгчийн сонголтууд",
			dc: "Dc",
			excel: "excel руу экспортлох",
			report_config: "Тохиргоог мэдээлэх",
			device_id: "Төхөөрөмжийн дугаар",
			notification_config: "Мэдэгдлийн Тохиргоо",
			create_alert: "Сэрүүлэг үүсгэх",
			success: "Амжилт",
			error: "Алдаа",
			warning: "Анхааруулга",
			alert_type: "Сэрэмжлүүлгийн төрөл",
			alert_mode: "Сэрэмжлүүлгийн горим",
			manual: "Гарын авлага",
			automatic: "Автомат",
			confirm: "Баталгаажуулна уу",
			graffics: "График",
			notice: "Мэдэгдэл",
			alice_face: "ODT нүүр",
			faces: "Нүүр царай",
			recognized: "Хүлээн зөвшөөрөгдсөн",
			odt_face: "ODT - Face",
			unknown: "Үл мэдэгдэх",
			select: "Сонгох",
			relay: "Релей",
			searching_relays: "Релей хайж байна",
			searching: "Хайж байна",
			no_relays_found: "Релей олдсонгүй",
			retry_search: "Дахин хайх",
			help_name_peripheral:
				"Энэ периферийн төхөөрөмжийг тодорхойлох өвөрмөц нэрийг оруулна уу. Хамгийн багадаа 4 тэмдэгт шаардлагатай.",
			help_type_peripheral:
				"Периферийн төрлийг сонгоно уу: Сирен (дохиолол), Цахилгаан түгжээ (хаалганы түгжээ), Arduino (микроконтроллер), IoT Relay (ухаалаг релей) эсвэл Odroid (нэг самбарт компьютер).",
			help_medium:
				"Холболтын хэрэгсэлийг сонгоно уу: USB (шууд USB холболт), TCP (сүлжээний холболт), GPIO (ерөнхий зорилготой оролт/гаралтын пин) эсвэл HTTP (веб суурийн холболт).",
			help_ip:
				"Төхөөрөмжийн IP хаягийг оруулна уу. TCP холболтод шаардлагатай. Формат: XXX.XXX.XXX.XXX",
			help_serial:
				"Төхөөрөмжийн серийн дугаар эсвэл таних тэмдгийг оруулна уу. Энэ нь ихэвчлэн төхөөрөмжийн шошго дээр байдаг эсвэл төхөөрөмжийн сканнаас авч болно.",
			help_arduino:
				'Илрүүлсэн төхөөрөмжийн жагсаалтаас Arduino төхөөрөмжийг сонгоно уу. Холбогдсон төхөөрөмжийг скан хийхийн тулд "Arduino авах" дээр дарна уу.',
			help_relay:
				"Боломжтой релейн жагсаалтаас IoT Relay төхөөрөмжийг сонгоно уу. Систем нь идэвхтэй релейг автоматаар хайна.",
			help_username:
				"Баталгаажуулалтын хэрэглэгчийн нэрийг оруулна уу. Цахилгаан түгжээний төхөөрөмжид шаардлагатай.",
			help_password:
				"Баталгаажуулалтын нууц үгийг оруулна уу. Цахилгаан түгжээний төхөөрөмжид шаардлагатай.",
			help_token:
				"Баталгаажуулалтын токен эсвэл API түлхүүрийг оруулна уу. Зарим цахилгаан түгжээний төхөөрөмжид шаардлагатай.",
			help_host:
				"Хост хаяг эсвэл серверийн URL-ийг оруулна уу. Цахилгаан түгжээний төхөөрөмжид шаардлагатай. Формат: хост нэр эсвэл IP хаяг.",
			to_train: "Сургуулилах",
			video_feed: "Видео хангамж",
			detected_faces: "Илрүүлсэн царай",
			host_list: "Хостын жагсаалт",
			type: "Төрөл",
			country: "Улс",
			licence: "Тусгай зөвшөөрөл",
			host_configuration: "Хостын тохиргоо",
			update: "Шинэчлэх",
			alarm_button_save: "Save",
			alarm_button_update: "Update",
			control: "Хяналт",
			device: "Төхөөрөмж",
			multi_face_roster: "Терминалууд дээрх хүмүүс",
			multi_face_roster_subtitle: "Терминалаар нэгтгэсэн царай",
			multi_face_roster_refresh: "Терминалууд дээрх хүмүүсийг шинэчлэх",
			multi_face_roster_group_label: "Бүлэглэх",
			multi_face_roster_search_label: "Нэр эсвэл FPID-аар хайх",
			multi_face_roster_loading_people:
				"Терминалууд дээрх хүмүүсийг ачаалж байна...",
			multi_face_roster_empty_title: "Харуулах хүн алга",
			multi_face_roster_empty_filter: "Одоогийн шүүлтүүрээр царай олдсонгүй.",
			multi_face_roster_unnamed_person: "Нэргүй хүн",
			multi_face_roster_system: "Систем",
			multi_face_roster_terminal: "Терминал",
			multi_face_roster_yes: "Тийм",
			multi_face_roster_no: "Үгүй",
			multi_face_roster_registered: "Бүртгэлтэй",
			multi_face_roster_registered_single: "Бүртгэлтэй",
			multi_face_roster_missing_import: "Импорт хүлээгдэж байна",
			multi_face_roster_backend_only: "Зөвхөн системд",
			multi_face_roster_group_person: "Хүнээр",
			multi_face_roster_group_terminal: "Терминалаар",
			multi_face_roster_import_to_list: "Жагсаалт руу импортлох",
			multi_face_roster_clear_selection: "Сонголтыг цэвэрлэх",
			multi_face_roster_import_people_title: "Хүмүүс импортлох",
			multi_face_roster_import_people_subtitle:
				"Шаардлагатай үед жагсаалт болон эх терминалыг сонгоно уу.",
			multi_face_roster_close_import: "Импортыг хаах",
			multi_face_roster_face_list_label: "Царайны жагсаалт",
			multi_face_roster_no_face_lists: "Царайны жагсаалт алга",
			multi_face_roster_source_required:
				"Нэгээс олон терминал дээр байгаа хүмүүсийн эх терминалыг сонгоно уу.",
			multi_face_roster_source_terminal_label: "Эх терминал",
			multi_face_roster_cancel: "Цуцлах",
			multi_face_roster_import: "Импортлох",
			multi_face_roster_terminal_count: "{0} терминал",
			multi_face_roster_summary_counts:
				"{0} бүртгэлтэй · {1} импорт хүлээгдэж байна",
			multi_face_roster_failed_terminals:
				"{0} терминал хариу өгсөнгүй. Боломжтой өгөгдлийг харуулж байна.",
			multi_face_roster_partial_terminals:
				"Анхааруулга: {0} дээрх жагсаалт бүрэн бус байж болно. Терминал хэсэгчилсэн эсвэл таслагдсан өгөгдөл мэдээлсэн; бүх хүн байгаа гэж үзэхээс өмнө шалгана уу.",
			multi_face_roster_selected_count: "{0} хүн импортлохоор сонгогдсон",
			multi_face_roster_ready_count: "{0} хүн импортлоход бэлэн.",
			multi_face_roster_list_fallback: "Жагсаалт {0}",
			multi_face_roster_registered_subtitle:
				"Терминал болон системд байгаа хүмүүс",
			multi_face_roster_missing_import_subtitle:
				"Терминал дээр байгаа боловч системд байхгүй хүмүүс",
			multi_face_roster_person_view_subtitle:
				"Бүх терминалын нэгтгэсэн харагдац",
			multi_face_roster_people_count: "{0} хүн",
			multi_face_roster_no_terminals: "Царай таних нэвтрэх терминал олдсонгүй.",
			multi_face_roster_load_error:
				"Нэгтгэсэн хүмүүсийн жагсаалтыг ачаалж чадсангүй.",
			multi_face_roster_state_loaded: "Ачаалсан",
			multi_face_roster_state_connected: "Холбогдсон",
			multi_face_roster_state_disconnected: "Холбогдоогүй",
			multi_face_roster_state_partial: "Бүрэн бус",
			multi_face_roster_state_error: "Алдаа",
			multi_face_roster_state_loading: "Ачаалж байна",
			multi_face_roster_state_diagnostic: "Оношилгоо",
			multi_face_roster_photo_alt: "{0}-ийн царайны зураг",
			multi_face_roster_select_person: "{0}-г импортлохоор сонгох",
			multi_face_roster_unselect_person: "{0}-г импортоос хасах",
			multi_face_roster_lists_error: "Царайны жагсаалтуудыг ачаалж чадсангүй.",
			multi_face_roster_import_success:
				"{0} хүн импортлогдож жагсаалтад нэмэгдлээ.",
			multi_face_roster_import_partial_success:
				"{0} хүн импортлогдлоо. {1} нь аль хэдийн бүртгэлтэй эсвэл эх терминал дээр байхгүй болсон тул импортлогдсонгүй.",
			multi_face_roster_import_failed_count:
				"{0} хүн аль хэдийн бүртгэлтэй эсвэл эх терминал дээр байхгүй болсон тул импортлогдсонгүй.",
			multi_face_roster_import_error: "Сонголтыг импортолж чадсангүй.",
			multi_face_roster_add_person: "Хүн нэмэх",
			multi_face_roster_add_success:
				"Хүн нэмэгдлээ. Синк нь толин жагсаалтын гишүүнчлэлийг боловсруулна.",
			multi_face_roster_remove_from_terminal: "Терминалаас хасах",
			multi_face_roster_move_target_label: "Терминалууд руу шилжүүлэх",
			multi_face_roster_copy_or_move_target_label:
				"Терминалууд руу хуулах эсвэл шилжүүлэх",
			multi_face_roster_move_no_destinations:
				"Энэ хүнд өөр очих терминал алга.",
			multi_face_roster_move_person: "Шилжүүлэх",
			multi_face_roster_copy_to_terminal: "Терминалууд руу хуулах",
			multi_face_roster_add_to_terminal_target_label: "Терминалууд руу нэмэх",
			multi_face_roster_add_to_terminal_no_destinations:
				"Энэ хүнд очих терминал алга.",
			multi_face_roster_add_to_terminal: "Терминал руу нэмэх",
			multi_face_roster_delete_completely: "Бүрэн устгах",
			multi_face_roster_confirm: "Тийм, устгах",
			multi_face_roster_move_confirm: "Тийм, шилжүүлэх",
			multi_face_roster_copy_confirm: "Тийм, хуулах",
			multi_face_roster_add_to_terminal_confirm: "Тийм, нэмэх",
			multi_face_roster_remove_confirm_title: "Хүнийг терминалаас хасах уу?",
			multi_face_roster_remove_confirm_message:
				"{0}-г {1} терминалаас устгахдаа итгэлтэй байна уу? Энэ нь толин жагсаалтын гишүүнчлэлийг хасаж терминалын устгалд оруулна.",
			multi_face_roster_move_confirm_title:
				"Хүнийг сонгосон терминалууд руу шилжүүлэх үү?",
			multi_face_roster_move_confirm_message:
				"{0}-г {1} рүү шилжүүлэхдээ итгэлтэй байна уу? Эхлээд одоогийн бүх терминалын толин жагсаалтын гишүүнчлэлийг хасаад дараа нь сонгосон очих гишүүнчлэлүүдийг нэмнэ.",
			multi_face_roster_copy_confirm_title:
				"Хүнийг сонгосон терминалууд руу хуулах уу?",
			multi_face_roster_copy_confirm_message:
				"{0}-г {1} рүү хуулахдаа итгэлтэй байна уу? Одоогийн терминалын гишүүнчлэлүүд хэвээр үлдэж зөвхөн сонгосон очих гишүүнчлэлүүд нэмэгдэнэ.",
			multi_face_roster_add_to_terminal_confirm_title:
				"Хүнийг сонгосон терминалууд руу нэмэх үү?",
			multi_face_roster_add_to_terminal_confirm_message:
				"{0}-г {1} рүү нэмэхдээ итгэлтэй байна уу? Синк сонгосон толин жагсаалтын гишүүнчлэлүүдийг үүсгэнэ.",
			multi_face_roster_delete_confirm_title: "Хүнийг бүрэн устгах уу?",
			multi_face_roster_delete_confirm_message:
				"{0}-г устгахдаа итгэлтэй байна уу? Эхлээд бүх терминалын толин жагсаалтын гишүүнчлэлийг хасаад боломжтой бол backend-ийн сургасан хүнийг устгана.",
			multi_face_roster_remove_success: "Хүн {0}-ээс хасагдлаа.",
			multi_face_roster_move_success:
				"Хүн шилжлээ. Синк одоогийн эхүүдээс устгаж очих терминалуудад үүсгэнэ.",
			multi_face_roster_copy_success:
				"Хүн сонгосон терминалын толин жагсаалтууд руу хуулагдлаа. Одоогийн терминалын гишүүнчлэлүүд хэвээр үлдсэн.",
			multi_face_roster_add_to_terminal_success:
				"Хүн сонгосон терминалын толин жагсаалтуудад нэмэгдлээ. Синк терминалын хэрэглэгчийг үүсгэнэ.",
			multi_face_roster_delete_success:
				"Хүн толин жагсаалтаас болон боломжтой үед backend-ээс устгагдлаа.",
			multi_face_roster_action_error: "Хүний үйлдлийг гүйцэтгэж чадсангүй.",
			multi_face_roster_terminal_list_missing:
				"Терминалын толин жагсаалтыг олж чадсангүй.",
			multi_face_roster_person_id_missing: "Хүний backend id-г олж чадсангүй.",
			multi_face_roster_membership_missing:
				"Терминалын толин жагсаалтын гишүүнчлэл олдсонгүй.",
			access_control_face_roster_sync_terminal_users:
				"Терминалын хэрэглэгчдийг синк хийх",
			access_control_face_roster_sync_success:
				"Терминалын хэрэглэгчид синк хийгдлээ.",
			access_control_face_roster_sync_error:
				"Терминалын хэрэглэгчдийг синк хийж чадсангүй.",
			multi_face_roster_detail_title: "Хүний дэлгэрэнгүй",
			multi_face_roster_close_detail: "Дэлгэрэнгүйг хаах",
			multi_face_roster_user_info: "Хэрэглэгчийн мэдээлэл",
			multi_face_roster_name: "Нэр",
			multi_face_roster_status_summary: "Төлөвийн хураангуй",
			multi_face_roster_present_terminals: "Байгаа терминалууд",
			multi_face_roster_events_chart_title: "Нэвтрэх терминалын үйл явдлууд",
			multi_face_roster_events_chart_subtitle:
				"Сүүлийн 30 өдрийн өдөр тутмын үйл явдал",
			multi_face_roster_events_chart_label: "Үйл явдлууд",
			multi_face_roster_events_total: "{0} үйл явдал",
			multi_face_roster_events_loading: "Үйл явдлуудыг ачаалж байна...",
			multi_face_roster_events_empty:
				"Сүүлийн 30 өдөрт нэвтрэх терминалын үйл явдал олдсонгүй.",
			multi_face_roster_events_error:
				"Энэ хүний үйл явдлуудыг ачаалж чадсангүй.",
			terminal_face_rule_registered_faces_note:
				"This rule uses the faces registered in the selected access terminal(s).",
			terminal_face_rule_registered_faces_list: "Терминалд бүртгэлтэй царай",
			terminal_face_rule_list_required:
				"The selected face terminal does not have a resolvable registered-faces list.",
			require_face_list_or_entity: "FACE rules require a list or entity",
			access_terminal_events: "Нэвтрэх терминалын үйл явдлууд",
			device_id: "Төхөөрөмжийн дугаар",
			rtsp_address: "RTSP хаяг",
			data: "Мэдээлэл",
			ms_s: "Сургалтанд хамрагдахгүй байх зургийг сонго",
			ms_c: "Сонгогдсоноос нь итгэлтэй байна уу?",
			ms_c1: "Та шинэ нууц үгийн итгэлтэй байна уу?",
			trained_thumbnail: "Сургасан өнгөц зураг",
			confidence: "Итгэл үнэмшил",
			number_detecteds: "Дугаар илэрлээ",
			device_options: "Төхөөрөмжийн сонголтууд",
			type_devices: "Төхөөрөмжийн төрөл",
			detection: "Илрүүлэх",
			evidence: "Нотлох баримт",
			config_device: "Төхөөрөмжийг тохируулах",
			rtsp_address: "RTSP хаяг",
			udp_address: "UDP хаяг",
			x: "Албан тушаал X",
			y: "Албан тушаал Y",
			w: "Өргөн",
			h: "Өндөр",
			stats: "Статистикууд",
			connections: "Холболтууд",
			country_config: "Configuracion de país",
			hosts: "Servidores",
			ms_np: "Хадгалсан профайл байхгүй байна",
			user_list: "Хэрэглэгчийн жагсаалт",
			registered_user: "Бүртгүүлсэн хэрэглэгч",
			super_user: "Супер хэрэглэгч",
			admin: "Администратор",
			operator: "Оператор",
			user_role: "Хэрэглэгчийн үүрэг",
			user_data: "Хэрэглэгчийн мэдээлэл",
			login_data: "Нэвтрэх мэдээлэл",
			forgot_psw: "Нууц үгээ мартсан байна",
			recover_psw: "Нууц үгийг сэргээх",
			search_name: "Нэрээр хайх",
			search_date: "Огноогоор нь хайх",
			search_date_range: "Огноогоор хайх",
			resizable: "Хэмжээг нь өөрчлөх боломжтой",
			draggable: "Маш их чирэгддэг",
			responsive: "Хариуцлагатай",
			prevent_collision: "Мөргөлдөхөөс урьдчилан сэргийлэх",
			static: "Статик",
			vertical_compact: "Босоо авсаархан",
			detections: "Илрүүлэлт",
			welcome: "Тавтай морилно уу",
			ms_sd: "Хяналтын самбарыг сонгоно уу",
			lpr: "LPR",
			face: "FACE",
			"Face-Access-Terminal": "Face Access Terminal",
			traffic: "TRAFFIC",
			object: "OBJECT",
			user_tracking: "Хэрэглэгч хянах",
			daily: "Өдөр бүр",
			weekly: "Долоо хоног бүр",
			ms_sp: "Имэйлээ шалгана уу, аюулгүй байдлын код илгээгдсэн байна.",
			security_code: "Аюулгүй байдлын кодыг оруулна уу",
			no_match: "Таарахгүй байна",
			match: "Тохирч байна",
			recovery_process: "Нууц үг сэргээх үйл явц",
			roi: "Сонирхсон газар",
			Roi: "Рой",
			top: "Дээд",
			left: "Зүүн",
			motion_flag: "Хөдөлгөөнт туг",
			draw_routes: "Маршрут зурах",
			duration: "Үргэлжлэх хугацаа",
			fps_top: "FPS дээд",
			use_overview: "Тоймлон ашиглана уу",
			port: "Боомт",
			ms_del: "Та үүнийг устгахыг хүсч байгаадаа итгэлтэй байна уу?",
			basic_info: "Үндсэн мэдээлэл",
			ip_rest: "IP REST",
			entry_type: "Оролтын төрөл",
			debug: "Дебаг хийх",
			speed_sensor: "Хурдны мэдрэгч",
			speed_limit: "Хурдны хязгаарлалт",
			fps: "FPS",
			plates_proc: "Плитсууд",
			use_subdet_only: "Зөвхөн subdet ашиглана уу",
			recog_all: "Бүгдийг тэмдэглэ",
			use_cascade: "Каскад ашиглана уу",
			step_udp_stream: "Алхам UDP урсгал",
			events: "Үйл явдал",
			created_at: "Үүсгэсэн огноо",
			monthly_events: "Сарын арга хэмжээ",
			daily_events: "Өдөр тутмын үйл явдлууд",
			status_queue: "Статусын дараалал",
			total_income: "Нийт орлого",
			news: "Мэдээ мэдээлэл",
			total_onqueue: "Нийт дараалалд байна",
			offline: "Оффлайн",
			online: "Онлайн",
			inputs: "Оролтууд",
			input: "Оролт",
			relays: "Релей",
			relay_status: "Релейн төлөв",
			waiting_relay_data: "Релейн мэдээлэл хүлээж байна...",
			error_loading_relays: "Релей ачаалахад алдаа гарлаа",
			more_details: "Илүү дэлгэрэнгүй мэдээллийг",
			details: "Дэлгэрэнгүй мэдээлэл",
			// Compat: зарим дэлгэцүүд испани түлхүүрийг шууд ашигладаг
			Detalles: "Дэлгэрэнгүй мэдээлэл",
			// Counter modal
			counter_details: "Тоолуурын дэлгэрэнгүй",
			rfid: "RFID",
			photo_segment: "Зургийн хэсэг",
			plate: "Улсын дугаар",
			// Төлөв/дэлгэрэнгүй түлхүүрүүд
			ok: "OK",
			auth_invalid: "Нэвтрэх мэдээлэл буруу",
			device_offline: "Камер асаагдаагүй эсвэл нэвтрэх боломжгүй",
			list_id: "Жагсаалтын ID",
			list_name: "Жагсаалтын нэр",
			motive: "Шалтгаан",
			creation_date: "Үүсгэсэн огноо",
			update_date: "Шинэчлэгдсэн огноо",
			type: "Төрөл",
			description: "Тайлбар",
			online_events: "Онлайн илэрц",
			offline_events: "Офлайн илэрц",
			ms_adh: "Платформ эхлүүлэх, үзэхийн тулд шинэ хост сонгох ба нэмнэ үү",
			photo: "Фото зураг",
			segment: "Дугаарын зураг",
			dvr: "DVR",
			manager_id: "Менежерийн дугаар",
			add_components: "Бүрэлдэхүүн хэсгүүдийг нэмнэ",
			lpr_events: " Дугаарын илэрц",
			events_rfid: "RFID илэрц",
			device_list: "Төхөөрөмжийн жагсаалт",
			drawable_options: "Зурах боломжтой сонголтууд",
			grid_options: "Сүлжээний сонголтууд",
			video_stream: "Видео урсгал",
			installation_process: "Суулгах үйл явц",
			match_rules: "Тоглолтын дүрэм", // тааруулах тохиргоо / tuning settings
			new_match_rule: "Тоглолтын шинэ дүрэм",
			select_host_lpr: "Хост LPR-г сонгоно уу",
			select_host_rfid: "Хост RFID сонгоно уу",
			select_rfid_ant: "RFID ANT сонгоно уу",
			match_history: "Тоглолтын түүх",
			ant: "Ant",
			epc: "Epc",
			memory_data: "Санах ойн мэдээлэл",
			rssi: "rssi",
			date_lpr: "Огноо LPR",
			date_rfid: "Огноо RFID",
			host_config_logs: "Хост тохируулгын бүртгэлүүд",
			integration: "Интеграцчлал",
			manager: "Менежер",
			ip_address: "IP хаяг",
			integration_config: "Интеграцийн тохиргоо",
			cloud_config: "CLOUD тохиргоо",
			list: "Жагсаалт",
			cloud: "CLOUD",
			config_file: "Тохиргооны зам",
			ms_del: "Та устгахдаа итгэлтэй байна уу?",
			deleted: "Устгасан",
			updated: "Шинэчлэгдсэн",
			saved: "Хадгалсан",
			registered: "Бүртгэгдсэн",
			edited: "Зассан байна",
			video_streams: "Видео урсгал",
			hostname: "Камерын нэр",
			ip: "IP",
			status: "Статус",
			total: "Нийт",
			onqueue: "Онкью",
			axle: "Тэнхлэг",
			weight: "Жин",
			number_passenger: "Зорчигчийн дугаар",
			payment: "Төлбөр",
			type_encode_media: "Кодчилогч медиаг бичнэ үү",
			type_integrate: "Төрөл нэгтгэх",
			cancel: "Цуцлах",
			select_lane: "Эгнээ сонгоно уу",
			lane: "Эгнээ",
			add_tariff: "Тариф нэмэх",
			tariffs: "Тарифууд",
			type_vehicle: "Тээврийн хэрэгслийн төрөл",
			direction: "Чиглэл",
			type_transport: "Тээврийн төрөл",
			np_start: "Зорчигчдын тоо эхэлдэг",
			np_end: "Зорчигчдын тоо дуусна",
			weight_init: "Эхний жин",
			weight_end: "Жингийн төгсгөл",
			person: "Хүн",
			n_a: "Хоосон",
			payments: "Төлбөр",
			ms_sel: "Сургахаар зургаа сонгоно уу",
			folder_name: "Фолдерын нэр",
			minimum_selected: "Хамгийн бага нь сонгогдсон",
			missing_data: "Мэдээлэл байхгүй байна",
			traffic_lights: "Гэрлэн дохио",
			port_server_modbus: "Порт сервер",
			uselanes: "Эгнээ ашиглана уу",
			use_ocr: "Use OCR",
			laneconfig: "OCR ашиглах",
			wb_violation: "Цагаан хайрцагны зөрчил",
			wb_vio_time: "Цагаан хайрцаг цаг",
			quadrants: "Дөрвөлжин",
			gpu: "GPU",
			uuid: "UUID",
			ms_reset:
				"Одоогийн өгөгдөл алдагдах болно. Үндсэн мэдээллээс бусад. Та өгөгдмөл утгуудыг тохируулах гэж байгаадаа итгэлтэй байна уу?",
			lanes_id: "Эгнээний дугаар",
			lanes: "Эгнээ",
			type_lane: "Эгнээ эгнээ",
			turns: "Эргэдэг",
			turn: "Эргэлт",
			street_cam: "Гудамжны камер",
			top_view_cam: "Шилдэг харах камер",
			mapview: "Газрын зураг",
			ms_complet: "Бүх талбарыг бөглөнө үү",
			alerts: "Зөрчлийн бүртгэл",
			ocr_found: "OCR олдсон",
			coord: "Координатууд",
			speed: "Хурд",
			speed_limit: "Хурдны хязгаарлалт",
			size: "Хэмжээ",
			plate_search: "Улсын дугаар хайх",
			host_id: "ID de Host",
			no_valid: "Хүчин төгөлдөр бус",
			invalid_ip: "Буруу IP байна",
			ms_dwh:
				"Ройыг дахин зурах буюу сунгана уу, Ройын хэмжээс нь 0.50-аас их, өндөр нь 0.10-аас хэтрэхгүй байх ёстой",
			latitude: "Өргөрөг",
			longitude: "Урт",
			state: "Улсын",
			rtsp_path: "RTSP зам",
			lat: "Лат",
			long: "Урт",
			no_data: "Дата байхгүй байна",
			create_dashboard: "Хяналтын самбар үүсгэх",
			create_dashboard_profile: "Хяналтын самбарын профайл үүсгэх",
			ms_new_dashboard: "Шинэ хянах самбартаа нэр бичнэ үү",
			saved_profile: "Хадгалсан профайл",
			updated_profile: "Шинэчлэгдсэн профайл",
			connection_type: "Холболтын төрөл",
			ms_sel_type: "Төрлийг сонгоно уу",
			ms_name_exist: "Ийм нэртэй байна, өөр нэр оруулна уу", //Энэ нэр нь аль хэдийн үүссэн, өөр нэрийг оруулна уу
			ms_rename_dashboard:
				"Хэрэв та профайлын нэрийг өөрчлөхийг хүсвэл шинэ нэр оруулна уу.",
			update_profile: "Хувийн мэдээллийг шинэчлэх",
			update_dashboard_profile: "Хяналтын самбарын профайлыг шинэчилнэ үү",
			blacklist: "Хар жагсаалт",
			active: "Идэвхтэй",
			inactive: "Идэвхгүй байна",
			motive: "Хөдөлгөөнтэй",
			refresh: "Сэргээнэ үү",
			matches_found: "Тохирсон үр дүн олдсон",
			matches_no_found: "Тохирсон зүйл олдсонгүй",
			light: "Цагаан",
			night: "Хар",
			language: "Хэл",
			language_english: "Англи",
			language_spanish: "Испани",
			language_mongolian: "Монгол",
			gpu_device: "GPU төхөөрөмж",
			ocr_port: "OCR порт",
			decoding_type: "Код тайлах төрөл",
			added: "Нэмэгдсэн",
			notifications: "Мэдэгдэл",
			virtual_keyboard: "Виртуал гар",
			records: "Бичлэг",
			limit: "Хязгаарлалт",
			mb: "МБ",
			delete_profile: "Хувийн мэдээллийг устгах", //Профайлын самбарыг устгах
			lanes_config: "Эгнээний тохиргоо",
			location: "Байршил",
			general_parameters: "Ерөнхий параметрүүд",
			number_items: "Тоо зүйл",
			no_records_found: "Ямар ч бичлэг олдсонгүй",
			records_found: "Бичлэг олдсон",
			plate_chars: "Улсын дугаар",
			plate_char: "Улсын дугаар",
			img: "Дугаарын зураг",
			location_host: "Байршил", // translated
			expire_date_vehicle_inspection: "ҮЗЛЭГ ОНШИЛГООНЫ ЗӨРЧИЛ",
			point_a: "А цэг",
			point_b: "Б цэг",
			distance: "Зай",
			km_h: "Км / цаг",
			video_type: "Видеоны төрөл",
			video_stream_type: "Видео дамжуулалтын төрөл",
			stream_flv: "FLV",
			stream_ws: "WS-FLV",
			stream_hls: "HLS",
			stream_udp: "UDP",
			data_no_found: "Мэдээлэл олдсонгүй",
			data_found: "Мэдээлэл олдсон",
			invalid_empty_records: "Видеоны URL буруу эсвэл хоосон байна",
			ms_sel_dd: "Жагсаалт хийх огноо, төхөөрөмжийг сонгоно уу",
			udp_connection: "UDP холболт",
			stream_element: "Видео дамжуулалтын элемент",
			stream_data: "Видео урсгалын мэдээлэл",
			enter_value: "Утга оруулна уу",
			connecting: "Холбож байна",
			reconnecting: "Дахин холбогдож байна",
			connected: "Холбогдсон байна",
			disconnected: "Холбогдоогүй байна",
			events_received: "Үйл явдлыг хүлээн авсан",
			alert_sound: "Дуут дохио",
			sync_alarm_list: "Сэрүүлгийн жагсаалтыг синк хийж байна",
			loading_hosts_list: "Хост жагсаалтыг ачаалж байна",
			loaded_hosts_list: "Хост жагсаалтыг ачаалж байна",
			loading_devices_list: "Төхөөрөмжийн жагсаалтыг ачаалж байна",
			loaded_devices_list: "Ачаалагдсан төхөөрөмжүүдийн жагсаалт",
			loading_dashboard_profile: "Cargando perfil de tablero",
			loaded_dashboard_profile: "Perfil de tablero cargado",
			loading_dashboard: "Cargando Dashboard",
			please_wait: "Por favor espere...",
			safe_zone: "Zona segura",
			contact_list: "Харилцагчийн жагсаалт",
			telephone: "Утас",
			cellphone: "Гар утас",
			alert_sounds_settings: "Сэрэмжлүүлэг сонсогдож байна",
			sounds: "Дуу чимээ",
			pop_ups: "Поп хүрэгчид",
			nvr: "NVR",
			vid_path: "Vid зам",
			port_rest: "Боомтын амралт",
			type_decoding: "Декодчилох хэлбэр",
			motion_threshold: "Хөдөлгөөний босго",
			detection_threshold: "Илрүүлэх босго",
			tracker_max_frames: "Хамгийн дээд хэмжээтэй фреймүүд",
			obj_to_detect: "Obj илрүүлэх",
			detect: "Илрүүлэх",
			debug: "Дибаг хийх",
			stream_ip: "IP дамжуулах",
			stream_port: "Урсгалын боомт",
			video_source: "Видео эх сурвалж",
			reconnecting_ws: "WS-ийг 30 секундын дотор дахин холбоно уу",
			timeout: "Завсарлага",
			seconds: "Секунд",
			add_device: "Төхөөрөмж нэмэх",
			ip_cam: "IP CAM",
			constellation: "Од эрхэс",
			streaming: "Видео дамжуулалт",
			config: "Config",
			timeline: "Он цагийн хэлхээс",
			alarms: "Сэрүүлэг",
			zones: "Бүсүүд",
			areas: "Талбай",
			hardware_requirements: "Тоног төхөөрөмжид тавигдах шаардлага",
			demo_version: "Демо хувилбар",
			register: "Бүртгүүлэх",
			zone: "Бүс",
			container: "Сав",
			path_file: "Зам файл",
			motion: "Motion",
			anomalies: "Anomalies",
			objects: "Objects",
			human_actions: "Human actions",
			face_recognition: "Face recognition",
			gun: "Gun",
			weapon_detector: "Weapon detector",
			tags: "Шошго",
			tag: "Шошго",
			motion: "Хөдөлгөөн",
			categorie: "Ангилал",
			sel_new_location: "Шинэ байршил сонгох",
			my_streaming: "My Streaming",
			stream_ws1: "WS",
			min_alert: "Сэрэмжлүүлгийн горимыг багасгасан",
			map: "Газрын зураг",
			createdAt: "Үүсгэсэн",
			no_receiving_stream: "Урсгал хүлээж авахгүй байна",
			popup_timeout: "Завсарлага",
			alert_time: "Анхааруулах цаг",
			sound: "Дуу",
			frequency_smart_event: "Ухаалаг үйл явдлын давтамж",
			frequency_smart_event_tooltip:
				"Ухаалаг үйл явдал хэр олон удаа үүсэхийг тодорхойлно (минутаар). 0 гэдэг нь нөхцөл хангагдах бүрт үйл явдал үүснэ гэсэн үг.",
			smart_event_cooldown_seconds_label: "Cooldown event/alert (seconds)",
			frequency: "Давтамж",
			popup: "Нээх",
			access: "Хандалт",
			prediction: "Урьдчилан таамаглах",
			folder: "Фолдерын зам",
			probability: "Магадлал",
			hands_up: "Гараа өргө",
			record: "Бичлэг",
			timezone: "Цагийн бүс",
			select_timezone: "Цагийн бүсийг сонгоно уу",
			protocol: "Протокол",
			protocol_socket: "Протокол сокет",
			ip_socket: "IP сокет",
			port_socket: "Порт сокет",
			port_face: "Порт Face",
			parameters: "Параметрүүд",
			parameter: "Параметр",
			color: "Өнгө",
			line_width: "Шугамын өргөн",
			playback: "Playback",
			alarm: "Сэрүүлэг",
			monday: "Даваа гараг",
			tuesday: "Мягмар гараг",
			wednesday: "Лхагва гараг",
			thursday: "Пүрэв",
			friday: "Баасан гараг",
			saturday: "Бямба",
			sunday: "Ням гараг",
			interval: "Интервал",
			notifiable: "Мэдэгдэх боломжтой",
			send_ws: "Telegram илгээх",
			send_email: "И-мэйл илгээх",
			schedule: "Хуваарь",
			analytic: "Аналитик",
			count_device: "Төхөөрөмжийг тоолох",
			alarm_info: "Сэрүүлгийн мэдээлэл",
			capacity: "Хүчин чадал", // Чадавхи
			minimum_time: "Тiempo mimimo",
			channel: "Canal",
			smart_event: "Smart event",
			channels: "Channels",
			ip_stream: "IP урсгал",
			port_stream: "Боомтын урсгал",
			ModBus: "ModBus",
			useLanes: "Эгнээ ашиглана уу",
			laneConfig: "Lane Config",
			port_overview: "Боомтын тойм",
			videoEvidence: "Видео баримт",
			videoDuration: "Видео үргэлжлэх хугацаа",
			use_OCR: "OCR ашиглах",
			lane: "Эгнээ",
			lane1: "1-p Эгнээ",
			lane2: "2-p Эгнээ",
			lane3: "3-p Эгнээ",
			lane4: "4-p Эгнээ",
			lane5: "5-p Эгнээ",
			lane6: "6-p Эгнээ",
			type: "Төрөл",
			type1: "1 Төрөл",
			type2: "2 Төрөл",
			type3: "3 Төрөл",
			type4: "4 Төрөл",
			type5: "5 Төрөл",
			type6: "6 Төрөл",
			turn: "Эргэх",
			turn1: "1 Эргэх",
			turn2: "2 Эргэх",
			turn3: "3 Эргэх",
			turn4: "4 Эргэх",
			turn5: "5 Эргэх",
			turn6: "6 Эргэх",
			statistics: "Статистик",
			analytics: "Аналитик",
			analytics_logs: "Аналитик бүртгэл",
			recording: "Бичлэг хийх",
			on: "АСААЛТТАЙ",
			off: "УНТРАА",
			table_no_exist: "Энэ хүснэгт байхгүй байна",
			table_no_enable: "Энэ хүснэгт идэвхжээгүй байна",
			clear_console: "Консолыг арилгах",
			novideo_source: "Видео эх сурвалж",
			app_full_frame: "Апп бүрэн хүрээ",
			frame_resize_width: "Хүрээний хэмжээг өөрчлөх",
			frame_resize_height: "Хүрээний хэмжээг өөрчлөх",
			max_object_size: "Объектын дээд хэмжээ",
			redis_port: "Redis порт",
			motion_method: "Хөдөлгөөний арга",
			jump_n_frames_for_proccess: "Проксын хувьд жааз үсрэх",
			draw: "Зурах",
			DO_MOTION: "Хөдөлгөөнийг хий",
			display_by_analytics: "Аналитик замаар харуулах",
			rest_ip: "REST IP",
			rest_port: "REST порт",
			roi1: "ROI1",
			roi2: "ROI2",
			rtsp: "RTSP",
			rtsp2: "RTSP2",
			deviceId: "Төхөөрөмжийн дугаар",
			redis_ip: "Redis IP",
			settings_smart_event: "Ухаалаг үйл явдлын тохиргоо",
			entry_type: "Оруулах төрөл",
			white_box_limits: "Цагаан хайрцгийн хязгаар",
			gpu_device: "GPU төхөөрөмж",
			lists: "Жагсаалт",
			new_list: "Шинэ жагсаалт",
			listing_setting: "Жагсаалтын тохиргоо",
			listing_details: "Дэлгэрэнгүй жагсаалт",
			registered_list_details: "Бүртгэгдсэн жагсаалтын дэлгэрэнгүй мэдээлэл",
			require_sel_list: "Жагсаалтыг сонгох шаардлагатай",
			registered_integrations: "Бүртгэгдсэн интеграцууд",
			video_segments: "Видео сегментүүд",
			mode: "Горим",
			manage: "Удирдах",
			AG_REDIS_111:
				"Үйлчилгээг эхлүүлэхэд асуудал гарсан тул дэмжлэгтэй холбоо барина уу",
			technical_records: "Техникийн бүртгэл",
			AG_BK_RECORD_001: "Камер бичлэг хийж эхэллээ",
			AG_BK_RECORD_002: "Одоогийн байдлаар камер бичлэг хийхгүй байна",
			AG_BK_RECORD_003:
				"Камер бичихгүй байгаа тул дахин эхлүүлэхийг оролдож байна", // 'Камер бичлэгийг дахин эхлүүлэхийг оролдож байна',
			AG_BK_RECORD_000: "Камер бичлэг хийж байна",
			section: "Хэсэг",
			alert: "Анхааруулга",
			AG_BK_DISK_001: "Диск олдсонгүй, дискний анхдагчаар эхэл",
			AG_BK_DISK_007: "Диск анхдагч үүсгэсэн",
			AG_BK_DISK_011: "Анхдагч байдлаар үүсгэсэн дискний алдаа",
			AG_DEV_002: "Төхөөрөмжийн алдаа",
			AG_DEV_005: "Төхөөрөмжийг шалгана уу",
			not_permissions: "Танд зөвшөөрөл байхгүй байна",
			activate: "Идэвхжүүлэх",
			confirm_upgrade: "Шинэчлэлтийг баталгаажуулна уу",
			AG_BK_GPS_017: "Координат хүлээн аваагүй, хамрах хүрээнээс гадуур",
			req_sel_device: "Шаардлагатай: төхөөрөмжийг сонгоно уу ",
			scale: "Улсын дугаар",
			Scale: "Хуваарь",
			smart_reports: "Ухаалаг үйл явдлын тайлан",
			no_info_page: "Энэ хуудсан дээр мэдээлэл олдсонгүй.",
			no_found_page: "Хуудас олдсонгүй",
			registered_smart_event: "Бүртгэгдсэн ухаалаг үйл явдлууд",
			registered_devices: "Бүртгэгдсэн төхөөрөмжүүд",
			support: "Дэмжлэг",
			notifications_technical: "Техникийн мэдэгдлүүд",
			profiles_default: "Өгөгдмөл профайл",
			dashboards: "Хяналтын самбар",
			components: "Бүрэлдэхүүн хэсгүүд",
			select_dates: "Огноог сонгоно уу",
			req_sel_analitic: "Аналитикийг сонгох шаардлагатай",
			no_res_server: "Серверээс хариу ирээгүй байна",
			req_sel_analytic_tag: "Аналитик болон шошго сонгох шаардлагатай",
			bike: "Унадаг дугуй",
			bus: "Автобус",
			truck: "Ачааны машин",
			car: "Машин",
			laptop: "Зөөврийн компьютер",
			motorcycle: "Мотоцикл",
			area_interest: "Сонирхсон газар",
			motorbike: "Мотоцикл",
			suggested_timezone: "Санал болгож буй цагийн бүс",
			registered_zones: "Бүртгэгдсэн бүсүүд",
			select_zone: "Бүс сонгох",
			type_zone: "Бүс бичих",
			background_image: "Арын зураг",
			sync_blacklist: "Хар жагсаалтыг синк хийх",
			sync_cloud: "CLOUD -той синк хийх",
			upload_imagen: "Төсөөллийг байршуулах",
			req_name_file_upload: "Байршуулахад шаардлагатай бүсийн нэр эсвэл файл",
			uploaded_image: "Байршуулсан зураг",
			bbox: "",
			bbox_: "Хязгаарлах хайрцаг",
			tag_count: "Шошго тоолох",
			list_id: "Жагсаалтын ID",
			entity: "Байгууллага",
			click_test_video: "Видеог туршихын тулд дарна уу",
			select_record_rtsp: "Энэхүү RTSP -г бичихийн тулд сонгоно уу",
			disk: "Диск",
			disks: "Диск",
			registered_disks: "Бүртгэгдсэн дискүүд",
			required_range_24h: "Шаардлагатай хүрээ 24 цаг",
			no_found_id_del: "Устгах зүйлийн ID олдсонгүй",
			not_found: "Олдсонгүй",
			not_found_propierties: "Үл хөдлөх хөрөнгө олдсонгүй",
			delete_shape: "Дүрсийг устгах",
			new_shape: "Шинэ хэлбэр",
			registered_lists: "Бүртгэгдсэн жагсаалтууд",
			not_found_device: "Төхөөрөмж олдсонгүй",
			not_found_tag: "Шошго олдсонгүй",
			owner: "Эзэмшигч",
			visitor: "Зочин",
			current_photo: "Одоогийн зураг",
			trained_photo: "Сургалтанд хамрагдсан зураг",
			registering_user: "Хэрэглэгчийг бүртгэж байна",
			role_not_valid: "Сонгосон үүрэг буруу байна",
			role: "Үүрэг",
			invalid_password: "Нууц үг буруу байна",
			required: "Шаардлагатай",
			whatsapp: "Whatsapp",
			enable: "Идэвхжүүлэх",
			url: "URL",
			import: "Импорт",
			export: "Экспорт",
			registered_schedules: "Бүртгэгдсэн хуваарь",
			confirm_reset: "Дахин тохируулахыг баталгаажуулна уу",
			download: "Татаж авах",
			current_page: "Одоогийн хуудас",
			current_videos: "Одоогийн видеонууд",
			all: "Бүгд",
			select_videos: "Видео сонгох",
			select_items: "Зүйлс сонгох",
			media_path: "Хэвлэл мэдээллийн зам",
			server_ip: "Серверийн IP",
			server_port: "Сервер порт",
			poligons: "Олон өнцөгт",
			code: "Код",
			module: "Модуль",
			detail: "Дэлгэрэнгүй",
			req_id_del: "Устгахын тулд ID шаардлагатай",
			req_created_devices: "Үүсгэсэн төхөөрөмжүүдийг шаарддаг",
			timelapse: "Хугацаа алдсан",
			min_6_characters: "Хамгийн багадаа 6 тэмдэгт",
			valid: "Хүчинтэй",
			confirmed: "Батлагдсан",
			and_reseted: "Тэгээд дахин байгуулсан",
			reseted: "Дахин тохируулсан",
			change_password: "Нууц үг солих",
			new_zone: "Шинэ бүс",
			zone_settings: "Бүсийн тохиргоо",
			discovered_devices: "Илэрсэн төхөөрөмжүүд",
			clear_logs: "логуудыг цэвэрлэх",
			restart: "Дахин ачааллах",
			restarted: "Дахин эхлүүлсэн",
			start: "Эхлэх",
			started: "Эхэлсэн",
			stop: "Зогс",
			stopped: "Зогссон",
			store_chunks: "Хэсэг хэсгүүдийг хадгалах",
			video_size_factor: "Видео хэмжээний хүчин зүйл",
			is_record: "рекорд юм",
			channel_record: "Сувгийн бичлэг",
			registered_colors_bbox: "Бүртгэгдсэн өнгө Bbox",
			registered_sounds: "Бүртгэгдсэн дуу чимээ",
			logo: "Лого",
			logos: "Лого",
			registered_faces: "Бүртгэгдсэн FACE",
			view_grid: "Сүлжээг харах",
			view_list: "Жагсаалтыг харах",
			xaddr: "xaddr",
			updatedAt: "Шинэчлэгдсэн цаг",
			delete_devices: "Төхөөрөмжүүдийг устгах",
			backup: "Нөөц",
			restore_backup: "Нөөцөөс сэргээх",
			ms_dashboard_empty:
				"Хяналтын самбар хоосон. Бүрэлдэхүүн хэсгүүдийг нэмнэ үү",
			used: "Ашигласан",
			space: "Орон зай",
			waiting: "Хүлээж байна",
			waiting_: "Хүлээж байна...",
			AG_BK_RECORD_004: "RTSP NULL, RTSP-г тохируулах шаардлагатай",
			max_buffer: "Хамгийн их буфер",
			amount_to_delete: "Устгах дүн",
			limit_erased_recording: "Бичлэгийг устгахыг хязгаарлах",
			limit_erased_evidences: "Нотлох баримт устгах хязгаар",
			percent_limit_del_evidences: "Нотлох баримт устгаж эхлэх диск %",
			rtsp_timeout: "RTSP timeout (s)",
			storage: "Хадгалах",
			AG_BK_RETRASMISSION_004: "Хаалттай дахин дамжуулалт",
			AG_BK_PING_DEVICE_000: "Төхөөрөмжийн нөхцөл байдал сайн байна",
			AG_BK_PING_DEVICE_001: "Төхөөрөмжийн пинг саатаж байна",
			AG_BK_PING_DEVICE_002: "Төхөөрөмжийн ping илэрсэнгүй",
			AG_BK_RETRASMISSION_002: "дахин дамжуулахтай холбоотой алдаа",
			AG_BK_PING_NETWORK_000: "Сүлжээний нөхцөл байдал сайн байна",
			AG_BK_PING_NETWORK_002: "Сүлжээтэй Ping илэрсэнгүй",
			AG_BK_DISK_000: "Диск сайн нөхцөлд.",
			AG_BK_DISK_002: "Дискний хадгалах хэмжээ хязгаараас хэтэрсэн",
			video_evidence: "Видео нотлох баримт",
			AG_BK_RETRASMISSION_000: "Сайн холболттой дахин дамжуулалт",
			AG_BK_RETRASMISSION_001: "Релейг дахин холбож байна",
			computer: "Компьютер",
			device_ping: "Төхөөрөмжийн ping",
			retransmission: "Дахин дамжуулах",
			confirm_logout: "Та гарахдаа итгэлтэй байна уу",
			AG_BK_RTSP_000: "Видео дамжуулалт ажиллаж байна",
			AG_BK_RTSP_002: "Видео цацалтыг авч чадсангүй",
			workspace: "Ажлын талбар",
			only_fails: "Зөвхөн бүтэлгүйтдэг",
			select_retransmission: "Нэвтрүүлгийн видео нийтлэх",
			port_socket_msg: "Хэрэв IP хаяг порт агуулсан бол нэмнэ үү",
			name_cloud_msg: "Энэ нь ажлын талбарыг тодорхойлох явдал юм",
			registered_workspaces: "Бүртгэгдсэн ажлын талбарууд",
			more_options: "Илүү олон сонголт",
			download_pdf: "PDF татаж авах",
			download_excel: "EXCEL татаж авах",
			hide_filters: "Шүүлтүүрийг нуух",
			show_filters: "Шүүлтүүрийг харуулах",
			redirect_reports: "Тайлан руу дахин чиглүүлэх",
			select_tags: "Шошгуудыг сонгоно уу",
			ignore: "Үл тоомсорлох",
			send: "Илгээх",
			confirm_options: "Сонголтуудыг баталгаажуулна уу",
			magament_incidents: "Үйл явдлын менежмент",
			type_peripheral: "Захын төрөл",
			new_peripheral: "Шинэ захын төхөөрөмж",
			pin: "Pin",
			type_device: "Төрөл төхөөрөмж",
			access_control: "Хандалтын хяналт",
			access_control_vendor: "Brand",
			access_control_integrated_model: "Integrated model",
			access_control_vendor_fallback: "Could not load brands from the server. Using local fallback options.",
			access_control_models_unavailable: "Could not load integrated models. Enter the model manually and continue.",
			access_control_model_manual_hint: "If the model list is unavailable, type the integrated model manually.",
			access_control_vendor_required: "Select the terminal brand before continuing.",
			access_control_model_required: "Select or enter the integrated model before continuing.",
			access_control_terminal_required: "Complete name, IP, user and password before continuing.",
			access_control_probe_terminal: "Detect terminal information",
			access_control_probe_running: "Detecting terminal information...",
			access_control_probe_success: "Terminal information detected.",
			access_control_probe_unavailable: "Could not detect terminal information. You can continue manually.",
			access_control_server_location_loaded: "Server location loaded as default. You can adjust it on the map.",
			access_control_server_location_unavailable: "Could not load the server location. Select the location manually on the map.",
			access_control_rtsp_url: "RTSP stream URL",
			access_control_rtsp_preview: "RTSP preview",
			access_control_rtsp_preview_help: "Use the same RTSP test flow as camera registration. If the browser cannot play it directly, keep the RTSP and continue.",
			access_control_rtsp_required: "RTSP stream URL required",
			access_control_rtsp_invalid: "RTSP URL must start with rtsp://",
			access_control_rtsp_preview_unavailable: "RTSP preview is unavailable through the current media path. You can keep editing the form.",
			access_control_rtsp_backend_dependency: "RTSP persistence requires backend support. Save without RTSP or update the backend dependency.",
			access_control_backend_device_id_contract: "The backend must generate deviceId automatically. Current backend validation is incorrectly requiring it.",
			access_control_step_vendor_title: "Choose the brand",
			access_control_step_vendor_help: "Start by selecting the terminal brand supported by the integration.",
			access_control_step_model_title: "Choose the model",
			access_control_step_model_help: "Select the integrated model available for the selected brand.",
			access_control_step_terminal_title: "Terminal data",
			access_control_step_terminal_help: "Enter name, IP, user, password and serial. The system will try to detect information automatically.",
			access_control_step_video_title: "Video and RTSP",
			access_control_step_video_help: "Add or test the RTSP URL associated with the terminal camera.",
			access_control_step_location_title: "Terminal location",
			access_control_step_location_help: "Confirm the server default location or select another point on the map.",
			drag_drop_audio: "Аудио чирж оруулна уу",
			invalid_audio_file: "Зөвхөн аудио файл зөвшөөрнө.",

			action_device_empty_actions: "No configured actions to show.",
			action_device_details_toggle: "View full details",
			action_device_default_title: "Configured action",
			action_device_type_unknown: "Undefined type",
			action_device_type_peripheral: "Peripheral",
			action_device_type_access_control: "Access control",
			action_device_type_device: "Camera / device",
			action_device_type_system: "System",
			action_device_condition_success: "when successful",
			action_device_condition_failure: "when it fails",
			action_device_selected_device_fallback: "selected device",
			action_device_sound_fallback: "configured sound",
			action_device_sentence_play_audio: "Play",
			action_device_sentence_on: "on",
			action_device_sentence_snapshot: "Take a photo on",
			action_device_sentence_record: "Record video on",
			action_device_sentence_webhook: "Send an external URL notice",
			action_device_sentence_smart_event: "Change a smart event state",
			action_device_detail_condition: "Condition",
			action_device_detail_sound_value: "Sound / value",
			action_device_description_placeholder: "Welcome sound",
			action_device_action_play_audio: "Play audio",
			action_device_action_send_value: "Send relay state",
			action_device_action_snapshot: "Take photo",
			action_device_action_record: "Record video",
			action_device_action_webhook: "External URL notice",
			action_device_action_blink: "Blink",
			action_device_action_ring: "Ring",
			action_device_action_change_smart_event_status: "Change smart event state",
			action_device_action_connect: "Connect",
			action_device_action_start_counter: "Start counter",
			action_device_action_end_counter: "End counter",
			action_device_assistant_intro:
				"Follow these steps to explain what the action does, where it runs, and when it should run.",
			action_device_step_identify_title: "Identify this action",
			action_device_step_identify_help:
				"Use a short name operators can recognize later, for example: Welcome sound.",
			action_device_step_target_title: "Choose where it will run",
			action_device_step_target_help:
				"Select the equipment type, the device, and the action to perform.",
			action_device_step_config_title: "Configure what it will do",
			action_device_step_config_help:
				"Only the fields needed for the selected action are shown here.",
			action_device_step_timing_title: "Choose when it runs",
			action_device_step_timing_help:
				"Define if this action runs when the alarm succeeds, fails, or changes an event.",
			action_device_label_relay_channel: "Relay channel",
			action_device_label_relay_state: "Relay state",
			action_device_label_start_wait: "Wait before executing",
			action_device_label_active_duration: "Active time",
			action_device_label_when: "When should it run?",
			action_device_help_description:
				"This name is for the operator. It helps identify the action without reading technical values.",
			action_device_help_type:
				"Choose the family of equipment: camera, peripheral, access control, or system.",
			action_device_help_device:
				"Choose the physical device where this action will run.",
			action_device_help_action:
				"Choose what the system should do with the selected device.",
			action_device_help_destiny:
				"Choose who should receive or use this action result.",
			action_device_help_sound:
				"Choose the audio that will be played on the selected terminal.",
			action_device_help_sound_file:
				"Upload a new audio file if it is not already listed.",
			action_device_help_delay:
				"How long the action stays active before returning to its initial state.",
			action_device_help_seconds:
				"Seconds to wait before the action starts executing.",
			action_device_help_relay_channel:
				"Relay channel to control on the peripheral device.",
			action_device_help_relay_state:
				"State to send to the relay channel: ON or OFF, according to the device configuration.",
			action_device_help_frequency:
				"Number of repetitions or execution frequency, when the device supports it.",
			action_device_help_ring_action:
				"Choose whether the sound should start or stop.",
			action_device_help_ring_file:
				"Choose the stored sound file used by the peripheral.",
			action_device_help_ring_mode:
				"Choose how the peripheral should play the sound.",
			action_device_help_count: "Number of times the action should repeat.",
			action_device_help_volume: "Volume level for the sound action.",
			action_device_help_smart_event:
				"Smart event that will be enabled, disabled, or changed by this action.",
			action_device_help_active_on:
				"Choose whether this action runs on a successful or failed alarm result.",
			medium: "Дунд",
			test_peripheral: "Захын төхөөрөмжийг турших",
			roles: "Дүрүүд",
			registered_roles: "Бүртгэгдсэн дүрүүд",
			permissions: "Зөвшөөрөл",
			registered_permissions: "Бүртгэгдсэн зөвшөөрөл",
			add: "Нэмэх",
			view: "Үзэх",
			can_add: "Нэмэх боломжтой",
			can_view: "Үзэх боломжтой",
			can_edit: "Засварлах боломжтой",
			can_update: "Шинэчилж болно",
			serial: "Цуврал",
			action: "Үйлдэл",
			value: "Үнэ цэнэ",
			delay: "Саатал",
			incident: "Болсон явдал",
			incidents: "Үйл явдал",
			new_incident: "Шинэ үйл явдал",
			table: "Хүснэгт",
			none_selected: "сонгогдсонгүй",
			draw_detected_area: "Илэрсэн хэсгийг зурах",
			resource: "Нөөц",
			resources: "Нөөц",
			registered_resources: "Бүртгэгдсэн нөөц",
			managers: "Менежерүүд",
			parking: "Машины зогсоол",
			information: "Мэдээлэл",
			exit: "гарах",
			entry: "Нэвтрэх",
			invoice: "Нэхэмжлэх",
			barcode: "Бар код",
			loading_states: "Ачаалах төлөв",
			loading: "Ачааж байна",
			total_invoice: "Нийт нэхэмжлэх",
			invoice_counter: "Нэхэмжлэлийн тоолуур",
			id_invoice: "ID нэхэмжлэх",
			consecutive: "Дараалсан",
			void: "Хүчингүй",
			iva: "Ива",
			subtotal: "Дунд нийлбэр",
			total_charge: "Нийт төлбөр",
			workspaces: "Workspaces",
			domain: "Домэйн",
			counter: "Тоолуур",
			last_update: "Сүүлийн шинэчлэл",
			not_recording: "бичлэг хийхгүй байна",
			it_being_recorded: "Энэ нь аль хэдийн бичигдсэн байна",
			your_browser_not_req:
				"Таны вэб хөтөч шаардлага хангахгүй байна; Firefox эсвэл Google Chrome гэх мэт сайн хөтөч рүү шинэчилнэ үү",
			no_devices: "төхөөрөмж байхгүй",
			start_recording: "Бичлэг хийж эхлээрэй",
			stop_recording: "Бичлэгээ зогсоо",
			microphone_selection: "Микрофоны сонголт",
			device_selection: "Төхөөрөмжийн сонголт",
			audio: "Аудио",
			valid_name_without_cs: "Тусгай тэмдэгтгүй хүчинтэй нэр",
			current_password: "Одоогын Нууц Үг",
			define_new_password: "Шинэ нууц үгийг тодорхойлох",
			contacts: "Харилцагчид",
			new_contact: "Шинэ холбоо барих",
			registered_contacts: "Бүртгэгдсэн харилцагчид",
			send_telegram: "Telegram илгээх",
			telegram: "Telegram",
			settings_contact: "Тохиргоо холбоо барих",
			contact: "Холбоо барих",
			your_pws_has_changed: "Таны нууц үг амжилттай өөрчлөгдсөн байна",
			manual_confirmation: "гараар баталгаажуулах",
			type_of_contact: "Харилцааны төрөл",
			final_client: "Эцсийн үйлчлүүлэгч",
			alert_monitor: "Сэрэмжлүүлэг монитор",
			require_confirmation: "Баталгаажуулах шаардлагатай",
			confirm_alert: "сэрэмжлүүлэгийг баталгаажуулах",
			close_descriptions: "Тайлбарыг хаах",
			create_motion: "Хөдөлгөөн үүсгэх",
			confirmed_date: "Батлагдсан огноо",
			confirmed_alert: "Баталгаажсан сэрэмжлүүлэг",
			not_confirmed: "Батлагдаагүй",
			alarm_name: "Сэрүүлгийн нэр",
			address: "Хаяг",
			date_birth: "Төрсөн өдөр",
			profiles: "Профайлууд",
			new_profile: "Шинэ профайл",
			registered_profiles: "Бүртгэгдсэн профайлууд",
			client: "Үйлчлүүлэгч",
			other: "Бусад",
			external_customer: "гадаад үйлчлүүлэгч",
			get_arduinos: "Ардуино аваарай",
			get_devices: "Төхөөрөмж авах",
			arduino: "Arduino",
			page_not_found: "Хуудас олдсонгүй",
			redirecting_page: "Хуудсыг дахин чиглүүлж байна",
			select_dashboard: "Хяналтын самбар сонгоно уу",
			"": "",
			is_motion: "MOTION бол",
			video_for_display: "Үзүүлэн харуулах видео",
			cropping_faces: "тайрах нүүр",
			"hand-up": "Гараа өргө",
			detected: "Илэрсэн",
			all: "Бүгд",
			event: "Үйл явдал",
			not_tagged: "Тэмдэглэгдээгүй",
			telegramAPI: "Telegram API",
			name_guardian: "нэр GUARDIAN",
			uuid_guardian: "UUID Guardian",
			broker_password: "Брокерын нууц үг",
			broker_username: "Брокерын хэрэглэгчийн нэр",
			broker_address: "Брокерын хаяг",
			broker_port: "Брокер порт",
			route: "Маршрут",
			component: "Бүрэлдэхүүн хэсэг",
			api: "API",
			// CitizenFace API translations
			citizen_title: "Регистрээр",
			citizenface_api_integration: "CitizenFace API интеграци",
			citizen_query_title: "Иргэний хайлт - CitizenFace API",
			citizen_id_label: "Иргэний ID",
			citizen_id_placeholder: "Жишээ: CO8709023T63",
			citizen_id_required: "ID шаардлагатай",
			citizen_id_required_integration:
				"Иргэний ID шаардлагатай бөгөөд интеграци тохируулагдсан байх ёстой",
			consult: "Хайх",
			query_result_title: "Хайлтын үр дүн",
			endpoint: "Төгсгөл",
			not_configured: "Тохируулагдаагүй",
			citizen_query_success: "Хайлт амжилттай хийгдлээ",
			citizen_query_error: "Иргэнийг хайхад алдаа гарлаа",
			add_unlisted_resources: "Жагсаалтад ороогүй эх сурвалжуудыг нэмнэ үү",
			not_found_items_add: "Нэмэх зүйл олдсонгүй",
			new_resource: "Шинэ нөөц",
			add_unlisted_permissions: "Жагсаалтад ороогүй зөвшөөрлийг нэмнэ үү",
			req_id_to_update: "Шинэчлэхийн тулд ID шаардлагатай",
			knife: "Хутга",
			default: "Өгөгдмөл",
			google_analytic_id: "Google Analytic ID",
			add_permission: "Зөвшөөрөл нэмэх",
			can_delete: "Устгаж болно",
			no_have_permission_create: "Танд үүсгэх зөвшөөрөл байхгүй байна",
			no_have_permission_edit: "Танд засварлах зөвшөөрөл байхгүй байна",
			no_have_permission_view: "Танд үзэх зөвшөөрөл байхгүй байна",
			no_have_permission_delete: "Танд устгах зөвшөөрөл байхгүй байна",
			setting_device: "Төхөөрөмжийн тохиргоо",
			setting_analytic: "Аналитик тохиргоо",
			not_allowed_on_sight: "Харагдахыг хориглоно",
			devices: "Төхөөрөмжүүд",
			server_rtsp: "RTSP сервер",
			parked: "Зогсоолтой",
			overpaid_parking: "Илүү төлбөртэй зогсоол",
			processed_entries: "Боловсруулсан оруулгууд",
			paid: "Төлбөртэй",
			unpaid: "Төлбөргүй",
			paid_by_post: "Шуудангаар төлнө",
			whitelist: "Цагаан жагсаалт",
			others: "Бусад",
			trained: "Бүртгэлтэй хүмүүс",
			seleccion_files_to_train: "Сургалтын файлуудыг сонгох",
			number_trained: "Сургалтанд хамрагдсан дугаар",
			trained_user: "Сургалтанд хамрагдсан хэрэглэгч",
			avc: "AVC",
			vehicle_type: "Тээврийн хэрэгслийн төрөл",
			axle_counter: "Тэнхлэгийн тоолуур",
			lifted_axles: "Lifted axles",
			axle_count: "# Тэнхлэг",
			required_select_analytic: "Аналитикийг сонгох шаардлагатай",
			date_of_admission: "Элссэн огноо",
			entry_module: "Нэвтрэх модуль",
			entry_type: "Оролтын төрөл",
			departure_date: "Явах огноо",
			exit_module: "Гарах модуль",
			exit_type: "Гарах төрөл",
			rate: "Үнэлгээ",
			tax: "Татвар",
			payment_method: "Төлбөрийн нөхцөл",
			bill_number: "Тооцооны дугаар",
			is_created_automatically: "Автоматаар үүсгэгддэг",
			similar_face: "Ижил царай",
			face_detected: "Царай илэрсэн",
			faceUUID: "faceUUID",
			similarity_information: "Ижил төстэй байдлын мэдээлэл",
			alert_information: "Анхааруулга мэдээлэл",
			face_detected_information: "Нүүр илрүүлсэн мэдээлэл",
			file: "Файл",
			files: "Файлууд",
			ip_machine: "IP машин",
			image: "Зураг",
			workstation: "Ажлын станц",
			workstations: "Ажлын станцууд",
			filters: "Шүүлтүүр",
			isignored: "Үл тоомсорлодог",
			option: "Сонголт",
			false_positive: "Худал эерэг",
			ignore_alert: "Сэрэмжлүүлэгийг үл тоомсорлох",
			edit_map_name: "Газрын зургийн нэрийг засах",
			map_name: "Газрын зургийн нэр",
			zoom: "Томруулах",
			zoom_in: "Томруулах",
			zoom_out: "Жижигрүүлэх",
			zoom_with_alerts: "Анхааруулгатай томруулна уу",
			destiny: "Хувь тавилан",
			monitor: "Хяналт",
			zoom_in_alerted: "Сэрэмжлүүлгийн үед томруулна уу",
			zoom_out_after_alerted: "Сэрэмжлүүлсний дараа холд",
			clean_dashboard: "Хяналтын самбарыг цэвэрлэх",
			is_incident: "Болсон явдал",
			type_incident: "Болсон явдлыг бичнэ үү",
			evnt_type: "Үйл явдлын төрөл",
			time_to_previous_state: "Өмнөх төлөв рүү шилжих хугацаа",
			confirmed_alert: "баталгаажсан сэрэмжлүүлэг",
			automatic_activation: "автомат идэвхжүүлэлт",
			ignored_alert: "Сэрэмжлүүлгийг үл тоомсорлосон",
			unconfirmed_alert: "Баталгаажаагүй сэрэмжлүүлэг",
			deleting_dashboard: "Хяналтын самбарыг устгаж байна",
			site: "Site",
			Sera4: "Sera4",
			alert_display_time: "Сэрэмжлүүлэг харуулах цаг",
			endpoint: "эцсийн цэг",
			working: "Ажиллаж байна",
			restarting: "Дахин эхлүүлж байна",
			AG_BK_RTSP_102:
				"Rtsp-ээс хариу алга, видео эсвэл дамжуулагчтай холболтыг шалгана уу", // "Серверээс хариу ирээгүй",
			AG_BK_RTSP_112: "Сервер хүсэлтээр дүүрэн байна",
			msg_local_rtsp:
				"Орон нутгийн RTSP нь бичлэг, аналитик болон өргөн нэвтрүүлэгт ашиглагддаг",
			msg_hls: "HLS форматтай видеонд зориулсан RTSP",
			AG_BK_RTSP_122: "RTSP буруу байна, шалгана уу",
			AG_BK_RTSP_132: "дамжуулалтын баталгаажуулалтын хугацаа хэтэрсэн",
			AG_BK_RTSP_133: "Сүлжээнд видео дамжуулах боломжгүй байна",
			"AG_BK_RETRASMISSION_00-1": "Видео цацаж эхэлж байна",
			"AG_BK_RECORD_00-1": "Бичлэг хийж байна",
			google: "Google",
			//local
			AG_BK_RETRASMISSION_LOCAL_000:
				"Дотоод серверийн төлөв рүү дамжуулалтыг нийтэлж байна: АСУУДАЛ",
			AG_BK_RETRASMISSION_LOCAL_001:
				"Дотоод серверийн төлөв рүү дамжуулалтыг нийтэлж байна: Дахин ачаалж байна",
			"AG_BK_RETRASMISSION_LOCAL_00-1":
				"Дотоод серверийн төлөв рүү дамжуулалтыг нийтэлж байна : Ачаалж байна",
			AG_BK_RETRASMISSION_LOCAL_002:
				"Дотоод серверийн төлөв рүү дамжуулалтыг нийтэлж байна: Алдаа",
			AG_BK_RETRASMISSION_LOCAL_004:
				"Дотоод серверийн төлөв рүү дамжуулалтыг нийтэлж байна: OFF",
			// cloud
			AG_BK_RETRASMISSION_CLOUD_000:
				"Үүлэн төлөв рүү дамжуулалтыг нийтэлж байна : АСУУДАЛ",
			AG_BK_RETRASMISSION_CLOUD_001:
				"Үүлэн төлөв рүү дамжуулалтыг нийтэлж байна: Дахин ачаалж байна",
			"AG_BK_RETRASMISSION_CLOUD_00-1":
				"Үүлэн төлөв рүү дамжуулалтыг нийтэлж байна : Ачаалж байна",
			AG_BK_RETRASMISSION_CLOUD_002:
				"Үүлэн төлөв рүү дамжуулалтыг нийтэлж байна: Алдаа",
			AG_BK_RETRASMISSION_CLOUD_004:
				"Үүлэн төлөв рүү дамжуулалтыг нийтэлж байна: OFF",
			side: "Хажуу тал",
			way: "Арга зам",
			"AG_BK_RTSP_00-1": "Дамжуулалтын төлөвийг ачаалж байна",
			AG_BK_RETRASMISSION_003: "Видео дахин дамжуулах төлөв: анивчих",
			AG_BK_RETRASMISSION_LOCAL_003:
				"Дотоод серверийн төлөв рүү дамжуулалтыг нийтэлж байна: анивчих ",
			AG_BK_RETRASMISSION_CLOUD_003:
				"Үүлэн төлөв рүү дамжуулалтыг нийтэлж байна: анивчих",
			error_get_counter_list: "Тоологчдын жагсаалтыг авахад алдаа гарлаа",
			rules: "Дүрэм",
			required_register_one_rule: "Нэг дүрмийг бүртгүүлэх шаардлагатай",
			rules_registered: "Дүрмүүд бүртгэгдсэн",
			devices_registered: "Бүртгэгдсэн төхөөрөмжүүд",
			rules_required_register: "Бүртгүүлэх шаардлагатай дүрмүүд",
			actions_registered: "Үйлдлүүд бүртгэгдсэн",
			devices_required_register: "Бүртгүүлэх шаардлагатай төхөөрөмжүүд",
			actions_required_register: "Бүртгүүлэх шаардлагатай үйлдлүүд",
			terms: "Нөхцөл",
			comply_with_any_rule: "Аливаа дүрмийг дагаж мөрдөх",
			follow_all_rules: "Бүх дүрмийг хэрэгжүүл",
			description_follow_all_rules:
				"Энэ сонголт идэвхжсэн үед мэдэгдэхийн тулд бүх дүрмийг хангасан байх ёстой",
			description_comply_any_rules:
				"Энэ идэвхтэй сонголт нь мэдэгдэхийн тулд аль нэг дүрмийг биелүүлэх боломжийг олгодог",
			time_automatic_closing: "автомат хаах цаг",
			plate_outside_allowed:
				"Зөвшөөрөгдсөн хязгаараас гадуур хавтан, 0.20-аас хэтрэхгүй байхыг зөвлөж байна",
			select_all: "Бүгдийг сонгох",
			trained_faces: "Бэлтгэгдсэн нүүр царай",
			hour: "Цаг",
			evidence_link: "Нотлох баримтын холбоос",
			unable_to_send_event_id_not_found:
				"Тайлан илгээх боломжгүй, үйл явдлын ID олдсонгүй",
			export_all: "Бүгдийг экспортлох",
			consultation_date: "Зөвлөлдөх огноо",
			date_range: "Огнооны хүрээ",
			preparing: "Бэлтгэж байна",
			preparing_to_export: "Экспортод бэлтгэж байна",
			consulting_information: "Зөвлөх мэдээлэл",
			adding_to_excel: "Excel-д нэмж байна",
			downloading_report: "Тайланг татаж байна",
			finalized: "Дуусгасан",
			edit_zone: "Бүсийг засах",
			edited_area: "Засварласан хэсэг",
			auto_zone: "Автомат бүс",
			method: "Method Request",
			find_location: "Байршлыг олох",
			getting_location: "Байршил авч байна",
			geolocation_not_supported: "Газарзүйн байршлыг энэ хөтөч дэмждэггүй.",
			enable_browser_permissions: "Хөтөчийн зөвшөөрлийг идэвхжүүлнэ үү",
			closing_session: "Хаалтын хуралдаан",
			closed_session: "Хаалттай сесс",
			device_status: "Төхөөрөмжийн төлөв",
			device_disconnected: "Төхөөрөмж салгагдсан",
			technical_status: "Техникийн байдал",
			initializing: "Эхэлж байна",
			activate_minimize_alert: "Сэрэмжлүүлэгийг багасгахын тулд идэвхжүүлнэ үү",
			disable_maximize_alert:
				"Сэрэмжлүүлэгийг нэмэгдүүлэхийн тулд идэвхгүй болгох",
			minimized: "Багасгасан",
			maximized: "Хамгийн их болгосон",
			option_to_export:
				"Энэ сонголт нь lpr, дохиолол, ухаалаг үйл явдал, нүүр царай, объект гэсэн аналитикийг Excel рүү экспортлох боломжтой.",
			warning_more_time:
				"Анхааруулга: Энэ нь илүү их цаг хугацаа шаардах болно",
			no_pending_notifications: "Хүлээгдэж буй мэдэгдэл алга",
			helmet: "Дуулга",
			no_helmet: "Дуулгагүй",
			box: "Хайрцаг",
			icon: "Дүрс",
			registered_tags: "Бүртгэгдсэн шошго",
			press_enter_add_analytic: "Аналитик нэмэхийн тулд enter товчийг дарна уу",
			click_here_add_analytics: "Аналитик нэмэх бол энд дарна уу",
			tag_created: "Шошго үүсгэсэн",
			tag_updated: "Шошго шинэчлэгдсэн",
			tag_deleted: "Шошгийг устгасан",
			creating_tag: "Tag үүсгэх",
			updating_tag: "Шошгыг шинэчилж байна",
			deleting_tag: "Tag устгаж байна",
			analytics_created: "Аналитик үүсгэсэн",
			analytics_updated: "Аналитик шинэчлэгдсэн",
			analytics_deleted: "Аналитикийг устгасан",
			creating_analytics: "Аналитик үүсгэх",
			updating_analytics: "Аналитикийг шинэчилж байна",
			deleting_analytics: "Аналитикийг устгаж байна",
			load_default_tag_analytics:
				"Өгөгдмөл хаягууд болон аналитикуудыг ачаалах",
			actionsRing: "Үйлдэл",
			count: "Тоол",
			volumen: "Эзлэхүүн",
			multiple: "Олон",
			once: "Нэг удаа",
			system: "Систем",
			peripheral: "Захын",
			typeAction: "Үйлдлийг бичнэ үү",
			change_smart_event_status: "Ухаалаг үйл явдлын статусыг өөрчлөх",
			optimize_tracker: "Optimize tracker",
			already_exist_plate: "Уг хавтан жагсаалтад аль хэдийн байна",
			start_time: "Эхлэх цаг",
			end_time: "Эцсийн цаг",
			end: "Эцэс",
			group: "Бүлэг",
			density: "Нягтшил",
			peak_time: "Онцлох цаг",
			object_types: "Объектын төрлүүд",
			Iframe: "Iframe",
			register_events: "Үйл явдлыг бүртгэх",
			technical: "Техникийн",
			peripherals: "Захын төхөөрөмжүүд",
			audios: "Аудио",
			already_exist_component_dashboard:
				"Энэ бүрэлдэхүүн хэсэг нь хяналтын самбарт аль хэдийн байна",
			when_no_option_selected_dashboard:
				"Сонголтыг сонгоогүй тохиолдолд хамгийн сүүлийн хяналтын самбарыг анхдагчаар ачаална.",
			profile_already_up_to_dashboard:
				"Энэ профайлыг аль хэдийн Платформд байршуулсан байна",
			powered_by: "Powered by",
			version: "Хувилбар",
			rois_number: "Ройсын дугаар",
			copy_behavior_to: "зан төлөвийг хуулах",
			see_more: "Дэлгэрэнгүйг үзэх",
			historical_asset: "Түүхэн хөрөнгө",
			error_validating_images: "Зургийг баталгаажуулахад алдаа гарлаа",
			face_photo_valid: "The photo is valid for facial recognition",
			face_photo_invalid: "The photo is not valid for facial recognition",
			face_validation_pending: "Facial-recognition validation is pending",
			face_analytics_inactive: "FACE analytics is not active",
			face_validation_cleanup_pending:
				"The photo is valid; background processing is still pending",
			trained_face_capture_camera: "Camera",
			trained_face_capture_registered: "Registered camera",
			trained_face_capture_facing_user: "Front",
			trained_face_capture_facing_environment: "Back",
			trained_face_capture_start_preview: "Start preview",
			trained_face_capture_action: "Capture",
			trained_face_capture_no_preview:
				"No browser preview is available for this registered camera. Upload remains available as a fallback.",
			trained_face_capture_unsupported:
				"Browser camera access is not supported by this browser",
			trained_face_capture_requires_secure_context:
				"Camera access requires HTTPS or localhost. Open this page over HTTPS, use localhost during development, or upload an image instead.",
			trained_face_capture_not_ready: "Camera preview is not ready",
			trained_face_capture_stop_preview: "Stop preview",
			trained_face_capture_stream_unavailable:
				"Registered camera stream could not start. Upload remains available as a fallback.",
			trained_face_capture_stream_timeout:
				"Registered camera stream timed out. Start preview again or upload an image instead.",
			trained_face_capture_snapshot_failed:
				"Registered camera snapshot failed. Try again or upload an image instead.",
			trained_face_capture_auth_preview_fallback:
				"Authenticated live preview is not available in this browser yet. Capture still uses the secure backend snapshot.",
			trained_face_capture_load_cameras_failed:
				"Could not load registered cameras. Upload remains available as a fallback.",
			trained_face_capture_error_503:
				"Camera stream is not available right now. Verify the camera is online or try another camera.",
			trained_face_capture_error_502:
				"Snapshot or stream could not be captured. Try again or check the camera connection.",
			trained_face_capture_error_403:
				"Your session is not authorized to use this camera. Refresh the page or log in again.",
			trained_face_capture_error_404:
				"Camera stream session was not found. Restart preview and try again.",
			trained_face_capture_error_network:
				"Backend or camera service is not reachable. Check the connection and try again.",
			trained_face_validation_error_503:
				"Face validation service is not available right now. Verify the camera or validation service connection and try again.",
			trained_face_validation_error_502:
				"Face validation service could not process the image. Try again with another photo.",
			trained_face_validation_error_403:
				"Your session expired or is not authorized. Refresh the page or log in again.",
			trained_face_validation_error_network:
				"Backend or validation service is not reachable. Check the connection and try again.",
			trained_face_validation_error_generic:
				"Could not validate the image. Try again with another photo.",
			trained_face_save_error_generic:
				"Could not save the trained face. Try again.",
			trained_face_list_assignment_title: "Assign to face lists",
			trained_face_list_required:
				"Choose at least one face list before saving.",
			trained_face_list_empty:
				"No face lists yet. Create one here to continue.",
			trained_face_list_create_label: "New list name",
			trained_face_list_create_action: "Create list",
			trained_face_list_assignment_pending:
				"Face saved, but list assignment is still pending. Retry list assignment before considering it complete.",
			trained_face_list_assignment_retry: "Retry assignment",
			invalid_images: "Буруу зураг",
			validated_images: "Баталгаажсан зургууд",
			"Cant find face in input": "Оролтонд царайг олж чадсангүй",
			search_by_video_face: "Видеогоор хайх",
			upload_video: "Видео байршуулах",
			upload_images: "Зураг байршуулах",
			results: "Үр дүн",
			analyze_video: "Видеог шинжлэх",
			video_database: "Видео мэдээллийн сан",
			video: "Видео",
			range: "Хүрээ",
			captured_image: "Зураг авсан",
			error_reading_video: "Видео уншихад алдаа гарлаа",
			select: "Сонго",
			deselect: "Сонголтыг цуцлах",
			table: "Жагсаалт",
			grid: "Зурагаар",
			time: "Цаг хугацаа",
			similarity: "Магадлал",
			see: "Харна уу",
			uploading_video: "Видео байршуулж байна",
			analyzing_video: "Видеог шинжилж байна",
			analysis_completed: "Шинжилгээ дууссан",
			successfully: "Амжилттай",
			unsuccessfully: "Амжилтгүй",
			activeOn: "Идэвхтэй байна",
			you_are_already_using_profile:
				"Та энэ профайлыг аль хэдийн ашиглаж байна",
			no_similarity_found: "Ижил төстэй байдал олдсонгүй",
			error_uploading_video_face:
				"Видеог ачаалахад алдаа гарлаа. Дахин оролдоно уу",
			selection_successfully: "Сонголт амжилттай хийгдсэн",
			face_needs_selected:
				"Та царайг сонгох эсвэл импортлох хэрэгтэй. Шалгаж, дараа нь хайлт хийнэ үү",
			now_you_can_perform_search: "Одоо та хайлт хийж болно",
			highest_similarity: "Хамгийн их ижил төстэй байдал",
			have_been_registered: "Бүртгүүлсэн:",
			have_not_been_registered: "Бүртгүүлээгүй байна:",
			face_already_registered_in_list:
				"Царай нь жагсаалтад аль хэдийн бүртгэгдсэн байна.",
			face_selection_required: "Нүүрний сонголт шаардлагатай",
			cuts: "Таслах",
			face_selected: "Нүүрийг сонгосон",
			video_clipping: "Видео хайчлах",
			no_data_found_face_search: "Царай хайхад өгөгдөл олдсонгүй",
			cropImage: "Зургийг тайрах",
			enableCropImage: "Зургийг тайрахыг идэвхжүүлнэ үү",
			disableCropImage: "Зураг тайрахыг идэвхгүй болгох",
			play: "Тоглох",
			pause: "Түр зогсоох",
			draw_box_over_area_captured: "Баривчлах талбай дээр хайрцаг зур",
			waiting_for_data: "Өгөгдөл хүлээж байна",
			error_loading: "Ачаалахад алдаа гарлаа",
			attributes: "Атрибутууд",
			car_type: "Авто машин",
			brand: "Брэнд",
			color: "Цэнхэр",
			direction: "Чиглэл",
			speed: "Хурд",
			speed_limit: "Хурд хязгаарлалт",
			no_dashboard_items: "Хяналтын самбарт харуулах зүйл алга",
			back_to_dashboard: "Хяналтын самбар руу буцах",
			set_default: "Өгөгдмөл болгох",
			Barcode: "Баркод",
			Device: "Төхөөрөмж",
			Inicio: "Эхлэх",
			"Foto inicio": "Эхлэх зураг",
			Fin: "Дуусах",
			"Foto fin": "Дуусах зураг",
			State: "Төлөв",
			in_progress: "Явагдаж байна",
			finished: "Дууссан",
			unknown: "Тодорхойгүй",
			grouped_events: "Бүлэглэсэн үйл явдал", // MONGOL
			duration: "Үргэлжлэх хугацаа",
			totalizers: "Нийлбэрүүд",

			// Modal de Entidades
			add_entities_to_list: "Жагсаалтад байгууллагын нэгжүүдийг нэмэх",
			select_list: "Жагсаалт сонгох",
			entities_selected: "сонгосон байгууллагын нэгжүүд",
			filter_by_name: "Нэрээр шүүх",
			filter_by_date: "Огноогоор шүүх",
			clear_filters: "Шүүлтүүрийг цэвэрлэх",
			add_to_list: "Жагсаалтад нэмэх",
			cancel: "Цуцлах",
			please_select_list_first: "Эхлээд жагсаалт сонгоно уу",
			no_entities_selected: "Байгууллагын нэгж сонгогдоогүй байна",
			entities_added_to_list: "Байгууллагын нэгжүүд жагсаалтад нэмэгдлээ",
			failed_to_fetch_entities: "Байгууллагын нэгжүүдийг авахад алдаа гарлаа",
			failed_to_add_entities: "Жагсаалтад нэмэхэд алдаа гарлаа",

			// Nuevas claves para listing_details.vue
			loading_please_wait: "Уншиж байна... Хүлээнэ үү",
			instructions: "Заавар",
			select_list_and_choose_entities:
				"Жагсаалт сонгоод дараа нь нэмэхийг хүсч буй байгууллагын нэгжүүдийг сонгоно уу. Тодорхой байгууллагын нэгжүүдийг олохын тулд шүүлтүүрийг ашиглаж болно.",
			entities_selected_for_list:
				"Жагсаалтад нэмэхээр сонгосон байгууллагын нэгжүүд",
			select_entities_from_table:
				"Жагсаалтад нэмэхийн тулд хүснэгтээс байгууллагын нэгжүүдийг сонгоно уу",
			search_filters: "Хайлтын шүүлтүүр",
			use_filters_to_find_entities:
				"Нэр эсвэл огноогоор тодорхой байгууллагын нэгжүүдийг олохын тулд эдгээр шүүлтүүрийг ашиглана уу",
			available_entities: "Боломжтой байгууллагын нэгжүүд",
			select_entities_to_add_to_list:
				"Жагсаалтад нэмэхийг хүсч буй байгууллагын нэгжүүдийг сонгоно уу. Бүгдийг сонгохын тулд дээд талын checkbox-ийг ашиглана уу.",
			deselect_all: "Бүгдийг цуцлах",
			select_all: "Бүгдийг сонгох",
			global_mode_activated: "Глобал горим идэвхжсэн",
			entities_of: "байгууллагын нэгжүүд",
			pages: "хуудас",
			active_filters: "Идэвхтэй шүүлтүүр",
			no_entities_available: "Байгууллагын нэгж байхгүй байна",
			no_entities_match_search_criteria:
				"Хайлтын шалгуурын дагуу байгууллагын нэгж олдсонгүй",
			photo: "Зураг",
			error_get_list: "Жагсаалт авахад алдаа гарлаа",
			failed_get_lists: "Жагсаалтуудыг авахад алдаа гарлаа",
			required_have_list_created:
				"Жагсаалт үүсгэх шаардлагатай: жагсаалт руу очно уу",
			error_get_list_trained: "Сургалтын жагсаалт авахад алдаа гарлаа",
			error_list_setting: "Жагсаалтын тохиргооны алдаа",
			res_logos: "Лого хэлбэрээр хариу",
			error_logos: "Лого алдаа",
			error_deleting: "Устгахад алдаа гарлаа",
			deleting_item: "Элемент устгаж байна",
			item_to_delete_have_id: "Устгах элемент нь id-тэй байх ёстой",
			item_to_delete_null: "Устгах элемент нь null байна",
			opening_modal: "Модал нээж байна...",
			modal_state: "Модалын төлөв:",
			list_changed_to: "Жагсаалт өөрчлөгдсөн:",
			api_response: "API хариу:",
			api_url: "API URL:",
			api_params: "API параметрүүд:",
			filtered_entities: "Шүүсэн байгууллагын нэгжүүд:",
			total: "Нийт:",
			applying_filters: "Шүүлтүүр хэрэглэж байна",
			none: "байхгүй",
			total_entities: "Нийт байгууллагын нэгжүүд",
			total_pages: "Нийт хуудас",
			items_per_page: "Хуудас бүрт байгаа элементүүд",
			page: "Хуудас",
			entities_loaded: "байгууллагын нэгжүүд утсан",
			total_so_far: "Одоогийн байдлаар нийт",
			all_entities_loaded: "Бүх байгууллагын нэгжүүд утсан",
			out_of: "ээс",
			warning: "Анхааруулга",
			expected: "Хүлээгдэж буй",
			entities_but_got: "байгууллагын нэгжүүд гэхдээ авсан",
			error_fetching_all_entities:
				"Бүх байгууллагын нэгжүүдийг авахад алдаа гарлаа",
			error_loading_all_entities:
				"Бүх байгууллагын нэгжүүдийг утсахад алдаа гарлаа",
			with_filters_applied: "шүүлтүүр хэрэглэсэн",
			filters_applied: "Хэрэглэсэн шүүлтүүр",
			viewing_details_for_entity:
				"Байгууллагын нэгжийн дэлгэрэнгүй мэдээллийг харж байна:",
			added_via_modal: "Модалаар нэмэгдсэн",
			filters_changed_global_mode_deactivated:
				"Шүүлтүүр өөрчлөгдсөн. Глобал сонголтын горим идэвхгүй болсон.",
			date_changed_global_mode_deactivated:
				"Огноо өөрчлөгдсөн. Глобал сонголтын горим идэвхгүй болсон.",
			global_selection_mode_deactivated:
				"Глобал сонголтын горим идэвхгүй болсон",
			loading_all_entities_from_all_pages:
				"Бүх хуудаснаас бүх байгууллагын нэгжүүдийг утсаж байна",
			entities_selected_from_pages:
				"{pages} хуудаснаас {count} байгууллагын нэгжүүд сонгогдсон ({perPage} хуудас бүрт)",
			invalid_entities_for_face_list:
				"Нүүрний жагсаалтад буруу байгууллагын нэгжүүд",
			unexpected_response: "API-аас гарах хүлээгдээгүй хариу",

			// Nuevas claves para el sistema de guía paso a paso
			step_1_select_list_first: "Алхам 1: Эхлээд жагсаалт сонгоно уу",
			step_2_enter_motive: "Алхам 2: Үргэлжлүүлэхийн тулд шалтгаан оруулна уу",
			step_3_select_faces: "Алхам 3: Нэмэхийн тулд нүүр сонгоно уу",
			ready_to_select_entities: "Байгууллагын нэгжүүдийг сонгоход бэлэн",
			setup_progress: "Тохиргооны явц",
			select_faces: "Нүүр сонгох",
			complete_steps_1_and_2_first: "Эхлээд 1, 2-р алхмуудыг гүйцэтгэнэ үү",
			table_locked: "Хүснэгт түгжигдсэн",
			complete_setup_steps_to_unlock:
				"Хүснэгтийг нээхийн тулд тохиргооны алхмуудыг гүйцэтгэнэ үү",
			step: "Алхам",
			enter_motive: "Байгууллагын нэгжүүдийг нэмэхийн тулд шалтгаан оруулна уу",
			failed_to_add_entities_detailed: "Жагсаалтад нэмэхэд алдаа гарлаа",
			not_in_list: "Жагсаалтад байхгүй",

			// VideoSearchByVideo component translations
			browser_not_support_video: "Таны хөтөч видео элементийг дэмжихгүй байна.",
			frame_information: "Хүрээний мэдээлэл",
			full_frame: "Бүрэн зураг",
			cropped_face: "Хайчилсан нүүр",
			timestamp: "Цаг",
			bbox: "Bbox",
			frame_index: "Хүрээний индекс",
			bbox_probability: "Bbox магадлал",
			face_id: "Нүүрний ID",
			photo_uuid: "Зургийн UUID",
			video_info: "Видеоны мэдээлэл",
			fps: "FPS",
			resolution: "Нарийвчлал",
			total_frames: "Нийт хүрээ",
			total_faces: "Нийт нүүр",
			face_search_completed_successfully: "Нүүр хайлт амжилттай дууссан",
			no_results_above_similarity_threshold:
				"Тогтоосон ижил төстэй байдлын босгоос дээш үр дүн олдсонгүй. Олдсон хамгийн өндөр ижил төстэй байдал {similarity}% байв. Хамгийн өндөр ижил төстэй байдлыг илрүүлсэн шүүлтүүрийг тохируулахыг хүсэж байна уу?",
			adjust_filter: "Шүүлтүүр тохируулах",
			similarity_filter_adjusted:
				"Ижил төстэй байдлын шүүлтүүр {similarity}% болгон тохируулагдсан",
			no_faces_found_in_search: "Хайлтад нүүр олдсонгүй",

			// LPR Modal translations
			lpr_event_details: "LPR Үйл явдлын дэлгэрэнгүй",
			event_information: "Үйл явдлын мэдээлэл",
			event_id: "Үйл явдлын ID",
			video_event: "Үйл явдлын видео",
			loading_video: "Видео ачаалж байна...",
			video_load_error: "Видеог ачаалах боломжгүй",
			no_video_available: "Энэ үйл явдалд видео байхгүй",
			play_in_main_player: "Үндсэн тоглуулагчаар тоглуулах",
			loading_image: "Зургийг ачаалж байна...",
			connection_onvif: "ONVIF холболт",
			connect: "Холбох",
			for_stream_2: "stream 2-д зориулсан",
			mb_gb: "MB/GB",
			tooltip_rtsp: "RTSP URL оруулна уу: rtsp://user:pass@ip[:port]/path",
			tooltip_rtsp2: "Нэмэлт RTSP (Substream эсвэл Суваг 2)",
			tooltip_hls: "HLS урсгалын URL (байвал)",
			tooltip_name: "Төхөөрөмжийн нэр (хамгийн багадаа 4 тэмдэгт)",
			tooltip_is_record: "Сонгосон сувагт бичлэг идэвхжүүлэх",
			tooltip_limit: "Бичлэгийн хадгалах лимит. MB эсвэл GB ашиглана",
			tooltip_is_motion: "Хөдөлгөөн илрүүлэхийг идэвхжүүлэх",
			tooltip_video_streaming: "Дэлгэцэлж харуулах видеог идэвхжүүлэх",
			tooltip_ip_machine: "Үйлчилгээ ажиллах хостын IP",
			tooltip_image: "Motion үйлчилгээний Docker дүрсийг сонгоно",
			tooltip_uuid:
				"Төхөөрөмжийн бүх нийтийн өвөрмөц таних тэмдэг. Энэ утгыг автоматаар үүсгэдэг бөгөөд өөрчлөх боломжгүй.",
			tooltip_record:
				"Төхөөрөмжийн видеоны бичлэгийг идэвхжүүлэх эсвэл идэвхгүй болгох. Идэвхжүүлсэн үед систем нь тохируулсан хадгалах хязгаарын дагуу бичлэгүүдийг хадгална.",
			tooltip_streaming:
				"Бодит цагийн видеоны дамжуулалтыг идэвхжүүлэх эсвэл идэвхгүй болгох. Идэвхжүүлсэн үед төхөөрөмжийн видео нь системд бодит цагийн харагдах боломжтой болно.",
			tooltip_optimize_tracker:
				"Хөдөлгөөний мөрдөгчийн оновчлолыг идэвхжүүлэх. Идэвхжүүлсэн үед хөдөлгөөний шинжилгээ болон үйл явдлын илрүүлэх гүйцэтгэлийг сайжруулж, системийн нөөцийн ашиглалтыг оновчтой болгоно.",
			tooltip_type_peripheral:
				"Туслах төхөөрөмжийн төрлийг сонгоно уу: Сирена (дохио), Цахим цоож (хаалганы цоож), Arduino (микроконтроллер), IoT Relay (ухаалаг реле) эсвэл Odroid (нэг самбарт компьютер). Төрөл бүр тодорхой тохиргоотой.",
			tooltip_arduino:
				"Энэ туслах төхөөрөмжид холбогдсон Arduino төхөөрөмжийг сонгоно уу. Arduino нь системд урьдчилан тохируулсан байх ёстой. Боломжтой Arduino-уудын жагсаалтаас сонгоно уу.",
			tooltip_mode:
				'Туслах төхөөрөмжийн ажиллагааны горимыг сонгоно уу: "in" (оролт) - системд дохио илгээдэг төхөөрөмжүүд, эсвэл "out" (гаралт) - системээс команд хүлээн авдаг төхөөрөмжүүд.',
			tooltip_medium:
				"Туслах төхөөрөмжийн холбоо барих хэрэгсэлийг сонгоно уу: USB (шууд USB холболт), TCP (сүлжээний TCP/IP холболт), GPIO (ерөнхий зориулалтын оролт/гаралтын пин) эсвэл HTTP (вэб суурилсан холболт).",
			tooltip_pin:
				"Холбоо барихад ашигладаг GPIO пин дугаар. Төхөөрөмжийн физик пин дугаарыг оруулна уу (жишээ нь: 2, 3, 4 гэх мэт). Зөвхөн хэрэгсэл нь GPIO байх үед шаардлагатай.",
			tooltip_ip:
				"Туслах төхөөрөмжийн IP хаяг. IPv4 форматаар IP хаягийг оруулна уу (жишээ нь: 192.168.1.100). Зөвхөн хэрэгсэл нь TCP эсвэл HTTP байх үед шаардлагатай.",
			tooltip_type:
				"Төхөөрөмжийн төрөл: IP_CAM (видеоны дамжуулалттай IP камер) эсвэл PERIPHERAL (мэдрэгч, хөдөлгүүр гэх мэт туслах төхөөрөмж). Энэ утгыг төхөөрөмж үүсгэсний дараа өөрчлөх боломжгүй.",
			tooltip_serial:
				"Туслах төхөөрөмжийн цувралын дугаар. Төхөөрөмжийн өвөрмөц цувралын дугаарыг таних болон хянах зорилгоор оруулна уу.",
			tooltip_onvif_user: "ONVIF device username",
			tooltip_onvif_password: "ONVIF device password",
			image_load_error: "Зургийг ачаалах боломжгүй",

			// Alert & Smart Event Modal translations
			alert_details: "Анхааруулгын дэлгэрэнгүй",
			smart_event_details: "Ухаалаг үйл явдлын дэлгэрэнгүй",
			event_type: "Үйл явдлын төрөл",
			event_details: "Үйл явдлын дэлгэрэнгүй",
			severity: "Хүндрэл",
			message: "Мессеж",
			rule_id: "Дүрмийн ID",
			tag: "Шошго",
			description: "Тайлбар",
			additional_information: "Нэмэлт мэдээлэл",
			unix_timestamp: "Unix Timestamp",
			style: "Хэв маяг",
			subgroup: "Дэд бүлэг",
			file: "Файл",
			duration: "Хугацаа",

			// EventsChart translations
			temporal_distribution_events: "Үйл явдлын цаг хугацааны тархалт",
			period: "Хугацаа",
			by_hour: "Цагаар",
			by_minute: "Минутаар",
			hour: "Цаг",
			minute: "Минут",
			time: "Цаг",
			no_data_events: "Харуулах үйл явдлын өгөгдөл байхгүй",
			number_events: "Үйл явдлын тоо",
			events_label: "үйл явдал",
			object_detected: "Илрүүлсэн Объект",
			events_count: "Үйл явдлын тоо",

			// Alarm Stats translations
			alarm_stats: "Дохиоллын Статистик",
			alarm_stats_total_counted: "Өнөөдрийн Нийт Тоолол",
			alarm_stats_good_units: "Сайн Нэгжүүд",
			alarm_stats_defects: "Илрүүлсэн Гэмтэл",
			alarm_stats_stoppages: "Өнөөдрийн Зогсолт",
			alarm_stats_quality_rate: "Чанарын Хувь",
			alarm_stats_defect_rate: "Гэмтлийн Хувь",
			alarm_stats_total_idle: "Нийт Зогсолтын Хугацаа",
			alarm_stats_this_minute: "энэ минутад",
			alarm_stats_units: "нэгж",
			alarm_stats_events: "үйл явдал",
			alarm_stats_current_rate: "Одоогийн Хурд",
			alarm_stats_units_min: "н/мин",
			alarm_stats_per_hour: "ЦАГТ",
			alarm_stats_peak_today: "ӨНӨӨДРИЙН ОРГИЛ",
			alarm_stats_avg_hour: "ДУНДЖААР/ЦАГ",
			alarm_stats_projection: "Ээлжийн Таамаглал",
			alarm_stats_projected_units: "Таамагласан Нэгжүүд",
			alarm_stats_projection_desc: "Одоогийн хурдаар",
			alarm_stats_shift_progress: "Ээлжийн Явц",
			alarm_stats_shift_duration: "ЭЭЛЖИЙН ХУГАЦАА",
			alarm_stats_time_remaining: "ҮЛДСЭН ХУГАЦАА",
			alarm_stats_oee: "ОЕЕ",
			alarm_stats_availability: "Ашиглалт",
			alarm_stats_performance: "Гүйцэтгэл",
			alarm_stats_quality: "Чанар",
			alarm_stats_oee_target: "ОЕЕ Зорилт",
			alarm_stats_below_target: "Зорилтоос доогуур",
			alarm_stats_above_target: "Зорилтоос дээгуур",
			alarm_stats_throughput: "Дамжуулалт",
			alarm_stats_rate: "Хурд",
			alarm_stats_defects_label: "Гэмтэл",
			alarm_stats_stoppages_label: "Зогсолт",
			alarm_stats_stoppage_log: "Зогсолтын Бүртгэл",
			alarm_stats_time: "Цаг",
			alarm_stats_start_time: "Start", // TODO: translate
			alarm_stats_end_time: "End", // TODO: translate
			alarm_stats_duration: "Хугацаа",
			alarm_stats_camera_trigger: "Камерын Дохио",
			alarm_stats_rate_before: "Өмнөх Хурд",
			alarm_stats_rate_after: "Дараах Хурд",
			alarm_stats_status: "Төлөв",
			alarm_stats_notes: "Тэмдэглэл",
			alarm_stats_resolved: "Шийдвэрлэсэн",
			alarm_stats_active: "Идэвхтэй",
			alarm_stats_active_dash: "Идэвхтэй",
			alarm_stats_no_stats: "Статистик байхгүй",
			alarm_stats_not_found: "Дохиолол олдсонгүй",
			alarm_stats_load_error: "Ачааллах алдаа",
			alarm_stats_retry: "Дахин оролдох",
			alarm_stats_shift_config: "Ээлжийн Тохиргоо",
			alarm_stats_shift_start: "Ээлжийн Эхлэл",
			alarm_stats_shift_dur_min: "Хугацаа (мин)",
			alarm_stats_target_rate: "Зорилтын Хурд (н/мин)",
			alarm_stats_stop_threshold: "Зогсолтын Босго (мс)",
			alarm_stats_cancel: "Цуцлах",
			alarm_stats_note_placeholder: "Тэмдэглэл нэмэх...",
			alarm_stats_listing: "Жагсаалт",
			alarm_stats_loading: "Loading statistics…",
			alarm_stats_title_fallback: "Alarm Statistics",
			alarm_stats_realtime_connected: "Real-time: connected",
			alarm_stats_realtime_disconnected: "Real-time: disconnected",
			alarm_stats_shift_button: "Shift",
			alarm_stats_ws_lost: "Real-time connection lost",
			alarm_stats_ws_reconnected: "Reconnected to server",
			alarm_stats_note_save_error: "Could not save note",
			alarm_stats_config_save_error: "Could not save configuration to server",
			alarm_stats_config_saved: "Shift configuration saved",
			alarm_stats_shift_start_hint: "Format HH:MM (24h)",
			alarm_stats_shift_duration_hint: "Duration in minutes (e.g. 480 = 8 h)",
			alarm_stats_target_rate_hint: "Expected units per minute (0 = no target)",
			alarm_stats_stop_threshold_hint:
				"Minimum idle time before registering a stoppage",
			alarm_stats_shift_start_invalid: "Enter a valid time (HH:MM)",
			alarm_stats_shift_duration_invalid:
				"Duration must be greater than 0 minutes",
			alarm_stats_target_rate_invalid: "Target rate must be 0 or greater",
			alarm_stats_threshold_invalid: "Minimum threshold is 1000 ms (1 second)",
			alarm_stats_reset_zoom: "Reset",
			alarm_stats_from: "From",
			alarm_stats_to: "To",
			alarm_stats_apply: "Apply",
			alarm_stats_preset_today: "Today",
			alarm_stats_preset_custom: "Custom",
			alarm_stats_all: "All",
			alarm_stats_chart_units_axis: "Units",
			alarm_stats_upm: "upm",

			// Dashboard Pie Events shell translations
			dashboard_pie_events_total_type_pie: "Dashboard chart builder",
			dashboard_pie_events_preset_total_alertas: "Total Alerts",
			dashboard_pie_events_preset_total_alertas_atendidas:
				"Total Attended Alerts",
			dashboard_pie_events_preset_porcentaje_operacion_efectiva:
				"Effective operation percentage",
			dashboard_pie_events_preset_alertas_pendientes_por_atender:
				"Unresolved Alerts",
			dashboard_pie_events_preset_alertas_clasificadas_positivas_falso_positivas:
				"Classified positive/false positive alerts",
			dashboard_pie_events_preset_alertas_por_dispositivo: "Alerts by device",
			dashboard_pie_events_preset_tiempo_accion_operador:
				"Operator action time",
			dashboard_pie_events_preset_interval_title: "Select chart interval",
			dashboard_alerts_by_device_tab_map: "Map",
			dashboard_alerts_by_device_tab_list: "List",
			dashboard_alerts_by_device_ranking: "Points with most alerts",
			dashboard_alerts_by_device_device: "Device",
			dashboard_alerts_by_device_count: "Alerts",
			dashboard_alerts_by_device_loading: "Loading device alerts...",
			dashboard_alerts_by_device_empty: "No device alert data is available.",
			dashboard_alerts_by_device_no_coordinates:
				"No devices with coordinates to plot.",
			dashboard_operator_action_time_subtitle:
				"Time from alarm to operator action",
			dashboard_operator_action_time_average: "Average",
			dashboard_operator_action_time_p95: "P95",
			dashboard_operator_action_time_best: "Best today",
			dashboard_operator_action_time_within_objective: "Within objective",
			dashboard_operator_action_time_objective: "Objective",
			dashboard_operator_action_time_distribution: "Distribution",
			dashboard_operator_action_time_daily_average:
				"Daily average response time",
			dashboard_operator_action_time_daily_empty:
				"No daily response time data is available.",
			dashboard_operator_action_time_total: "Actioned alerts",
			dashboard_operator_action_time_source: "Action source",
			dashboard_operator_action_time_interval: "Interval",
			dashboard_operator_action_time_interval_24h: "24h",
			dashboard_operator_action_time_interval_7d: "7d",
			dashboard_operator_action_time_interval_30d: "30d",
			dashboard_operator_action_time_loading: "Loading operator action time...",
			dashboard_operator_action_time_empty:
				"No operator action time data is available.",
			dashboard_operator_action_time_error:
				"Could not load operator action time. Try again later.",
			dashboard_operator_action_time_skipped_note:
				"Alerts skipped without creation timestamp",
			dashboard_operator_action_time_pending_note:
				"Open alerts measured until query time",
			dashboard_pie_events_title: "Add Dashboard Chart",
			dashboard_pie_events_shell_help:
				"Name the chart, choose the visualization type, preview the result, then add it to the dashboard.",
			dashboard_pie_events_metadata_error:
				"Графикийн metadata ачаалж чадсангүй. Backend бэлэн үед тохиргооны урсгал үргэлжилнэ.",
			dashboard_pie_events_section_datasource: "Өгөгдлийн эх сурвалж",
			dashboard_pie_events_section_interval: "Интервал",
			dashboard_pie_events_section_devices: "Төхөөрөмжүүд",
			dashboard_pie_events_section_refresh: "Шинэчлэл",
			dashboard_pie_events_section_preview: "Урьдчилсан харах",
			dashboard_pie_events_placeholder_interval:
				"Preset болон custom range сонголтууд энд идэвхжинэ.",
			dashboard_pie_events_placeholder_devices:
				"Төхөөрөмж сонголт энд идэвхжинэ.",
			dashboard_pie_events_placeholder_preview:
				"Widget нэмэхээс өмнөх урьдчилсан харах энд идэвхжинэ.",
			dashboard_pie_events_refresh_default: "Үндсэн шинэчлэл: 60 секунд.",
			dashboard_pie_events_add_disabled: "Урьдчилсан харахын дараа нэмэх",
			dashboard_pie_events_loading_metadata: "Metadata ачаалж байна...",
			dashboard_pie_events_metadata_loaded:
				"Metadata ачаалагдлаа. Дараагийн хэсэгт selector-ууд backend хязгаарлалтыг ашиглана.",
			dashboard_pie_events_metadata_pending: "Графикийн metadata хүлээж байна.",
			dashboard_pie_events_section_grouping: "Бүлэглэлт",
			dashboard_pie_events_section_filters: "Шүүлтүүрүүд",
			dashboard_pie_events_section_chart: "Chart",
			dashboard_pie_events_section_appearance: "Appearance",
			dashboard_pie_events_chart_name: "Name",
			dashboard_pie_events_chart_type: "Chart type",
			dashboard_pie_events_chart_type_pie: "Pie chart",
			dashboard_pie_events_chart_type_doughnut: "Donut chart",
			dashboard_pie_events_chart_type_kpi: "KPI card",
			dashboard_pie_events_chart_type_line: "Line chart",
			dashboard_pie_events_kpi_color: "KPI color",
			dashboard_pie_events_kpi_icon: "KPI icon",
			dashboard_pie_events_datasource: "Өгөгдлийн эх сурвалж",
			dashboard_pie_events_table: "Хүснэгт",
			dashboard_pie_events_interval_preset: "Интервалын preset",
			dashboard_pie_events_from: "Эхлэх",
			dashboard_pie_events_to: "Дуусах",
			dashboard_pie_events_devices: "Төхөөрөмжүүд",
			dashboard_pie_events_group_by: "Бүлэглэх талбар",
			dashboard_pie_events_no_grouping:
				"Энэ өгөгдлийн эх сурвалжид бүлэглэх талбар алга.",
			dashboard_pie_events_add_filter: "Шүүлтүүр нэмэх",
			dashboard_pie_events_no_filters:
				"Энэ өгөгдлийн эх сурвалжид шүүх талбар алга.",
			dashboard_pie_events_filter_field: "Талбар",
			dashboard_pie_events_filter_operator: "Оператор",
			dashboard_pie_events_filter_value: "Утга",
			dashboard_pie_events_refresh_seconds: "Шинэчлэх секунд",
			dashboard_pie_events_refresh_range: "Зөвшөөрөгдсөн шинэчлэлийн хүрээ:",
			dashboard_pie_events_preview: "Урьдчилан харах",
			dashboard_pie_events_preview_loading:
				"Урьдчилсан харагдац ачаалж байна...",
			dashboard_pie_events_preview_empty:
				"Нэмэхээс өмнө тохиргоог шалгахын тулд урьдчилан харна уу.",
			dashboard_pie_events_preview_error:
				"Урьдчилсан харагдац үүсгэж чадсангүй. Тохиргоог шалгаад дахин оролдоно уу.",
			dashboard_pie_events_total: "Нийт",
			dashboard_pie_events_requested: "Requested",
			dashboard_pie_events_interval_total: "Events in interval",
			dashboard_pie_events_grouped_total: "Grouped events",
			dashboard_pie_events_slice: "Хэсэг",
			dashboard_pie_events_value: "Утга",
			dashboard_pie_events_percent: "Хувь",
			dashboard_pie_events_add: "График нэмэх",
			dashboard_pie_events_preset_today: "Today",
			dashboard_pie_events_preset_yesterday: "Yesterday",
			dashboard_pie_events_preset_week: "Week",
			dashboard_pie_events_preset_15d: "Last 15 days",
			dashboard_pie_events_preset_30d: "Last 30 days",
			dashboard_pie_events_preset_last_24h: "Сүүлийн 24 цаг",
			dashboard_pie_events_preset_last_7d: "Сүүлийн 7 өдөр",
			dashboard_pie_events_preset_last_30d: "Сүүлийн 30 өдөр",
			dashboard_pie_events_preset_custom: "Custom",
			"dashboard.pie.events.values.alarms.classification.positive": "Positive",
			"dashboard.pie.events.values.alarms.classification.false_positive":
				"False positive",
			"dashboard.pie.events.values.alarms.classification.unclassified":
				"Pending classification",
			dashboard_pie_events_validation_chart_type: "Select a chart type.",
			dashboard_pie_events_validation_datasource:
				"Өгөгдлийн эх сурвалж сонгоно уу.",
			dashboard_pie_events_validation_table: "Хүснэгт сонгоно уу.",
			dashboard_pie_events_validation_devices: "Ядаж нэг төхөөрөмж сонгоно уу.",
			dashboard_pie_events_validation_custom_required:
				"Custom хүрээний эхлэх болон дуусах огноог сонгоно уу.",
			dashboard_pie_events_validation_custom_order:
				"Custom хүрээний эхлэх огноо дуусах огнооноос өмнө байх ёстой.",
			dashboard_pie_events_validation_custom_limit:
				"Custom хүрээ зөвшөөрөгдсөн цонхоос хэтэрсэн.",
			dashboard_pie_events_validation_refresh:
				"Шинэчлэх секунд зөвшөөрөгдсөн хүрээнээс гадуур байна.",
			dashboard_pie_events_validation_grouping:
				"Сонгосон бүлэглэлт metadata-аар зөвшөөрөгдөөгүй.",
			dashboard_pie_events_validation_filters:
				"Шүүлтүүрүүдийг зөвшөөрөгдсөн талбар болон оператороор бөглөнө үү.",
			dashboard_pie_events_loading_data: "Графикийн өгөгдөл ачаалж байна...",
			dashboard_pie_events_empty_data:
				"Энэ тохиргоонд үйл явдлын өгөгдөл алга.",
			dashboard_pie_events_data_error:
				"Графикийн өгөгдөл ачаалж чадсангүй. Дараа дахин оролдоно уу.",
			dashboard_pie_events_unsupported_config:
				"This chart configuration is not supported by this version.",
			dashboard_pie_events_retry: "Дахин оролдох",
			dashboard_pie_events_generated_at: "Үүсгэсэн",
			dashboard_pie_events_fields_event_type: "Event type",
			dashboard_pie_events_fields_name: "Name",
			dashboard_pie_events_fields_device: "Device",
			dashboard_pie_events_fields_deviceId: "Device",
			dashboard_pie_events_fields_timestamp: "Date and time",
			dashboard_pie_events_fields_unix_itme_stamp: "Date and time",
			dashboard_pie_events_fields_createdAt: "Created at",
			dashboard_pie_events_fields_updatedAt: "Updated at",
			dashboard_pie_events_fields_date: "Date",
			dashboard_pie_events_fields_data: "Data",
			dashboard_pie_events_fields_time: "Time",
			dashboard_pie_events_fields_manager: "Manager",
			dashboard_pie_events_fields_color: "Color",
			dashboard_pie_events_fields_attributes: "Attributes",
			dashboard_pie_events_fields_alarmId: "Alarm ID",
			dashboard_pie_events_fields_alertUUID: "Alert UUID",
			dashboard_pie_events_fields_analytic: "Analytic",
			dashboard_pie_events_fields_antenna_num: "Antenna number",
			dashboard_pie_events_fields_axle_count: "Axle count",
			dashboard_pie_events_fields_barcode: "Barcode",
			dashboard_pie_events_fields_bbox: "Bounding box",
			dashboard_pie_events_fields_caseId: "Case ID",
			dashboard_pie_events_fields_contact: "Contact",
			dashboard_pie_events_fields_coord: "Coordinates",
			dashboard_pie_events_fields_description: "Description",
			dashboard_pie_events_fields_detail: "Detail",
			dashboard_pie_events_fields_duration: "Duration",
			dashboard_pie_events_fields_duration_seconds: "Duration seconds",
			dashboard_pie_events_fields_duration_time: "Duration time",
			dashboard_pie_events_fields_end_time: "End time",
			dashboard_pie_events_fields_entry_event: "Entry event",
			dashboard_pie_events_fields_entry_trigger_event: "Entry trigger event",
			dashboard_pie_events_fields_entry_type: "Entry type",
			dashboard_pie_events_fields_epc_num: "EPC number",
			dashboard_pie_events_fields_eventId: "Event ID",
			dashboard_pie_events_fields_eventUUID: "Event UUID",
			dashboard_pie_events_fields_event_to_pay: "Event to pay",
			dashboard_pie_events_fields_exit_event: "Exit event",
			dashboard_pie_events_fields_exit_trigger_event: "Exit trigger event",
			dashboard_pie_events_fields_frame: "Frame",
			dashboard_pie_events_fields_frame_id: "Frame ID",
			dashboard_pie_events_fields_full_photo: "Full photo",
			dashboard_pie_events_fields_gif_evidence: "GIF evidence",
			dashboard_pie_events_fields_gifevidence: "GIF evidence",
			dashboard_pie_events_fields_h: "Height",
			dashboard_pie_events_fields_history: "History",
			dashboard_pie_events_fields_id: "ID",
			dashboard_pie_events_fields_init_time: "Start time",
			dashboard_pie_events_fields_is_confirmed: "Confirmed",
			dashboard_pie_events_fields_is_fp: "False positive",
			dashboard_pie_events_fields_is_ignored: "Ignored",
			dashboard_pie_events_fields_latitude: "Latitude",
			dashboard_pie_events_fields_longitude: "Longitude",
			dashboard_pie_events_fields_name_categorie: "Category name",
			dashboard_pie_events_fields_ocr_found: "OCR found",
			dashboard_pie_events_fields_operator: "Operator",
			dashboard_pie_events_fields_owner: "Owner",
			dashboard_pie_events_fields_path_evidence: "Evidence path",
			dashboard_pie_events_fields_plate_Description: "Plate description",
			dashboard_pie_events_fields_plate_found: "Plate found",
			dashboard_pie_events_fields_prob: "Probability",
			dashboard_pie_events_fields_probability: "Probability",
			dashboard_pie_events_fields_profileId: "Profile ID",
			dashboard_pie_events_fields_rfid_id: "RFID ID",
			dashboard_pie_events_fields_rssi_level: "RSSI level",
			dashboard_pie_events_fields_ruleId: "Rule ID",
			dashboard_pie_events_fields_segment_photo: "Segment photo",
			dashboard_pie_events_fields_side: "Side",
			dashboard_pie_events_fields_size: "Size",
			dashboard_pie_events_fields_speed: "Speed",
			dashboard_pie_events_fields_speed_limit: "Speed limit",
			dashboard_pie_events_fields_tid_num: "TID number",
			dashboard_pie_events_fields_top_image: "Top image",
			dashboard_pie_events_fields_total: "Total",
			dashboard_pie_events_fields_tracker_id: "Tracker ID",
			dashboard_pie_events_fields_url_evidence: "Evidence URL",
			dashboard_pie_events_fields_url_photo_event: "Event photo URL",
			dashboard_pie_events_fields_userId: "User ID",
			dashboard_pie_events_fields_vehicle_image_path: "Vehicle image path",
			dashboard_pie_events_fields_vehicle_image_url: "Vehicle image URL",
			dashboard_pie_events_fields_video: "Video",
			dashboard_pie_events_fields_vinfo: "Video info",
			dashboard_pie_events_fields_void_reason: "Void reason",
			dashboard_pie_events_fields_w: "Width",
			dashboard_pie_events_fields_way: "Way",
			dashboard_pie_events_fields_x: "X",
			dashboard_pie_events_fields_y: "Y",
			dashboard_pie_events_fields_uuid: "UUID",
			dashboard_pie_events_fields_motive_categorie: "Motive category",
			dashboard_pie_events_fields_tag: "Tag",
			dashboard_pie_events_fields_isalert: "Alert",
			dashboard_pie_events_fields_is_alarm: "Alarm",
			dashboard_pie_events_fields_plate_chars: "Plate",
			dashboard_pie_events_fields_type_vehicle: "Vehicle type",
			dashboard_pie_events_fields_vehicle_type: "Vehicle type",
			dashboard_pie_events_fields_direction: "Direction",
			dashboard_pie_events_fields_action: "Action",
			dashboard_pie_events_fields_type: "Type",
			dashboard_pie_events_fields_state: "State",
			dashboard_pie_events_fields_code: "Code",
			dashboard_pie_events_fields_module: "Module",
			dashboard_pie_events_fields_obs: "Observation",
			dashboard_pie_events_fields_void: "Void",
			dashboard_pie_events_fields_lane_no: "Lane",
			dashboard_pie_events_fields_typeCounter: "Counter type",
			dashboard_pie_events_fields_nameField: "Name field",
			dashboard_pie_events_fields_valueField: "Value field",
			dashboard_pie_events_fields_segment_photo_path: "Segment photo path",
			dashboard_pie_events_fields_segment_photo_url: "Segment photo URL",
			dashboard_pie_events_fields_full_photo_path: "Full photo path",
			dashboard_pie_events_fields_full_photo_url: "Full photo URL",
			dashboard_pie_events_fields_face_detected_path: "Detected face path",
			dashboard_pie_events_fields_face_detected_url: "Detected face URL",
		}),
	],
});
ml.change = function (lang) {
	this.current = lang; // Cambia el idioma actual
	localStorage.setItem("ml-lang", lang); // Guarda la preferencia en localStorage
	window.location.reload(); // Recarga la página para aplicar el cambio
};

export default ml;
